let pokemon = {}

pokemon.pokemonInfo = [
    {
        "name": "Absol",
        "level": [
            {
                "level": 1,
                "hp": 3000,
                "attack": 140,
                "defense": 52,
                "sp_attack": 20,
                "sp_defense": 36,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3650
            },
            {
                "level": 2,
                "hp": 3107,
                "attack": 159,
                "defense": 59,
                "sp_attack": 23,
                "sp_defense": 41,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.71,
                "move_speed": 3650
            },
            {
                "level": 3,
                "hp": 3224,
                "attack": 180,
                "defense": 67,
                "sp_attack": 27,
                "sp_defense": 47,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 11.49,
                "move_speed": 3650
            },
            {
                "level": 4,
                "hp": 3353,
                "attack": 203,
                "defense": 76,
                "sp_attack": 31,
                "sp_defense": 53,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 12.35,
                "move_speed": 3650
            },
            {
                "level": 5,
                "hp": 3495,
                "attack": 228,
                "defense": 86,
                "sp_attack": 36,
                "sp_defense": 60,
                "crit": 5,
                "cdr": 10,
                "lifesteal": 5,
                "attack_speed": 13.29,
                "move_speed": 3800
            },
            {
                "level": 6,
                "hp": 3651,
                "attack": 256,
                "defense": 97,
                "sp_attack": 41,
                "sp_defense": 68,
                "crit": 5,
                "cdr": 10,
                "lifesteal": 5,
                "attack_speed": 14.33,
                "move_speed": 3800
            },
            {
                "level": 7,
                "hp": 3823,
                "attack": 286,
                "defense": 109,
                "sp_attack": 47,
                "sp_defense": 76,
                "crit": 5,
                "cdr": 10,
                "lifesteal": 5,
                "attack_speed": 15.48,
                "move_speed": 3950
            },
            {
                "level": 8,
                "hp": 4012,
                "attack": 319,
                "defense": 122,
                "sp_attack": 53,
                "sp_defense": 85,
                "crit": 5,
                "cdr": 10,
                "lifesteal": 5,
                "attack_speed": 16.74,
                "move_speed": 3950
            },
            {
                "level": 9,
                "hp": 4221,
                "attack": 356,
                "defense": 136,
                "sp_attack": 60,
                "sp_defense": 95,
                "crit": 10,
                "cdr": 20,
                "lifesteal": 10,
                "attack_speed": 18.13,
                "move_speed": 4100
            },
            {
                "level": 10,
                "hp": 4451,
                "attack": 397,
                "defense": 152,
                "sp_attack": 68,
                "sp_defense": 106,
                "crit": 10,
                "cdr": 20,
                "lifesteal": 10,
                "attack_speed": 19.66,
                "move_speed": 4100
            },
            {
                "level": 11,
                "hp": 4704,
                "attack": 442,
                "defense": 170,
                "sp_attack": 76,
                "sp_defense": 118,
                "crit": 10,
                "cdr": 20,
                "lifesteal": 10,
                "attack_speed": 21.35,
                "move_speed": 4250
            },
            {
                "level": 12,
                "hp": 4983,
                "attack": 491,
                "defense": 189,
                "sp_attack": 85,
                "sp_defense": 131,
                "crit": 10,
                "cdr": 20,
                "lifesteal": 10,
                "attack_speed": 23.21,
                "move_speed": 4250
            },
            {
                "level": 13,
                "hp": 5290,
                "attack": 545,
                "defense": 210,
                "sp_attack": 95,
                "sp_defense": 146,
                "crit": 10,
                "cdr": 20,
                "lifesteal": 10,
                "attack_speed": 25.26,
                "move_speed": 4250
            },
            {
                "level": 14,
                "hp": 5628,
                "attack": 605,
                "defense": 233,
                "sp_attack": 106,
                "sp_defense": 162,
                "crit": 10,
                "cdr": 20,
                "lifesteal": 10,
                "attack_speed": 27.51,
                "move_speed": 4250
            },
            {
                "level": 15,
                "hp": 6000,
                "attack": 670,
                "defense": 259,
                "sp_attack": 118,
                "sp_defense": 180,
                "crit": 10,
                "cdr": 20,
                "lifesteal": 10,
                "attack_speed": 29.99,
                "move_speed": 4250
            }
        ]
    },
    {
        "name": "Aegislash",
        "level": [
            {
                "level": 1,
                "hp": 3000,
                "attack": 168,
                "defense": 80,
                "sp_attack": 20,
                "sp_defense": 60,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 15,
                "move_speed": 3600
            },
            {
                "level": 2,
                "hp": 3062,
                "attack": 171,
                "defense": 83,
                "sp_attack": 21,
                "sp_defense": 62,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 15.98,
                "move_speed": 3600
            },
            {
                "level": 3,
                "hp": 3136,
                "attack": 174,
                "defense": 86,
                "sp_attack": 23,
                "sp_defense": 64,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 17.16,
                "move_speed": 3600
            },
            {
                "level": 4,
                "hp": 3225,
                "attack": 178,
                "defense": 90,
                "sp_attack": 25,
                "sp_defense": 67,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 18.57,
                "move_speed": 3600
            },
            {
                "level": 5,
                "hp": 3547,
                "attack": 192,
                "defense": 105,
                "sp_attack": 32,
                "sp_defense": 77,
                "crit": 5,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 21.77,
                "move_speed": 3750
            },
            {
                "level": 6,
                "hp": 3675,
                "attack": 198,
                "defense": 111,
                "sp_attack": 35,
                "sp_defense": 81,
                "crit": 5,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 23.81,
                "move_speed": 3750
            },
            {
                "level": 7,
                "hp": 4259,
                "attack": 223,
                "defense": 138,
                "sp_attack": 48,
                "sp_defense": 100,
                "crit": 5,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 29.25,
                "move_speed": 3900
            },
            {
                "level": 8,
                "hp": 4444,
                "attack": 231,
                "defense": 147,
                "sp_attack": 52,
                "sp_defense": 106,
                "crit": 5,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 35.18,
                "move_speed": 3900
            },
            {
                "level": 9,
                "hp": 4665,
                "attack": 241,
                "defense": 157,
                "sp_attack": 57,
                "sp_defense": 113,
                "crit": 10,
                "cdr": 20,
                "lifesteal": 0,
                "attack_speed": 35.7,
                "move_speed": 4050
            },
            {
                "level": 10,
                "hp": 4931,
                "attack": 253,
                "defense": 169,
                "sp_attack": 63,
                "sp_defense": 122,
                "crit": 10,
                "cdr": 20,
                "lifesteal": 0,
                "attack_speed": 39.92,
                "move_speed": 4050
            },
            {
                "level": 11,
                "hp": 5250,
                "attack": 267,
                "defense": 184,
                "sp_attack": 70,
                "sp_defense": 132,
                "crit": 10,
                "cdr": 20,
                "lifesteal": 0,
                "attack_speed": 44.99,
                "move_speed": 4200
            },
            {
                "level": 12,
                "hp": 5632,
                "attack": 284,
                "defense": 202,
                "sp_attack": 78,
                "sp_defense": 144,
                "crit": 10,
                "cdr": 20,
                "lifesteal": 0,
                "attack_speed": 44.99,
                "move_speed": 4200
            },
            {
                "level": 13,
                "hp": 6091,
                "attack": 304,
                "defense": 223,
                "sp_attack": 88,
                "sp_defense": 159,
                "crit": 10,
                "cdr": 20,
                "lifesteal": 0,
                "attack_speed": 44.99,
                "move_speed": 4200
            },
            {
                "level": 14,
                "hp": 6641,
                "attack": 328,
                "defense": 249,
                "sp_attack": 100,
                "sp_defense": 177,
                "crit": 10,
                "cdr": 20,
                "lifesteal": 0,
                "attack_speed": 44.99,
                "move_speed": 4200
            },
            {
                "level": 15,
                "hp": 7302,
                "attack": 357,
                "defense": 280,
                "sp_attack": 115,
                "sp_defense": 200,
                "crit": 10,
                "cdr": 20,
                "lifesteal": 0,
                "attack_speed": 44.99,
                "move_speed": 4200
            }
        ]
    },
    {
        "name": "Armarouge",
        "level": [
            {
                "level": 1,
                "hp": 3300,
                "attack": 150,
                "defense": 60,
                "sp_attack": 80,
                "sp_defense": 40,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3600
            },
            {
                "level": 2,
                "hp": 3387,
                "attack": 154,
                "defense": 65,
                "sp_attack": 94,
                "sp_defense": 44,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.89,
                "move_speed": 3600
            },
            {
                "level": 3,
                "hp": 3486,
                "attack": 159,
                "defense": 71,
                "sp_attack": 110,
                "sp_defense": 49,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 11.91,
                "move_speed": 3600
            },
            {
                "level": 4,
                "hp": 3600,
                "attack": 165,
                "defense": 78,
                "sp_attack": 128,
                "sp_defense": 55,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 13.08,
                "move_speed": 3750
            },
            {
                "level": 5,
                "hp": 4122,
                "attack": 192,
                "defense": 110,
                "sp_attack": 211,
                "sp_defense": 82,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 18.43,
                "move_speed": 3750
            },
            {
                "level": 6,
                "hp": 4273,
                "attack": 200,
                "defense": 119,
                "sp_attack": 235,
                "sp_defense": 90,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 19.98,
                "move_speed": 3900
            },
            {
                "level": 7,
                "hp": 4447,
                "attack": 209,
                "defense": 130,
                "sp_attack": 263,
                "sp_defense": 99,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 21.76,
                "move_speed": 3900
            },
            {
                "level": 8,
                "hp": 4647,
                "attack": 219,
                "defense": 142,
                "sp_attack": 295,
                "sp_defense": 109,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 23.82,
                "move_speed": 4050
            },
            {
                "level": 9,
                "hp": 4878,
                "attack": 231,
                "defense": 156,
                "sp_attack": 332,
                "sp_defense": 121,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 26.18,
                "move_speed": 4050
            },
            {
                "level": 10,
                "hp": 5143,
                "attack": 244,
                "defense": 172,
                "sp_attack": 374,
                "sp_defense": 134,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 28.9,
                "move_speed": 4200
            },
            {
                "level": 11,
                "hp": 5448,
                "attack": 260,
                "defense": 191,
                "sp_attack": 422,
                "sp_defense": 150,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 32.03,
                "move_speed": 4200
            },
            {
                "level": 12,
                "hp": 5799,
                "attack": 278,
                "defense": 213,
                "sp_attack": 478,
                "sp_defense": 168,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 35.63,
                "move_speed": 4200
            },
            {
                "level": 13,
                "hp": 6203,
                "attack": 299,
                "defense": 238,
                "sp_attack": 542,
                "sp_defense": 189,
                "crit": 0,
                "cdr": 20,
                "lifesteal": 0,
                "attack_speed": 39.77,
                "move_speed": 4200
            },
            {
                "level": 14,
                "hp": 6667,
                "attack": 323,
                "defense": 267,
                "sp_attack": 616,
                "sp_defense": 213,
                "crit": 0,
                "cdr": 20,
                "lifesteal": 0,
                "attack_speed": 44.53,
                "move_speed": 4200
            },
            {
                "level": 15,
                "hp": 7200,
                "attack": 350,
                "defense": 300,
                "sp_attack": 700,
                "sp_defense": 240,
                "crit": 0,
                "cdr": 20,
                "lifesteal": 0,
                "attack_speed": 50,
                "move_speed": 4200
            }
        ]
    },
    {
        "name": "Azumarill",
        "level": [
            {
                "level": 1,
                "hp": 3250,
                "attack": 125,
                "defense": 80,
                "sp_attack": 20,
                "sp_defense": 80,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3600
            },
            {
                "level": 2,
                "hp": 3352,
                "attack": 132,
                "defense": 87,
                "sp_attack": 22,
                "sp_defense": 87,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.67,
                "move_speed": 3600
            },
            {
                "level": 3,
                "hp": 3469,
                "attack": 141,
                "defense": 95,
                "sp_attack": 24,
                "sp_defense": 95,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 11.43,
                "move_speed": 3600
            },
            {
                "level": 4,
                "hp": 4064,
                "attack": 185,
                "defense": 136,
                "sp_attack": 36,
                "sp_defense": 136,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 15.31,
                "move_speed": 3600
            },
            {
                "level": 5,
                "hp": 4219,
                "attack": 196,
                "defense": 147,
                "sp_attack": 40,
                "sp_defense": 147,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 16.32,
                "move_speed": 3750
            },
            {
                "level": 6,
                "hp": 4398,
                "attack": 209,
                "defense": 159,
                "sp_attack": 44,
                "sp_defense": 159,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 17.48,
                "move_speed": 3750
            },
            {
                "level": 7,
                "hp": 4603,
                "attack": 224,
                "defense": 173,
                "sp_attack": 48,
                "sp_defense": 173,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 18.82,
                "move_speed": 3900
            },
            {
                "level": 8,
                "hp": 4839,
                "attack": 241,
                "defense": 189,
                "sp_attack": 53,
                "sp_defense": 189,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 20.36,
                "move_speed": 3900
            },
            {
                "level": 9,
                "hp": 5111,
                "attack": 261,
                "defense": 208,
                "sp_attack": 59,
                "sp_defense": 208,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 22.13,
                "move_speed": 4050
            },
            {
                "level": 10,
                "hp": 5424,
                "attack": 284,
                "defense": 230,
                "sp_attack": 65,
                "sp_defense": 230,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 24.17,
                "move_speed": 4050
            },
            {
                "level": 11,
                "hp": 5784,
                "attack": 310,
                "defense": 255,
                "sp_attack": 72,
                "sp_defense": 255,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 26.52,
                "move_speed": 4200
            },
            {
                "level": 12,
                "hp": 6198,
                "attack": 340,
                "defense": 284,
                "sp_attack": 81,
                "sp_defense": 284,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 29.22,
                "move_speed": 4200
            },
            {
                "level": 13,
                "hp": 6674,
                "attack": 375,
                "defense": 317,
                "sp_attack": 91,
                "sp_defense": 317,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 32.33,
                "move_speed": 4200
            },
            {
                "level": 14,
                "hp": 7221,
                "attack": 415,
                "defense": 355,
                "sp_attack": 102,
                "sp_defense": 355,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 35.9,
                "move_speed": 4200
            },
            {
                "level": 15,
                "hp": 7850,
                "attack": 461,
                "defense": 399,
                "sp_attack": 115,
                "sp_defense": 399,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 40,
                "move_speed": 4200
            }
        ]
    },
    {
        "name": "Blastoise",
        "level": [
            {
                "level": 1,
                "hp": 3225,
                "attack": 150,
                "defense": 100,
                "sp_attack": 50,
                "sp_defense": 70,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3700
            },
            {
                "level": 2,
                "hp": 3319,
                "attack": 152,
                "defense": 108,
                "sp_attack": 55,
                "sp_defense": 75,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.29,
                "move_speed": 3700
            },
            {
                "level": 3,
                "hp": 3432,
                "attack": 154,
                "defense": 117,
                "sp_attack": 61,
                "sp_defense": 82,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.63,
                "move_speed": 3700
            },
            {
                "level": 4,
                "hp": 3568,
                "attack": 157,
                "defense": 128,
                "sp_attack": 68,
                "sp_defense": 90,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 11.04,
                "move_speed": 3700
            },
            {
                "level": 5,
                "hp": 4060,
                "attack": 168,
                "defense": 169,
                "sp_attack": 95,
                "sp_defense": 119,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 12.54,
                "move_speed": 3850
            },
            {
                "level": 6,
                "hp": 4256,
                "attack": 172,
                "defense": 185,
                "sp_attack": 106,
                "sp_defense": 130,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 13.14,
                "move_speed": 3850
            },
            {
                "level": 7,
                "hp": 5148,
                "attack": 191,
                "defense": 205,
                "sp_attack": 155,
                "sp_defense": 144,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 15.86,
                "move_speed": 4000
            },
            {
                "level": 8,
                "hp": 5430,
                "attack": 197,
                "defense": 229,
                "sp_attack": 171,
                "sp_defense": 160,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 16.72,
                "move_speed": 4000
            },
            {
                "level": 9,
                "hp": 5769,
                "attack": 204,
                "defense": 312,
                "sp_attack": 190,
                "sp_defense": 218,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 17.75,
                "move_speed": 4150
            },
            {
                "level": 10,
                "hp": 6175,
                "attack": 213,
                "defense": 346,
                "sp_attack": 212,
                "sp_defense": 242,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 18.98,
                "move_speed": 4150
            },
            {
                "level": 11,
                "hp": 6662,
                "attack": 224,
                "defense": 387,
                "sp_attack": 239,
                "sp_defense": 271,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 20.46,
                "move_speed": 4300
            },
            {
                "level": 12,
                "hp": 7247,
                "attack": 237,
                "defense": 436,
                "sp_attack": 271,
                "sp_defense": 305,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 22.24,
                "move_speed": 4300
            },
            {
                "level": 13,
                "hp": 7948,
                "attack": 252,
                "defense": 495,
                "sp_attack": 310,
                "sp_defense": 346,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 24.37,
                "move_speed": 4300
            },
            {
                "level": 14,
                "hp": 8790,
                "attack": 270,
                "defense": 565,
                "sp_attack": 356,
                "sp_defense": 395,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 26.93,
                "move_speed": 4300
            },
            {
                "level": 15,
                "hp": 9800,
                "attack": 292,
                "defense": 650,
                "sp_attack": 412,
                "sp_defense": 455,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 30,
                "move_speed": 4300
            }
        ]
    },
    {
        "name": "Blaziken",
        "level": [
            {
                "level": 1,
                "hp": 3250,
                "attack": 160,
                "defense": 80,
                "sp_attack": 20,
                "sp_defense": 60,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3700
            },
            {
                "level": 2,
                "hp": 3315,
                "attack": 165,
                "defense": 85,
                "sp_attack": 21,
                "sp_defense": 64,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.29,
                "move_speed": 3700
            },
            {
                "level": 3,
                "hp": 3393,
                "attack": 171,
                "defense": 92,
                "sp_attack": 23,
                "sp_defense": 69,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.63,
                "move_speed": 3700
            },
            {
                "level": 4,
                "hp": 3487,
                "attack": 178,
                "defense": 100,
                "sp_attack": 25,
                "sp_defense": 75,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 11.04,
                "move_speed": 3700
            },
            {
                "level": 5,
                "hp": 3827,
                "attack": 203,
                "defense": 128,
                "sp_attack": 32,
                "sp_defense": 97,
                "crit": 5,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 12.54,
                "move_speed": 3850
            },
            {
                "level": 6,
                "hp": 3963,
                "attack": 213,
                "defense": 139,
                "sp_attack": 35,
                "sp_defense": 106,
                "crit": 5,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 13.14,
                "move_speed": 3850
            },
            {
                "level": 7,
                "hp": 4581,
                "attack": 258,
                "defense": 190,
                "sp_attack": 48,
                "sp_defense": 145,
                "crit": 5,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 15.86,
                "move_speed": 4000
            },
            {
                "level": 8,
                "hp": 4776,
                "attack": 272,
                "defense": 206,
                "sp_attack": 52,
                "sp_defense": 157,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 16.72,
                "move_speed": 4000
            },
            {
                "level": 9,
                "hp": 5010,
                "attack": 289,
                "defense": 226,
                "sp_attack": 57,
                "sp_defense": 172,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 17.75,
                "move_speed": 4150
            },
            {
                "level": 10,
                "hp": 5291,
                "attack": 309,
                "defense": 249,
                "sp_attack": 63,
                "sp_defense": 190,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 18.98,
                "move_speed": 4150
            },
            {
                "level": 11,
                "hp": 5628,
                "attack": 333,
                "defense": 277,
                "sp_attack": 70,
                "sp_defense": 212,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 20.46,
                "move_speed": 4300
            },
            {
                "level": 12,
                "hp": 6033,
                "attack": 362,
                "defense": 311,
                "sp_attack": 78,
                "sp_defense": 238,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 22.24,
                "move_speed": 4300
            },
            {
                "level": 13,
                "hp": 6518,
                "attack": 397,
                "defense": 351,
                "sp_attack": 88,
                "sp_defense": 269,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 24.37,
                "move_speed": 4300
            },
            {
                "level": 14,
                "hp": 7101,
                "attack": 439,
                "defense": 400,
                "sp_attack": 100,
                "sp_defense": 306,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 26.93,
                "move_speed": 4300
            },
            {
                "level": 15,
                "hp": 7800,
                "attack": 490,
                "defense": 458,
                "sp_attack": 115,
                "sp_defense": 351,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 30,
                "move_speed": 4300
            }
        ]
    },
    {
        "name": "Blissey",
        "level": [
            {
                "level": 1,
                "hp": 3278,
                "attack": 130,
                "defense": 40,
                "sp_attack": 40,
                "sp_defense": 60,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3700
            },
            {
                "level": 2,
                "hp": 3427,
                "attack": 134,
                "defense": 44,
                "sp_attack": 52,
                "sp_defense": 65,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.22,
                "move_speed": 3700
            },
            {
                "level": 3,
                "hp": 3598,
                "attack": 139,
                "defense": 48,
                "sp_attack": 66,
                "sp_defense": 71,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.47,
                "move_speed": 3700
            },
            {
                "level": 4,
                "hp": 4467,
                "attack": 162,
                "defense": 69,
                "sp_attack": 138,
                "sp_defense": 102,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 11.76,
                "move_speed": 3700
            },
            {
                "level": 5,
                "hp": 4694,
                "attack": 168,
                "defense": 74,
                "sp_attack": 157,
                "sp_defense": 110,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 12.1,
                "move_speed": 3850
            },
            {
                "level": 6,
                "hp": 4955,
                "attack": 175,
                "defense": 80,
                "sp_attack": 179,
                "sp_defense": 119,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 12.49,
                "move_speed": 3850
            },
            {
                "level": 7,
                "hp": 5255,
                "attack": 183,
                "defense": 87,
                "sp_attack": 204,
                "sp_defense": 130,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 12.94,
                "move_speed": 4000
            },
            {
                "level": 8,
                "hp": 5600,
                "attack": 192,
                "defense": 95,
                "sp_attack": 233,
                "sp_defense": 142,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 13.45,
                "move_speed": 4000
            },
            {
                "level": 9,
                "hp": 5997,
                "attack": 203,
                "defense": 104,
                "sp_attack": 266,
                "sp_defense": 156,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 14.04,
                "move_speed": 4150
            },
            {
                "level": 10,
                "hp": 6454,
                "attack": 215,
                "defense": 115,
                "sp_attack": 304,
                "sp_defense": 172,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 14.72,
                "move_speed": 4150
            },
            {
                "level": 11,
                "hp": 6980,
                "attack": 229,
                "defense": 128,
                "sp_attack": 348,
                "sp_defense": 191,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 15.5,
                "move_speed": 4300
            },
            {
                "level": 12,
                "hp": 7585,
                "attack": 245,
                "defense": 142,
                "sp_attack": 398,
                "sp_defense": 213,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 16.4,
                "move_speed": 4300
            },
            {
                "level": 13,
                "hp": 8281,
                "attack": 264,
                "defense": 159,
                "sp_attack": 456,
                "sp_defense": 238,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 17.43,
                "move_speed": 4300
            },
            {
                "level": 14,
                "hp": 9081,
                "attack": 285,
                "defense": 178,
                "sp_attack": 523,
                "sp_defense": 267,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 18.62,
                "move_speed": 4300
            },
            {
                "level": 15,
                "hp": 10000,
                "attack": 310,
                "defense": 200,
                "sp_attack": 600,
                "sp_defense": 300,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 19.99,
                "move_speed": 4300
            }
        ]
    },
    {
        "name": "Buzzwole",
        "level": [
            {
                "level": 1,
                "hp": 3250,
                "attack": 170,
                "defense": 120,
                "sp_attack": 20,
                "sp_defense": 80,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": "10.00",
                "move_speed": 3700
            },
            {
                "level": 2,
                "hp": 3412,
                "attack": 180,
                "defense": 134,
                "sp_attack": 23,
                "sp_defense": 91,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": "10.71",
                "move_speed": 3700
            },
            {
                "level": 3,
                "hp": 3590,
                "attack": 191,
                "defense": 149,
                "sp_attack": 27,
                "sp_defense": 103,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": "11.49",
                "move_speed": 3700
            },
            {
                "level": 4,
                "hp": 3786,
                "attack": 203,
                "defense": 165,
                "sp_attack": 31,
                "sp_defense": 116,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": "12.35",
                "move_speed": 3700
            },
            {
                "level": 5,
                "hp": 4001,
                "attack": 216,
                "defense": 183,
                "sp_attack": 35,
                "sp_defense": 130,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": "13.29",
                "move_speed": 3850
            },
            {
                "level": 6,
                "hp": 4238,
                "attack": 231,
                "defense": 203,
                "sp_attack": 40,
                "sp_defense": 146,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": "14.33",
                "move_speed": 3850
            },
            {
                "level": 7,
                "hp": 4499,
                "attack": 247,
                "defense": 225,
                "sp_attack": 45,
                "sp_defense": 163,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": "15.48",
                "move_speed": 4000
            },
            {
                "level": 8,
                "hp": 4786,
                "attack": 265,
                "defense": 249,
                "sp_attack": 51,
                "sp_defense": 182,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": "16.74",
                "move_speed": 4000
            },
            {
                "level": 9,
                "hp": 5103,
                "attack": 285,
                "defense": 275,
                "sp_attack": 58,
                "sp_defense": 203,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": "18.13",
                "move_speed": 4150
            },
            {
                "level": 10,
                "hp": 5452,
                "attack": 306,
                "defense": 304,
                "sp_attack": 65,
                "sp_defense": 226,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": "19.66",
                "move_speed": 4150
            },
            {
                "level": 11,
                "hp": 5836,
                "attack": 330,
                "defense": 336,
                "sp_attack": 73,
                "sp_defense": 251,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": "21.35",
                "move_speed": 4300
            },
            {
                "level": 12,
                "hp": 6259,
                "attack": 356,
                "defense": 371,
                "sp_attack": 82,
                "sp_defense": 279,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": "23.21",
                "move_speed": 4300
            },
            {
                "level": 13,
                "hp": 6724,
                "attack": 385,
                "defense": 410,
                "sp_attack": 92,
                "sp_defense": 309,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": "25.26",
                "move_speed": 4300
            },
            {
                "level": 14,
                "hp": 7236,
                "attack": 417,
                "defense": 453,
                "sp_attack": 103,
                "sp_defense": 343,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": "27.51",
                "move_speed": 4300
            },
            {
                "level": 15,
                "hp": 7800,
                "attack": 452,
                "defense": 500,
                "sp_attack": 115,
                "sp_defense": 380,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": "29.99",
                "move_speed": 4300
            }
        ]
    },
    {
        "name": "Ceruledge",
        "level": [
            {
                "level": 1,
                "hp": 3250,
                "attack": 125,
                "defense": 80,
                "sp_attack": 20,
                "sp_defense": 64,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3700
            },
            {
                "level": 2,
                "hp": 3352,
                "attack": 132,
                "defense": 85,
                "sp_attack": 22,
                "sp_defense": 71,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.89,
                "move_speed": 3700
            },
            {
                "level": 3,
                "hp": 3469,
                "attack": 140,
                "defense": 91,
                "sp_attack": 24,
                "sp_defense": 79,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 11.91,
                "move_speed": 3700
            },
            {
                "level": 4,
                "hp": 3604,
                "attack": 149,
                "defense": 98,
                "sp_attack": 27,
                "sp_defense": 88,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 13.08,
                "move_speed": 3700
            },
            {
                "level": 5,
                "hp": 4219,
                "attack": 190,
                "defense": 130,
                "sp_attack": 40,
                "sp_defense": 130,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 18.43,
                "move_speed": 3850
            },
            {
                "level": 6,
                "hp": 4398,
                "attack": 202,
                "defense": 139,
                "sp_attack": 44,
                "sp_defense": 142,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 19.98,
                "move_speed": 3850
            },
            {
                "level": 7,
                "hp": 4603,
                "attack": 216,
                "defense": 150,
                "sp_attack": 48,
                "sp_defense": 156,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 21.76,
                "move_speed": 4000
            },
            {
                "level": 8,
                "hp": 4839,
                "attack": 232,
                "defense": 162,
                "sp_attack": 53,
                "sp_defense": 172,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 23.82,
                "move_speed": 4000
            },
            {
                "level": 9,
                "hp": 5111,
                "attack": 250,
                "defense": 176,
                "sp_attack": 59,
                "sp_defense": 191,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 26.18,
                "move_speed": 4150
            },
            {
                "level": 10,
                "hp": 5424,
                "attack": 271,
                "defense": 192,
                "sp_attack": 66,
                "sp_defense": 213,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 28.9,
                "move_speed": 4150
            },
            {
                "level": 11,
                "hp": 5784,
                "attack": 295,
                "defense": 211,
                "sp_attack": 73,
                "sp_defense": 238,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 32.03,
                "move_speed": 4300
            },
            {
                "level": 12,
                "hp": 6198,
                "attack": 322,
                "defense": 233,
                "sp_attack": 82,
                "sp_defense": 266,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 35.63,
                "move_speed": 4300
            },
            {
                "level": 13,
                "hp": 6674,
                "attack": 353,
                "defense": 258,
                "sp_attack": 92,
                "sp_defense": 299,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 39.77,
                "move_speed": 4300
            },
            {
                "level": 14,
                "hp": 7221,
                "attack": 389,
                "defense": 287,
                "sp_attack": 103,
                "sp_defense": 337,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 44.53,
                "move_speed": 4300
            },
            {
                "level": 15,
                "hp": 7850,
                "attack": 430,
                "defense": 320,
                "sp_attack": 116,
                "sp_defense": 380,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 50,
                "move_speed": 4300
            }
        ]
    },
    {
        "name": "Charizard",
        "level": [
            {
                "level": 1,
                "hp": 3200,
                "attack": 161,
                "defense": 70,
                "sp_attack": 20,
                "sp_defense": 54,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 0,
                "move_speed": 3700
            },
            {
                "level": 2,
                "hp": 3264,
                "attack": 165,
                "defense": 74,
                "sp_attack": 21,
                "sp_defense": 57,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 0,
                "move_speed": 3700
            },
            {
                "level": 3,
                "hp": 3341,
                "attack": 170,
                "defense": 79,
                "sp_attack": 23,
                "sp_defense": 61,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 0,
                "move_speed": 3700
            },
            {
                "level": 4,
                "hp": 3434,
                "attack": 176,
                "defense": 85,
                "sp_attack": 25,
                "sp_defense": 65,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 0,
                "move_speed": 3700
            },
            {
                "level": 5,
                "hp": 3771,
                "attack": 199,
                "defense": 106,
                "sp_attack": 32,
                "sp_defense": 81,
                "crit": 15,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 0,
                "move_speed": 3850
            },
            {
                "level": 6,
                "hp": 3905,
                "attack": 208,
                "defense": 114,
                "sp_attack": 35,
                "sp_defense": 87,
                "crit": 15,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 0,
                "move_speed": 3850
            },
            {
                "level": 7,
                "hp": 4516,
                "attack": 249,
                "defense": 152,
                "sp_attack": 48,
                "sp_defense": 116,
                "crit": 15,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 0,
                "move_speed": 4000
            },
            {
                "level": 8,
                "hp": 4709,
                "attack": 262,
                "defense": 164,
                "sp_attack": 52,
                "sp_defense": 125,
                "crit": 15,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 0,
                "move_speed": 4000
            },
            {
                "level": 9,
                "hp": 4941,
                "attack": 277,
                "defense": 178,
                "sp_attack": 57,
                "sp_defense": 136,
                "crit": 30,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 0,
                "move_speed": 4150
            },
            {
                "level": 10,
                "hp": 5219,
                "attack": 296,
                "defense": 195,
                "sp_attack": 63,
                "sp_defense": 149,
                "crit": 30,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 0,
                "move_speed": 4150
            },
            {
                "level": 11,
                "hp": 5553,
                "attack": 318,
                "defense": 216,
                "sp_attack": 70,
                "sp_defense": 165,
                "crit": 30,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 0,
                "move_speed": 4300
            },
            {
                "level": 12,
                "hp": 5953,
                "attack": 345,
                "defense": 241,
                "sp_attack": 78,
                "sp_defense": 184,
                "crit": 30,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 0,
                "move_speed": 4300
            },
            {
                "level": 13,
                "hp": 6433,
                "attack": 377,
                "defense": 271,
                "sp_attack": 88,
                "sp_defense": 207,
                "crit": 30,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 0,
                "move_speed": 4300
            },
            {
                "level": 14,
                "hp": 7009,
                "attack": 416,
                "defense": 307,
                "sp_attack": 100,
                "sp_defense": 235,
                "crit": 30,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 0,
                "move_speed": 4300
            },
            {
                "level": 15,
                "hp": 7700,
                "attack": 462,
                "defense": 350,
                "sp_attack": 115,
                "sp_defense": 268,
                "crit": 30,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 0,
                "move_speed": 4300
            }
        ]
    },
    {
        "name": "Chandelure",
        "level": [
            {
                "level": 1,
                "hp": 3200,
                "attack": 135,
                "defense": 35,
                "sp_attack": 50,
                "sp_defense": 30,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3700
            },
            {
                "level": 2,
                "hp": 3244,
                "attack": 137,
                "defense": 37,
                "sp_attack": 64,
                "sp_defense": 32,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.29,
                "move_speed": 3700
            },
            {
                "level": 3,
                "hp": 3297,
                "attack": 140,
                "defense": 40,
                "sp_attack": 80,
                "sp_defense": 35,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.63,
                "move_speed": 3700
            },
            {
                "level": 4,
                "hp": 3361,
                "attack": 143,
                "defense": 43,
                "sp_attack": 100,
                "sp_defense": 39,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 11.04,
                "move_speed": 3700
            },
            {
                "level": 5,
                "hp": 3593,
                "attack": 155,
                "defense": 55,
                "sp_attack": 171,
                "sp_defense": 52,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 12.54,
                "move_speed": 3850
            },
            {
                "level": 6,
                "hp": 3685,
                "attack": 160,
                "defense": 60,
                "sp_attack": 199,
                "sp_defense": 57,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 13.14,
                "move_speed": 3850
            },
            {
                "level": 7,
                "hp": 4106,
                "attack": 181,
                "defense": 82,
                "sp_attack": 328,
                "sp_defense": 80,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 15.86,
                "move_speed": 4000
            },
            {
                "level": 8,
                "hp": 4239,
                "attack": 188,
                "defense": 89,
                "sp_attack": 369,
                "sp_defense": 87,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 16.72,
                "move_speed": 4000
            },
            {
                "level": 9,
                "hp": 4399,
                "attack": 196,
                "defense": 97,
                "sp_attack": 418,
                "sp_defense": 96,
                "crit": 0,
                "cdr": 15,
                "lifesteal": 0,
                "attack_speed": 17.75,
                "move_speed": 4150
            },
            {
                "level": 10,
                "hp": 4591,
                "attack": 206,
                "defense": 107,
                "sp_attack": 477,
                "sp_defense": 107,
                "crit": 0,
                "cdr": 15,
                "lifesteal": 0,
                "attack_speed": 18.98,
                "move_speed": 4150
            },
            {
                "level": 11,
                "hp": 4821,
                "attack": 218,
                "defense": 119,
                "sp_attack": 548,
                "sp_defense": 120,
                "crit": 0,
                "cdr": 15,
                "lifesteal": 0,
                "attack_speed": 20.46,
                "move_speed": 4300
            },
            {
                "level": 12,
                "hp": 5097,
                "attack": 232,
                "defense": 124,
                "sp_attack": 633,
                "sp_defense": 135,
                "crit": 0,
                "cdr": 15,
                "lifesteal": 0,
                "attack_speed": 22.24,
                "move_speed": 4300
            },
            {
                "level": 13,
                "hp": 5428,
                "attack": 249,
                "defense": 152,
                "sp_attack": 735,
                "sp_defense": 153,
                "crit": 0,
                "cdr": 25,
                "lifesteal": 0,
                "attack_speed": 24.37,
                "move_speed": 4300
            },
            {
                "level": 14,
                "hp": 5825,
                "attack": 269,
                "defense": 173,
                "sp_attack": 857,
                "sp_defense": 175,
                "crit": 0,
                "cdr": 25,
                "lifesteal": 0,
                "attack_speed": 26.93,
                "move_speed": 4300
            },
            {
                "level": 15,
                "hp": 6300,
                "attack": 295,
                "defense": 200,
                "sp_attack": 1005,
                "sp_defense": 203,
                "crit": 0,
                "cdr": 25,
                "lifesteal": 0,
                "attack_speed": 30,
                "move_speed": 4300
            }
        ]
    },
    {
        "name": "Cinderace",
        "level": [
            {
                "level": 1,
                "hp": 3000,
                "attack": 135,
                "defense": 50,
                "sp_attack": 20,
                "sp_defense": 30,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3650
            },
            {
                "level": 2,
                "hp": 3034,
                "attack": 140,
                "defense": 53,
                "sp_attack": 21,
                "sp_defense": 33,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 11.87,
                "move_speed": 3650
            },
            {
                "level": 3,
                "hp": 3075,
                "attack": 145,
                "defense": 57,
                "sp_attack": 23,
                "sp_defense": 36,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 14.11,
                "move_speed": 3650
            },
            {
                "level": 4,
                "hp": 3125,
                "attack": 151,
                "defense": 62,
                "sp_attack": 25,
                "sp_defense": 40,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 16.8,
                "move_speed": 3650
            },
            {
                "level": 5,
                "hp": 3305,
                "attack": 174,
                "defense": 78,
                "sp_attack": 32,
                "sp_defense": 55,
                "crit": 15,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 26.53,
                "move_speed": 3800
            },
            {
                "level": 6,
                "hp": 3376,
                "attack": 183,
                "defense": 84,
                "sp_attack": 35,
                "sp_defense": 61,
                "crit": 15,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 30.4,
                "move_speed": 3800
            },
            {
                "level": 7,
                "hp": 3702,
                "attack": 221,
                "defense": 114,
                "sp_attack": 49,
                "sp_defense": 88,
                "crit": 15,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 48.04,
                "move_speed": 3950
            },
            {
                "level": 8,
                "hp": 3805,
                "attack": 233,
                "defense": 123,
                "sp_attack": 53,
                "sp_defense": 97,
                "crit": 15,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 53.61,
                "move_speed": 3950
            },
            {
                "level": 9,
                "hp": 3928,
                "attack": 247,
                "defense": 134,
                "sp_attack": 58,
                "sp_defense": 107,
                "crit": 30,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 60.3,
                "move_speed": 4100
            },
            {
                "level": 10,
                "hp": 4076,
                "attack": 264,
                "defense": 147,
                "sp_attack": 64,
                "sp_defense": 119,
                "crit": 30,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 68.33,
                "move_speed": 4100
            },
            {
                "level": 11,
                "hp": 4254,
                "attack": 284,
                "defense": 163,
                "sp_attack": 71,
                "sp_defense": 134,
                "crit": 30,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 77.96,
                "move_speed": 4250
            },
            {
                "level": 12,
                "hp": 4467,
                "attack": 309,
                "defense": 182,
                "sp_attack": 80,
                "sp_defense": 152,
                "crit": 30,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 89.52,
                "move_speed": 4250
            },
            {
                "level": 13,
                "hp": 4723,
                "attack": 339,
                "defense": 206,
                "sp_attack": 91,
                "sp_defense": 175,
                "crit": 30,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 103.39,
                "move_speed": 4250
            },
            {
                "level": 14,
                "hp": 5030,
                "attack": 375,
                "defense": 235,
                "sp_attack": 104,
                "sp_defense": 201,
                "crit": 30,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 120.03,
                "move_speed": 4250
            },
            {
                "level": 15,
                "hp": 5399,
                "attack": 418,
                "defense": 268,
                "sp_attack": 119,
                "sp_defense": 232,
                "crit": 30,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 140,
                "move_speed": 4250
            }
        ]
    },
    {
        "name": "Clefable",
        "level": [
            {
                "level": 1,
                "hp": 3300,
                "attack": 130,
                "defense": 40,
                "sp_attack": 40,
                "sp_defense": 30,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3700
            },
            {
                "level": 2,
                "hp": 3404,
                "attack": 134,
                "defense": 45,
                "sp_attack": 54,
                "sp_defense": 34,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.22,
                "move_speed": 3700
            },
            {
                "level": 3,
                "hp": 3524,
                "attack": 138,
                "defense": 51,
                "sp_attack": 70,
                "sp_defense": 38,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.47,
                "move_speed": 3700
            },
            {
                "level": 4,
                "hp": 4132,
                "attack": 160,
                "defense": 79,
                "sp_attack": 152,
                "sp_defense": 60,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 11.76,
                "move_speed": 3700
            },
            {
                "level": 5,
                "hp": 4291,
                "attack": 166,
                "defense": 86,
                "sp_attack": 173,
                "sp_defense": 66,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 12.1,
                "move_speed": 3850
            },
            {
                "level": 6,
                "hp": 4473,
                "attack": 173,
                "defense": 95,
                "sp_attack": 198,
                "sp_defense": 73,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 12.49,
                "move_speed": 3850
            },
            {
                "level": 7,
                "hp": 4683,
                "attack": 181,
                "defense": 105,
                "sp_attack": 226,
                "sp_defense": 81,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 12.94,
                "move_speed": 4000
            },
            {
                "level": 8,
                "hp": 4924,
                "attack": 190,
                "defense": 116,
                "sp_attack": 258,
                "sp_defense": 90,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 13.45,
                "move_speed": 4000
            },
            {
                "level": 9,
                "hp": 5202,
                "attack": 200,
                "defense": 129,
                "sp_attack": 295,
                "sp_defense": 100,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 14.04,
                "move_speed": 4150
            },
            {
                "level": 10,
                "hp": 5521,
                "attack": 211,
                "defense": 144,
                "sp_attack": 338,
                "sp_defense": 111,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 14.72,
                "move_speed": 4150
            },
            {
                "level": 11,
                "hp": 5889,
                "attack": 224,
                "defense": 161,
                "sp_attack": 387,
                "sp_defense": 124,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 15.5,
                "move_speed": 4300
            },
            {
                "level": 12,
                "hp": 6312,
                "attack": 239,
                "defense": 181,
                "sp_attack": 444,
                "sp_defense": 139,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 16.4,
                "move_speed": 4300
            },
            {
                "level": 13,
                "hp": 6798,
                "attack": 257,
                "defense": 204,
                "sp_attack": 509,
                "sp_defense": 157,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 17.44,
                "move_speed": 4300
            },
            {
                "level": 14,
                "hp": 7357,
                "attack": 277,
                "defense": 230,
                "sp_attack": 584,
                "sp_defense": 177,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 18.63,
                "move_speed": 4300
            },
            {
                "level": 15,
                "hp": 8000,
                "attack": 300,
                "defense": 260,
                "sp_attack": 670,
                "sp_defense": 200,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 20,
                "move_speed": 4300
            }
        ]
    },
    {
        "name": "Comfey",
        "level": [
            {
                "level": 1,
                "hp": 3000,
                "attack": 120,
                "defense": 40,
                "sp_attack": 50,
                "sp_defense": 30,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3700
            },
            {
                "level": 2,
                "hp": 3089,
                "attack": 126,
                "defense": 45,
                "sp_attack": 71,
                "sp_defense": 35,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.36,
                "move_speed": 3700
            },
            {
                "level": 3,
                "hp": 3187,
                "attack": 133,
                "defense": 51,
                "sp_attack": 95,
                "sp_defense": 40,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.75,
                "move_speed": 3700
            },
            {
                "level": 4,
                "hp": 3295,
                "attack": 140,
                "defense": 57,
                "sp_attack": 121,
                "sp_defense": 46,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 11.18,
                "move_speed": 3700
            },
            {
                "level": 5,
                "hp": 3413,
                "attack": 148,
                "defense": 64,
                "sp_attack": 149,
                "sp_defense": 52,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 11.65,
                "move_speed": 3850
            },
            {
                "level": 6,
                "hp": 3543,
                "attack": 157,
                "defense": 72,
                "sp_attack": 180,
                "sp_defense": 59,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 12.17,
                "move_speed": 3850
            },
            {
                "level": 7,
                "hp": 3686,
                "attack": 167,
                "defense": 81,
                "sp_attack": 214,
                "sp_defense": 66,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 12.74,
                "move_speed": 4000
            },
            {
                "level": 8,
                "hp": 3844,
                "attack": 178,
                "defense": 90,
                "sp_attack": 252,
                "sp_defense": 74,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 13.37,
                "move_speed": 4000
            },
            {
                "level": 9,
                "hp": 4018,
                "attack": 190,
                "defense": 100,
                "sp_attack": 294,
                "sp_defense": 83,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 14.07,
                "move_speed": 4150
            },
            {
                "level": 10,
                "hp": 4210,
                "attack": 203,
                "defense": 112,
                "sp_attack": 340,
                "sp_defense": 93,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 14.84,
                "move_speed": 4150
            },
            {
                "level": 11,
                "hp": 4421,
                "attack": 217,
                "defense": 125,
                "sp_attack": 391,
                "sp_defense": 104,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 15.68,
                "move_speed": 4300
            },
            {
                "level": 12,
                "hp": 4653,
                "attack": 233,
                "defense": 139,
                "sp_attack": 447,
                "sp_defense": 116,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 16.61,
                "move_speed": 4300
            },
            {
                "level": 13,
                "hp": 4909,
                "attack": 250,
                "defense": 154,
                "sp_attack": 508,
                "sp_defense": 129,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 17.63,
                "move_speed": 4300
            },
            {
                "level": 14,
                "hp": 5190,
                "attack": 269,
                "defense": 171,
                "sp_attack": 576,
                "sp_defense": 144,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 18.76,
                "move_speed": 4300
            },
            {
                "level": 15,
                "hp": 5500,
                "attack": 290,
                "defense": 190,
                "sp_attack": 650,
                "sp_defense": 160,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 20,
                "move_speed": 4300
            }
        ]
    },
    {
        "name": "Cramorant",
        "level": [
            {
                "level": 1,
                "hp": 3292,
                "attack": 134,
                "defense": 60,
                "sp_attack": 50,
                "sp_defense": 40,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3700
            },
            {
                "level": 2,
                "hp": 3399,
                "attack": 139,
                "defense": 69,
                "sp_attack": 75,
                "sp_defense": 46,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 11.78,
                "move_speed": 3700
            },
            {
                "level": 3,
                "hp": 3517,
                "attack": 145,
                "defense": 78,
                "sp_attack": 102,
                "sp_defense": 52,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 13.74,
                "move_speed": 3700
            },
            {
                "level": 4,
                "hp": 3647,
                "attack": 151,
                "defense": 88,
                "sp_attack": 132,
                "sp_defense": 59,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 15.89,
                "move_speed": 3700
            },
            {
                "level": 5,
                "hp": 3789,
                "attack": 158,
                "defense": 99,
                "sp_attack": 165,
                "sp_defense": 67,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 18.25,
                "move_speed": 3850
            },
            {
                "level": 6,
                "hp": 3946,
                "attack": 166,
                "defense": 112,
                "sp_attack": 201,
                "sp_defense": 75,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 20.86,
                "move_speed": 3850
            },
            {
                "level": 7,
                "hp": 4118,
                "attack": 175,
                "defense": 126,
                "sp_attack": 240,
                "sp_defense": 84,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 23.72,
                "move_speed": 4000
            },
            {
                "level": 8,
                "hp": 4308,
                "attack": 185,
                "defense": 141,
                "sp_attack": 283,
                "sp_defense": 94,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 26.88,
                "move_speed": 4000
            },
            {
                "level": 9,
                "hp": 4517,
                "attack": 196,
                "defense": 158,
                "sp_attack": 331,
                "sp_defense": 105,
                "crit": 0,
                "cdr": 15,
                "lifesteal": 0,
                "attack_speed": 30.36,
                "move_speed": 4150
            },
            {
                "level": 10,
                "hp": 4748,
                "attack": 208,
                "defense": 176,
                "sp_attack": 384,
                "sp_defense": 117,
                "crit": 0,
                "cdr": 15,
                "lifesteal": 0,
                "attack_speed": 34.19,
                "move_speed": 4150
            },
            {
                "level": 11,
                "hp": 5002,
                "attack": 221,
                "defense": 196,
                "sp_attack": 442,
                "sp_defense": 131,
                "crit": 0,
                "cdr": 15,
                "lifesteal": 0,
                "attack_speed": 38.41,
                "move_speed": 4300
            },
            {
                "level": 12,
                "hp": 5281,
                "attack": 235,
                "defense": 218,
                "sp_attack": 506,
                "sp_defense": 146,
                "crit": 0,
                "cdr": 15,
                "lifesteal": 0,
                "attack_speed": 43.05,
                "move_speed": 4300
            },
            {
                "level": 13,
                "hp": 5589,
                "attack": 250,
                "defense": 243,
                "sp_attack": 576,
                "sp_defense": 162,
                "crit": 0,
                "cdr": 25,
                "lifesteal": 0,
                "attack_speed": 48.16,
                "move_speed": 4300
            },
            {
                "level": 14,
                "hp": 5928,
                "attack": 267,
                "defense": 270,
                "sp_attack": 654,
                "sp_defense": 180,
                "crit": 0,
                "cdr": 25,
                "lifesteal": 0,
                "attack_speed": 53.79,
                "move_speed": 4300
            },
            {
                "level": 15,
                "hp": 6301,
                "attack": 286,
                "defense": 300,
                "sp_attack": 739,
                "sp_defense": 200,
                "crit": 0,
                "cdr": 25,
                "lifesteal": 0,
                "attack_speed": 60,
                "move_speed": 4300
            }
        ]
    },
    {
        "name": "Crustle",
        "level": [
            {
                "level": 1,
                "hp": 3300,
                "attack": 175,
                "defense": 97,
                "sp_attack": 20,
                "sp_defense": 67,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3600
            },
            {
                "level": 2,
                "hp": 3447,
                "attack": 179,
                "defense": 108,
                "sp_attack": 22,
                "sp_defense": 74,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.44,
                "move_speed": 3600
            },
            {
                "level": 3,
                "hp": 3615,
                "attack": 183,
                "defense": 120,
                "sp_attack": 24,
                "sp_defense": 82,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.95,
                "move_speed": 3600
            },
            {
                "level": 4,
                "hp": 4469,
                "attack": 205,
                "defense": 182,
                "sp_attack": 36,
                "sp_defense": 125,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 13.54,
                "move_speed": 3600
            },
            {
                "level": 5,
                "hp": 4692,
                "attack": 211,
                "defense": 198,
                "sp_attack": 39,
                "sp_defense": 136,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 14.22,
                "move_speed": 3750
            },
            {
                "level": 6,
                "hp": 4948,
                "attack": 218,
                "defense": 217,
                "sp_attack": 43,
                "sp_defense": 149,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 15,
                "move_speed": 3750
            },
            {
                "level": 7,
                "hp": 5242,
                "attack": 226,
                "defense": 239,
                "sp_attack": 47,
                "sp_defense": 164,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 15.89,
                "move_speed": 3900
            },
            {
                "level": 8,
                "hp": 5581,
                "attack": 235,
                "defense": 264,
                "sp_attack": 52,
                "sp_defense": 181,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 16.92,
                "move_speed": 3900
            },
            {
                "level": 9,
                "hp": 5971,
                "attack": 245,
                "defense": 293,
                "sp_attack": 58,
                "sp_defense": 201,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 18.1,
                "move_speed": 4050
            },
            {
                "level": 10,
                "hp": 6420,
                "attack": 256,
                "defense": 326,
                "sp_attack": 65,
                "sp_defense": 224,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 19.46,
                "move_speed": 4050
            },
            {
                "level": 11,
                "hp": 6936,
                "attack": 269,
                "defense": 364,
                "sp_attack": 73,
                "sp_defense": 250,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 21.02,
                "move_speed": 4200
            },
            {
                "level": 12,
                "hp": 7530,
                "attack": 284,
                "defense": 407,
                "sp_attack": 82,
                "sp_defense": 280,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 22.82,
                "move_speed": 4200
            },
            {
                "level": 13,
                "hp": 8213,
                "attack": 301,
                "defense": 457,
                "sp_attack": 92,
                "sp_defense": 314,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 24.89,
                "move_speed": 4200
            },
            {
                "level": 14,
                "hp": 8998,
                "attack": 321,
                "defense": 514,
                "sp_attack": 103,
                "sp_defense": 354,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 27.27,
                "move_speed": 4200
            },
            {
                "level": 15,
                "hp": 9900,
                "attack": 344,
                "defense": 580,
                "sp_attack": 116,
                "sp_defense": 400,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 30,
                "move_speed": 4200
            }
        ]
    },
    {
        "name": "Darkrai",
        "level": [
            {
                "level": 1,
                "hp": 3600,
                "attack": 160,
                "defense": 80,
                "sp_attack": 90,
                "sp_defense": 60,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3800
            },
            {
                "level": 2,
                "hp": 3739,
                "attack": 167,
                "defense": 90,
                "sp_attack": 112,
                "sp_defense": 67,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.71,
                "move_speed": 3800
            },
            {
                "level": 3,
                "hp": 3892,
                "attack": 175,
                "defense": 101,
                "sp_attack": 137,
                "sp_defense": 75,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 11.49,
                "move_speed": 3800
            },
            {
                "level": 4,
                "hp": 4060,
                "attack": 184,
                "defense": 113,
                "sp_attack": 164,
                "sp_defense": 84,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 12.35,
                "move_speed": 3800
            },
            {
                "level": 5,
                "hp": 4244,
                "attack": 193,
                "defense": 126,
                "sp_attack": 194,
                "sp_defense": 93,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 13.3,
                "move_speed": 3950
            },
            {
                "level": 6,
                "hp": 4447,
                "attack": 203,
                "defense": 140,
                "sp_attack": 227,
                "sp_defense": 103,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 14.34,
                "move_speed": 3950
            },
            {
                "level": 7,
                "hp": 4670,
                "attack": 214,
                "defense": 155,
                "sp_attack": 263,
                "sp_defense": 114,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 15.49,
                "move_speed": 4100
            },
            {
                "level": 8,
                "hp": 4916,
                "attack": 227,
                "defense": 172,
                "sp_attack": 303,
                "sp_defense": 127,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 16.75,
                "move_speed": 4100
            },
            {
                "level": 9,
                "hp": 5187,
                "attack": 241,
                "defense": 191,
                "sp_attack": 347,
                "sp_defense": 141,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 18.14,
                "move_speed": 4250
            },
            {
                "level": 10,
                "hp": 5486,
                "attack": 256,
                "defense": 212,
                "sp_attack": 395,
                "sp_defense": 156,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 19.67,
                "move_speed": 4250
            },
            {
                "level": 11,
                "hp": 5816,
                "attack": 273,
                "defense": 235,
                "sp_attack": 448,
                "sp_defense": 173,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 21.36,
                "move_speed": 4400
            },
            {
                "level": 12,
                "hp": 6178,
                "attack": 292,
                "defense": 260,
                "sp_attack": 507,
                "sp_defense": 192,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 23.22,
                "move_speed": 4400
            },
            {
                "level": 13,
                "hp": 6577,
                "attack": 312,
                "defense": 287,
                "sp_attack": 571,
                "sp_defense": 212,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 25.27,
                "move_speed": 4400
            },
            {
                "level": 14,
                "hp": 7016,
                "attack": 335,
                "defense": 317,
                "sp_attack": 642,
                "sp_defense": 235,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 27.52,
                "move_speed": 4400
            },
            {
                "level": 15,
                "hp": 7500,
                "attack": 360,
                "defense": 350,
                "sp_attack": 720,
                "sp_defense": 260,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 30,
                "move_speed": 4400
            }
        ]
    },
    {
        "name": "Decidueye",
        "level": [
            {
                "level": 1,
                "hp": 3000,
                "attack": 125,
                "defense": 50,
                "sp_attack": 20,
                "sp_defense": 30,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3600
            },
            {
                "level": 2,
                "hp": 3031,
                "attack": 130,
                "defense": 53,
                "sp_attack": 22,
                "sp_defense": 33,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 11.57,
                "move_speed": 3600
            },
            {
                "level": 3,
                "hp": 3068,
                "attack": 136,
                "defense": 57,
                "sp_attack": 24,
                "sp_defense": 36,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 13.46,
                "move_speed": 3600
            },
            {
                "level": 4,
                "hp": 3112,
                "attack": 143,
                "defense": 62,
                "sp_attack": 27,
                "sp_defense": 40,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 15.73,
                "move_speed": 3600
            },
            {
                "level": 5,
                "hp": 3273,
                "attack": 167,
                "defense": 78,
                "sp_attack": 37,
                "sp_defense": 55,
                "crit": 15,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 23.96,
                "move_speed": 3750
            },
            {
                "level": 6,
                "hp": 3337,
                "attack": 177,
                "defense": 85,
                "sp_attack": 41,
                "sp_defense": 61,
                "crit": 15,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 27.24,
                "move_speed": 3750
            },
            {
                "level": 7,
                "hp": 3629,
                "attack": 221,
                "defense": 115,
                "sp_attack": 58,
                "sp_defense": 88,
                "crit": 15,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 42.17,
                "move_speed": 3900
            },
            {
                "level": 8,
                "hp": 3721,
                "attack": 235,
                "defense": 124,
                "sp_attack": 64,
                "sp_defense": 97,
                "crit": 15,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 46.89,
                "move_speed": 3900
            },
            {
                "level": 9,
                "hp": 3832,
                "attack": 252,
                "defense": 135,
                "sp_attack": 71,
                "sp_defense": 107,
                "crit": 30,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 52.55,
                "move_speed": 4050
            },
            {
                "level": 10,
                "hp": 3965,
                "attack": 272,
                "defense": 149,
                "sp_attack": 79,
                "sp_defense": 119,
                "crit": 30,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 59.34,
                "move_speed": 4050
            },
            {
                "level": 11,
                "hp": 4125,
                "attack": 296,
                "defense": 165,
                "sp_attack": 89,
                "sp_defense": 134,
                "crit": 30,
                "cdr": 0,
                "lifesteal": 20,
                "attack_speed": 67.5,
                "move_speed": 4200
            },
            {
                "level": 12,
                "hp": 4316,
                "attack": 325,
                "defense": 185,
                "sp_attack": 100,
                "sp_defense": 152,
                "crit": 30,
                "cdr": 0,
                "lifesteal": 20,
                "attack_speed": 77.28,
                "move_speed": 4200
            },
            {
                "level": 13,
                "hp": 4546,
                "attack": 359,
                "defense": 208,
                "sp_attack": 114,
                "sp_defense": 173,
                "crit": 30,
                "cdr": 0,
                "lifesteal": 25,
                "attack_speed": 89.02,
                "move_speed": 4200
            },
            {
                "level": 14,
                "hp": 4821,
                "attack": 400,
                "defense": 236,
                "sp_attack": 130,
                "sp_defense": 199,
                "crit": 30,
                "cdr": 0,
                "lifesteal": 25,
                "attack_speed": 103.1,
                "move_speed": 4200
            },
            {
                "level": 15,
                "hp": 5152,
                "attack": 450,
                "defense": 270,
                "sp_attack": 150,
                "sp_defense": 230,
                "crit": 30,
                "cdr": 0,
                "lifesteal": 25,
                "attack_speed": 120,
                "move_speed": 4200
            }
        ]
    },
    {
        "name": "Delphox",
        "level": [
            {
                "level": 1,
                "hp": 3300,
                "attack": 134,
                "defense": 35,
                "sp_attack": 80,
                "sp_defense": 27,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3700
            },
            {
                "level": 2,
                "hp": 3343,
                "attack": 136,
                "defense": 37,
                "sp_attack": 92,
                "sp_defense": 30,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.21,
                "move_speed": 3700
            },
            {
                "level": 3,
                "hp": 3394,
                "attack": 139,
                "defense": 39,
                "sp_attack": 107,
                "sp_defense": 33,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.47,
                "move_speed": 3700
            },
            {
                "level": 4,
                "hp": 3605,
                "attack": 150,
                "defense": 49,
                "sp_attack": 168,
                "sp_defense": 47,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 11.53,
                "move_speed": 3700
            },
            {
                "level": 5,
                "hp": 3679,
                "attack": 154,
                "defense": 52,
                "sp_attack": 190,
                "sp_defense": 52,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 11.9,
                "move_speed": 3850
            },
            {
                "level": 6,
                "hp": 4067,
                "attack": 174,
                "defense": 70,
                "sp_attack": 303,
                "sp_defense": 78,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 13.85,
                "move_speed": 3850
            },
            {
                "level": 7,
                "hp": 4174,
                "attack": 180,
                "defense": 75,
                "sp_attack": 334,
                "sp_defense": 85,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 14.39,
                "move_speed": 4000
            },
            {
                "level": 8,
                "hp": 4302,
                "attack": 187,
                "defense": 81,
                "sp_attack": 371,
                "sp_defense": 93,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 15.03,
                "move_speed": 4000
            },
            {
                "level": 9,
                "hp": 4456,
                "attack": 195,
                "defense": 88,
                "sp_attack": 416,
                "sp_defense": 103,
                "crit": 0,
                "cdr": 15,
                "lifesteal": 0,
                "attack_speed": 15.8,
                "move_speed": 4150
            },
            {
                "level": 10,
                "hp": 4641,
                "attack": 205,
                "defense": 97,
                "sp_attack": 470,
                "sp_defense": 115,
                "crit": 0,
                "cdr": 15,
                "lifesteal": 0,
                "attack_speed": 16.73,
                "move_speed": 4150
            },
            {
                "level": 11,
                "hp": 4863,
                "attack": 217,
                "defense": 107,
                "sp_attack": 535,
                "sp_defense": 130,
                "crit": 0,
                "cdr": 15,
                "lifesteal": 0,
                "attack_speed": 17.84,
                "move_speed": 4300
            },
            {
                "level": 12,
                "hp": 5129,
                "attack": 231,
                "defense": 119,
                "sp_attack": 612,
                "sp_defense": 148,
                "crit": 0,
                "cdr": 15,
                "lifesteal": 0,
                "attack_speed": 19.17,
                "move_speed": 4300
            },
            {
                "level": 13,
                "hp": 5448,
                "attack": 248,
                "defense": 134,
                "sp_attack": 705,
                "sp_defense": 169,
                "crit": 0,
                "cdr": 25,
                "lifesteal": 0,
                "attack_speed": 20.77,
                "move_speed": 4300
            },
            {
                "level": 14,
                "hp": 5831,
                "attack": 268,
                "defense": 152,
                "sp_attack": 816,
                "sp_defense": 194,
                "crit": 0,
                "cdr": 25,
                "lifesteal": 0,
                "attack_speed": 22.69,
                "move_speed": 4300
            },
            {
                "level": 15,
                "hp": 6290,
                "attack": 292,
                "defense": 174,
                "sp_attack": 950,
                "sp_defense": 225,
                "crit": 0,
                "cdr": 25,
                "lifesteal": 0,
                "attack_speed": 24.99,
                "move_speed": 4300
            }
        ]
    },
    {
        "name": "Dodrio",
        "level": [
            {
                "level": 1,
                "hp": 3050,
                "attack": 150,
                "defense": 45,
                "sp_attack": 20,
                "sp_defense": 35,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3700
            },
            {
                "level": 2,
                "hp": 3122,
                "attack": 161,
                "defense": 51,
                "sp_attack": 22,
                "sp_defense": 39,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.44,
                "move_speed": 3700
            },
            {
                "level": 3,
                "hp": 3205,
                "attack": 173,
                "defense": 57,
                "sp_attack": 24,
                "sp_defense": 43,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.95,
                "move_speed": 3700
            },
            {
                "level": 4,
                "hp": 3300,
                "attack": 187,
                "defense": 64,
                "sp_attack": 26,
                "sp_defense": 48,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 11.54,
                "move_speed": 3700
            },
            {
                "level": 5,
                "hp": 3735,
                "attack": 251,
                "defense": 98,
                "sp_attack": 40,
                "sp_defense": 70,
                "crit": 5,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 14.22,
                "move_speed": 3850
            },
            {
                "level": 6,
                "hp": 3861,
                "attack": 269,
                "defense": 108,
                "sp_attack": 44,
                "sp_defense": 76,
                "crit": 5,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 15,
                "move_speed": 3850
            },
            {
                "level": 7,
                "hp": 4006,
                "attack": 290,
                "defense": 119,
                "sp_attack": 48,
                "sp_defense": 83,
                "crit": 5,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 15.89,
                "move_speed": 4000
            },
            {
                "level": 8,
                "hp": 4173,
                "attack": 314,
                "defense": 132,
                "sp_attack": 53,
                "sp_defense": 91,
                "crit": 5,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 16.92,
                "move_speed": 4000
            },
            {
                "level": 9,
                "hp": 4365,
                "attack": 342,
                "defense": 147,
                "sp_attack": 59,
                "sp_defense": 101,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 18.1,
                "move_speed": 4150
            },
            {
                "level": 10,
                "hp": 4586,
                "attack": 374,
                "defense": 164,
                "sp_attack": 66,
                "sp_defense": 112,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 19.46,
                "move_speed": 4150
            },
            {
                "level": 11,
                "hp": 4840,
                "attack": 411,
                "defense": 184,
                "sp_attack": 74,
                "sp_defense": 125,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 21.02,
                "move_speed": 4300
            },
            {
                "level": 12,
                "hp": 5133,
                "attack": 454,
                "defense": 207,
                "sp_attack": 83,
                "sp_defense": 140,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 22.82,
                "move_speed": 4300
            },
            {
                "level": 13,
                "hp": 5469,
                "attack": 503,
                "defense": 233,
                "sp_attack": 93,
                "sp_defense": 157,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 24.89,
                "move_speed": 4300
            },
            {
                "level": 14,
                "hp": 5856,
                "attack": 560,
                "defense": 263,
                "sp_attack": 105,
                "sp_defense": 177,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 27.27,
                "move_speed": 4300
            },
            {
                "level": 15,
                "hp": 6300,
                "attack": 625,
                "defense": 298,
                "sp_attack": 118,
                "sp_defense": 200,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 30,
                "move_speed": 4300
            }
        ]
    },
    {
        "name": "Dragapult",
        "level": [
            {
                "level": 1,
                "hp": 3000,
                "attack": 140,
                "defense": 50,
                "sp_attack": 20,
                "sp_defense": 40,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3650
            },
            {
                "level": 2,
                "hp": 3036,
                "attack": 145,
                "defense": 53,
                "sp_attack": 21,
                "sp_defense": 42,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 11.01,
                "move_speed": 3650
            },
            {
                "level": 3,
                "hp": 3079,
                "attack": 151,
                "defense": 56,
                "sp_attack": 23,
                "sp_defense": 44,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 12.22,
                "move_speed": 3650
            },
            {
                "level": 4,
                "hp": 3131,
                "attack": 158,
                "defense": 60,
                "sp_attack": 25,
                "sp_defense": 46,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 13.67,
                "move_speed": 3650
            },
            {
                "level": 5,
                "hp": 3318,
                "attack": 185,
                "defense": 74,
                "sp_attack": 32,
                "sp_defense": 55,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 18.91,
                "move_speed": 3800
            },
            {
                "level": 6,
                "hp": 3393,
                "attack": 196,
                "defense": 80,
                "sp_attack": 35,
                "sp_defense": 59,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 20.99,
                "move_speed": 3800
            },
            {
                "level": 7,
                "hp": 3482,
                "attack": 209,
                "defense": 87,
                "sp_attack": 38,
                "sp_defense": 63,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 23.49,
                "move_speed": 3950
            },
            {
                "level": 8,
                "hp": 3589,
                "attack": 224,
                "defense": 95,
                "sp_attack": 42,
                "sp_defense": 68,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 26.49,
                "move_speed": 3950
            },
            {
                "level": 9,
                "hp": 3968,
                "attack": 279,
                "defense": 124,
                "sp_attack": 56,
                "sp_defense": 86,
                "crit": 25,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 37.09,
                "move_speed": 4100
            },
            {
                "level": 10,
                "hp": 4122,
                "attack": 301,
                "defense": 136,
                "sp_attack": 62,
                "sp_defense": 93,
                "crit": 25,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 41.41,
                "move_speed": 4100
            },
            {
                "level": 11,
                "hp": 4307,
                "attack": 328,
                "defense": 150,
                "sp_attack": 69,
                "sp_defense": 102,
                "crit": 25,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 46.6,
                "move_speed": 4250
            },
            {
                "level": 12,
                "hp": 4529,
                "attack": 360,
                "defense": 167,
                "sp_attack": 77,
                "sp_defense": 113,
                "crit": 25,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 52.82,
                "move_speed": 4250
            },
            {
                "level": 13,
                "hp": 4796,
                "attack": 399,
                "defense": 187,
                "sp_attack": 87,
                "sp_defense": 126,
                "crit": 25,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 60.29,
                "move_speed": 4250
            },
            {
                "level": 14,
                "hp": 5116,
                "attack": 445,
                "defense": 211,
                "sp_attack": 99,
                "sp_defense": 141,
                "crit": 25,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 69.25,
                "move_speed": 4250
            },
            {
                "level": 15,
                "hp": 5500,
                "attack": 500,
                "defense": 240,
                "sp_attack": 114,
                "sp_defense": 160,
                "crit": 25,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 80,
                "move_speed": 4250
            }
        ]
    },
    {
        "name": "Dragonite",
        "level": [
            {
                "level": 1,
                "hp": 3050,
                "attack": 165,
                "defense": 78,
                "sp_attack": 20,
                "sp_defense": 60,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3700
            },
            {
                "level": 2,
                "hp": 3117,
                "attack": 170,
                "defense": 83,
                "sp_attack": 21,
                "sp_defense": 64,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.57,
                "move_speed": 3700
            },
            {
                "level": 3,
                "hp": 3198,
                "attack": 177,
                "defense": 89,
                "sp_attack": 23,
                "sp_defense": 68,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 11.26,
                "move_speed": 3700
            },
            {
                "level": 4,
                "hp": 3295,
                "attack": 185,
                "defense": 96,
                "sp_attack": 25,
                "sp_defense": 73,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 12.08,
                "move_speed": 3700
            },
            {
                "level": 5,
                "hp": 3647,
                "attack": 214,
                "defense": 121,
                "sp_attack": 32,
                "sp_defense": 92,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 15.07,
                "move_speed": 3850
            },
            {
                "level": 6,
                "hp": 3787,
                "attack": 225,
                "defense": 131,
                "sp_attack": 35,
                "sp_defense": 100,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 16.26,
                "move_speed": 3850
            },
            {
                "level": 7,
                "hp": 3955,
                "attack": 239,
                "defense": 143,
                "sp_attack": 38,
                "sp_defense": 109,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 17.69,
                "move_speed": 4000
            },
            {
                "level": 8,
                "hp": 4627,
                "attack": 294,
                "defense": 191,
                "sp_attack": 52,
                "sp_defense": 145,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 23.41,
                "move_speed": 4000
            },
            {
                "level": 9,
                "hp": 4869,
                "attack": 314,
                "defense": 208,
                "sp_attack": 57,
                "sp_defense": 158,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 25.47,
                "move_speed": 4150
            },
            {
                "level": 10,
                "hp": 5159,
                "attack": 338,
                "defense": 229,
                "sp_attack": 63,
                "sp_defense": 174,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 27.94,
                "move_speed": 4150
            },
            {
                "level": 11,
                "hp": 5507,
                "attack": 367,
                "defense": 254,
                "sp_attack": 70,
                "sp_defense": 193,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 30.91,
                "move_speed": 4300
            },
            {
                "level": 12,
                "hp": 5925,
                "attack": 401,
                "defense": 284,
                "sp_attack": 78,
                "sp_defense": 216,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 34.47,
                "move_speed": 4300
            },
            {
                "level": 13,
                "hp": 6426,
                "attack": 442,
                "defense": 320,
                "sp_attack": 88,
                "sp_defense": 243,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 38.74,
                "move_speed": 4300
            },
            {
                "level": 14,
                "hp": 7028,
                "attack": 491,
                "defense": 363,
                "sp_attack": 100,
                "sp_defense": 276,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 43.86,
                "move_speed": 4300
            },
            {
                "level": 15,
                "hp": 7750,
                "attack": 550,
                "defense": 415,
                "sp_attack": 115,
                "sp_defense": 315,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 50,
                "move_speed": 4300
            }
        ]
    },
    {
        "name": "Duraludon",
        "level": [
            {
                "level": 1,
                "hp": 3000,
                "attack": 135,
                "defense": 70,
                "sp_attack": 20,
                "sp_defense": 50,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3650
            },
            {
                "level": 2,
                "hp": 3085,
                "attack": 148,
                "defense": 78,
                "sp_attack": 24,
                "sp_defense": 55,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 13.14,
                "move_speed": 3650
            },
            {
                "level": 3,
                "hp": 3179,
                "attack": 162,
                "defense": 87,
                "sp_attack": 28,
                "sp_defense": 61,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 16.59,
                "move_speed": 3650
            },
            {
                "level": 4,
                "hp": 3282,
                "attack": 178,
                "defense": 97,
                "sp_attack": 32,
                "sp_defense": 67,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 20.39,
                "move_speed": 3650
            },
            {
                "level": 5,
                "hp": 3395,
                "attack": 195,
                "defense": 108,
                "sp_attack": 37,
                "sp_defense": 74,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 24.57,
                "move_speed": 3800
            },
            {
                "level": 6,
                "hp": 3520,
                "attack": 214,
                "defense": 120,
                "sp_attack": 42,
                "sp_defense": 82,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 29.16,
                "move_speed": 3800
            },
            {
                "level": 7,
                "hp": 3657,
                "attack": 235,
                "defense": 133,
                "sp_attack": 48,
                "sp_defense": 91,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 34.21,
                "move_speed": 3950
            },
            {
                "level": 8,
                "hp": 3808,
                "attack": 258,
                "defense": 148,
                "sp_attack": 54,
                "sp_defense": 100,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 39.77,
                "move_speed": 3950
            },
            {
                "level": 9,
                "hp": 3975,
                "attack": 284,
                "defense": 164,
                "sp_attack": 61,
                "sp_defense": 110,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 45.88,
                "move_speed": 4100
            },
            {
                "level": 10,
                "hp": 4159,
                "attack": 312,
                "defense": 182,
                "sp_attack": 69,
                "sp_defense": 122,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 52.6,
                "move_speed": 4100
            },
            {
                "level": 11,
                "hp": 4362,
                "attack": 343,
                "defense": 201,
                "sp_attack": 77,
                "sp_defense": 135,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 20,
                "attack_speed": 60,
                "move_speed": 4250
            },
            {
                "level": 12,
                "hp": 4585,
                "attack": 377,
                "defense": 222,
                "sp_attack": 86,
                "sp_defense": 149,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 20,
                "attack_speed": 60,
                "move_speed": 4250
            },
            {
                "level": 13,
                "hp": 4830,
                "attack": 414,
                "defense": 246,
                "sp_attack": 96,
                "sp_defense": 164,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 25,
                "attack_speed": 60,
                "move_speed": 4250
            },
            {
                "level": 14,
                "hp": 5100,
                "attack": 455,
                "defense": 272,
                "sp_attack": 107,
                "sp_defense": 181,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 25,
                "attack_speed": 60,
                "move_speed": 4250
            },
            {
                "level": 15,
                "hp": 5397,
                "attack": 500,
                "defense": 301,
                "sp_attack": 119,
                "sp_defense": 200,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 25,
                "attack_speed": 60,
                "move_speed": 4250
            }
        ]
    },
    {
        "name": "Eldegoss",
        "level": [
            {
                "level": 1,
                "hp": 3278,
                "attack": 130,
                "defense": 40,
                "sp_attack": 40,
                "sp_defense": 30,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3800
            },
            {
                "level": 2,
                "hp": 3383,
                "attack": 134,
                "defense": 44,
                "sp_attack": 54,
                "sp_defense": 33,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.22,
                "move_speed": 3800
            },
            {
                "level": 3,
                "hp": 3503,
                "attack": 139,
                "defense": 48,
                "sp_attack": 70,
                "sp_defense": 36,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.47,
                "move_speed": 3800
            },
            {
                "level": 4,
                "hp": 4114,
                "attack": 162,
                "defense": 69,
                "sp_attack": 152,
                "sp_defense": 52,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 11.76,
                "move_speed": 3800
            },
            {
                "level": 5,
                "hp": 4274,
                "attack": 168,
                "defense": 74,
                "sp_attack": 173,
                "sp_defense": 56,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 12.1,
                "move_speed": 3950
            },
            {
                "level": 6,
                "hp": 4457,
                "attack": 175,
                "defense": 80,
                "sp_attack": 198,
                "sp_defense": 61,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 12.49,
                "move_speed": 3950
            },
            {
                "level": 7,
                "hp": 4668,
                "attack": 183,
                "defense": 87,
                "sp_attack": 226,
                "sp_defense": 66,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 12.94,
                "move_speed": 4100
            },
            {
                "level": 8,
                "hp": 4911,
                "attack": 192,
                "defense": 95,
                "sp_attack": 258,
                "sp_defense": 72,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 13.45,
                "move_speed": 4100
            },
            {
                "level": 9,
                "hp": 5190,
                "attack": 203,
                "defense": 104,
                "sp_attack": 295,
                "sp_defense": 79,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 14.04,
                "move_speed": 4250
            },
            {
                "level": 10,
                "hp": 5511,
                "attack": 215,
                "defense": 115,
                "sp_attack": 338,
                "sp_defense": 87,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 14.72,
                "move_speed": 4250
            },
            {
                "level": 11,
                "hp": 5880,
                "attack": 229,
                "defense": 128,
                "sp_attack": 387,
                "sp_defense": 96,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 15.5,
                "move_speed": 4400
            },
            {
                "level": 12,
                "hp": 6305,
                "attack": 245,
                "defense": 142,
                "sp_attack": 444,
                "sp_defense": 107,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 16.4,
                "move_speed": 4400
            },
            {
                "level": 13,
                "hp": 6794,
                "attack": 264,
                "defense": 159,
                "sp_attack": 509,
                "sp_defense": 119,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 17.43,
                "move_speed": 4400
            },
            {
                "level": 14,
                "hp": 7356,
                "attack": 285,
                "defense": 178,
                "sp_attack": 584,
                "sp_defense": 133,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 18.62,
                "move_speed": 4400
            },
            {
                "level": 15,
                "hp": 8002,
                "attack": 310,
                "defense": 200,
                "sp_attack": 670,
                "sp_defense": 149,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 19.99,
                "move_speed": 4400
            }
        ]
    },
    {
        "name": "Espeon",
        "level": [
            {
                "level": 1,
                "hp": 3200,
                "attack": 134,
                "defense": 35,
                "sp_attack": 50,
                "sp_defense": 27,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3700
            },
            {
                "level": 2,
                "hp": 3269,
                "attack": 137,
                "defense": 39,
                "sp_attack": 71,
                "sp_defense": 30,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3700
            },
            {
                "level": 3,
                "hp": 3349,
                "attack": 141,
                "defense": 44,
                "sp_attack": 95,
                "sp_defense": 34,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3700
            },
            {
                "level": 4,
                "hp": 3753,
                "attack": 161,
                "defense": 69,
                "sp_attack": 218,
                "sp_defense": 54,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3700
            },
            {
                "level": 5,
                "hp": 3858,
                "attack": 166,
                "defense": 75,
                "sp_attack": 250,
                "sp_defense": 59,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3850
            },
            {
                "level": 6,
                "hp": 3979,
                "attack": 172,
                "defense": 82,
                "sp_attack": 287,
                "sp_defense": 65,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3850
            },
            {
                "level": 7,
                "hp": 4118,
                "attack": 179,
                "defense": 90,
                "sp_attack": 329,
                "sp_defense": 72,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 4000
            },
            {
                "level": 8,
                "hp": 4278,
                "attack": 187,
                "defense": 100,
                "sp_attack": 378,
                "sp_defense": 80,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 4000
            },
            {
                "level": 9,
                "hp": 4462,
                "attack": 196,
                "defense": 111,
                "sp_attack": 434,
                "sp_defense": 89,
                "crit": 0,
                "cdr": 15,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 4150
            },
            {
                "level": 10,
                "hp": 4674,
                "attack": 207,
                "defense": 124,
                "sp_attack": 499,
                "sp_defense": 99,
                "crit": 0,
                "cdr": 15,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 4150
            },
            {
                "level": 11,
                "hp": 4918,
                "attack": 219,
                "defense": 139,
                "sp_attack": 573,
                "sp_defense": 111,
                "crit": 0,
                "cdr": 15,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 4300
            },
            {
                "level": 12,
                "hp": 5199,
                "attack": 233,
                "defense": 156,
                "sp_attack": 658,
                "sp_defense": 125,
                "crit": 0,
                "cdr": 15,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 4300
            },
            {
                "level": 13,
                "hp": 5522,
                "attack": 249,
                "defense": 176,
                "sp_attack": 756,
                "sp_defense": 141,
                "crit": 0,
                "cdr": 25,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 4300
            },
            {
                "level": 14,
                "hp": 5893,
                "attack": 268,
                "defense": 199,
                "sp_attack": 869,
                "sp_defense": 159,
                "crit": 0,
                "cdr": 25,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 4300
            },
            {
                "level": 15,
                "hp": 6320,
                "attack": 289,
                "defense": 225,
                "sp_attack": 999,
                "sp_defense": 180,
                "crit": 0,
                "cdr": 25,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 4300
            }
        ]
    },
    {
        "name": "Falinks",
        "level": [
            {
                "level": 1,
                "hp": 3200,
                "attack": 150,
                "defense": 90,
                "sp_attack": 20,
                "sp_defense": 70,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3700
            },
            {
                "level": 2,
                "hp": 3371,
                "attack": 160,
                "defense": 103,
                "sp_attack": 23,
                "sp_defense": 80,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.71,
                "move_speed": 3700
            },
            {
                "level": 3,
                "hp": 3559,
                "attack": 171,
                "defense": 118,
                "sp_attack": 27,
                "sp_defense": 91,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 11.49,
                "move_speed": 3700
            },
            {
                "level": 4,
                "hp": 3766,
                "attack": 183,
                "defense": 134,
                "sp_attack": 31,
                "sp_defense": 103,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 12.35,
                "move_speed": 3700
            },
            {
                "level": 5,
                "hp": 3993,
                "attack": 196,
                "defense": 152,
                "sp_attack": 35,
                "sp_defense": 117,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 13.3,
                "move_speed": 3850
            },
            {
                "level": 6,
                "hp": 4243,
                "attack": 211,
                "defense": 171,
                "sp_attack": 40,
                "sp_defense": 132,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 14.34,
                "move_speed": 3850
            },
            {
                "level": 7,
                "hp": 4518,
                "attack": 227,
                "defense": 192,
                "sp_attack": 45,
                "sp_defense": 149,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 15.49,
                "move_speed": 4000
            },
            {
                "level": 8,
                "hp": 4821,
                "attack": 245,
                "defense": 215,
                "sp_attack": 51,
                "sp_defense": 167,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 16.75,
                "move_speed": 4000
            },
            {
                "level": 9,
                "hp": 5155,
                "attack": 264,
                "defense": 241,
                "sp_attack": 58,
                "sp_defense": 187,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 18.14,
                "move_speed": 4150
            },
            {
                "level": 10,
                "hp": 5523,
                "attack": 285,
                "defense": 269,
                "sp_attack": 65,
                "sp_defense": 209,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 19.67,
                "move_speed": 4150
            },
            {
                "level": 11,
                "hp": 5928,
                "attack": 309,
                "defense": 300,
                "sp_attack": 73,
                "sp_defense": 234,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 21.36,
                "move_speed": 4300
            },
            {
                "level": 12,
                "hp": 6374,
                "attack": 335,
                "defense": 334,
                "sp_attack": 82,
                "sp_defense": 261,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 23.22,
                "move_speed": 4300
            },
            {
                "level": 13,
                "hp": 6865,
                "attack": 364,
                "defense": 372,
                "sp_attack": 92,
                "sp_defense": 291,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 25.27,
                "move_speed": 4300
            },
            {
                "level": 14,
                "hp": 7405,
                "attack": 395,
                "defense": 414,
                "sp_attack": 103,
                "sp_defense": 324,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 27.52,
                "move_speed": 4300
            },
            {
                "level": 15,
                "hp": 8000,
                "attack": 430,
                "defense": 460,
                "sp_attack": 115,
                "sp_defense": 360,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 30,
                "move_speed": 4300
            }
        ]
    },
    {
        "name": "Garchomp",
        "level": [
            {
                "level": 1,
                "hp": 3050,
                "attack": 165,
                "defense": 90,
                "sp_attack": 20,
                "sp_defense": 67,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3800
            },
            {
                "level": 2,
                "hp": 3117,
                "attack": 170,
                "defense": 95,
                "sp_attack": 21,
                "sp_defense": 71,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.5,
                "move_speed": 3800
            },
            {
                "level": 3,
                "hp": 3198,
                "attack": 176,
                "defense": 102,
                "sp_attack": 23,
                "sp_defense": 76,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 11.1,
                "move_speed": 3800
            },
            {
                "level": 4,
                "hp": 3295,
                "attack": 183,
                "defense": 110,
                "sp_attack": 25,
                "sp_defense": 82,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 11.82,
                "move_speed": 3800
            },
            {
                "level": 5,
                "hp": 3647,
                "attack": 209,
                "defense": 138,
                "sp_attack": 32,
                "sp_defense": 104,
                "crit": 5,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 14.44,
                "move_speed": 3950
            },
            {
                "level": 6,
                "hp": 3787,
                "attack": 219,
                "defense": 149,
                "sp_attack": 35,
                "sp_defense": 113,
                "crit": 5,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 15.48,
                "move_speed": 3950
            },
            {
                "level": 7,
                "hp": 3955,
                "attack": 232,
                "defense": 163,
                "sp_attack": 38,
                "sp_defense": 124,
                "crit": 5,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 16.73,
                "move_speed": 4100
            },
            {
                "level": 8,
                "hp": 4157,
                "attack": 247,
                "defense": 179,
                "sp_attack": 42,
                "sp_defense": 137,
                "crit": 5,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 18.23,
                "move_speed": 4100
            },
            {
                "level": 9,
                "hp": 4869,
                "attack": 300,
                "defense": 237,
                "sp_attack": 56,
                "sp_defense": 183,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 23.53,
                "move_speed": 4250
            },
            {
                "level": 10,
                "hp": 5159,
                "attack": 322,
                "defense": 261,
                "sp_attack": 62,
                "sp_defense": 202,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 25.69,
                "move_speed": 4250
            },
            {
                "level": 11,
                "hp": 5507,
                "attack": 348,
                "defense": 289,
                "sp_attack": 69,
                "sp_defense": 224,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 28.28,
                "move_speed": 4400
            },
            {
                "level": 12,
                "hp": 5925,
                "attack": 379,
                "defense": 323,
                "sp_attack": 77,
                "sp_defense": 251,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 31.39,
                "move_speed": 4400
            },
            {
                "level": 13,
                "hp": 6426,
                "attack": 417,
                "defense": 364,
                "sp_attack": 87,
                "sp_defense": 283,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 35.12,
                "move_speed": 4400
            },
            {
                "level": 14,
                "hp": 7028,
                "attack": 462,
                "defense": 413,
                "sp_attack": 99,
                "sp_defense": 321,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 39.6,
                "move_speed": 4400
            },
            {
                "level": 15,
                "hp": 7750,
                "attack": 516,
                "defense": 472,
                "sp_attack": 114,
                "sp_defense": 367,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 45,
                "move_speed": 4400
            }
        ]
    },
    {
        "name": "Gardevoir",
        "level": [
            {
                "level": 1,
                "hp": 3200,
                "attack": 134,
                "defense": 35,
                "sp_attack": 65,
                "sp_defense": 27,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3700
            },
            {
                "level": 2,
                "hp": 3245,
                "attack": 136,
                "defense": 38,
                "sp_attack": 79,
                "sp_defense": 29,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3700
            },
            {
                "level": 3,
                "hp": 3299,
                "attack": 139,
                "defense": 41,
                "sp_attack": 96,
                "sp_defense": 32,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3700
            },
            {
                "level": 4,
                "hp": 3363,
                "attack": 142,
                "defense": 45,
                "sp_attack": 116,
                "sp_defense": 35,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3700
            },
            {
                "level": 5,
                "hp": 3596,
                "attack": 154,
                "defense": 59,
                "sp_attack": 190,
                "sp_defense": 46,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3850
            },
            {
                "level": 6,
                "hp": 3689,
                "attack": 159,
                "defense": 65,
                "sp_attack": 219,
                "sp_defense": 50,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3850
            },
            {
                "level": 7,
                "hp": 4113,
                "attack": 180,
                "defense": 91,
                "sp_attack": 353,
                "sp_defense": 70,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 4000
            },
            {
                "level": 8,
                "hp": 4247,
                "attack": 187,
                "defense": 99,
                "sp_attack": 395,
                "sp_defense": 76,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 4000
            },
            {
                "level": 9,
                "hp": 4408,
                "attack": 195,
                "defense": 109,
                "sp_attack": 446,
                "sp_defense": 84,
                "crit": 0,
                "cdr": 15,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 4150
            },
            {
                "level": 10,
                "hp": 4601,
                "attack": 205,
                "defense": 121,
                "sp_attack": 507,
                "sp_defense": 93,
                "crit": 0,
                "cdr": 15,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 4150
            },
            {
                "level": 11,
                "hp": 4832,
                "attack": 216,
                "defense": 135,
                "sp_attack": 580,
                "sp_defense": 104,
                "crit": 0,
                "cdr": 15,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 4300
            },
            {
                "level": 12,
                "hp": 5109,
                "attack": 230,
                "defense": 152,
                "sp_attack": 668,
                "sp_defense": 117,
                "crit": 0,
                "cdr": 15,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 4300
            },
            {
                "level": 13,
                "hp": 5442,
                "attack": 247,
                "defense": 172,
                "sp_attack": 773,
                "sp_defense": 133,
                "crit": 0,
                "cdr": 25,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 4300
            },
            {
                "level": 14,
                "hp": 5841,
                "attack": 267,
                "defense": 196,
                "sp_attack": 899,
                "sp_defense": 152,
                "crit": 0,
                "cdr": 25,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 4300
            },
            {
                "level": 15,
                "hp": 6320,
                "attack": 291,
                "defense": 225,
                "sp_attack": 1050,
                "sp_defense": 175,
                "crit": 0,
                "cdr": 25,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 4300
            }
        ]
    },
    {
        "name": "Gengar",
        "level": [
            {
                "level": 1,
                "hp": 3456,
                "attack": 167,
                "defense": 52,
                "sp_attack": 80,
                "sp_defense": 38,
                "crit": "0",
                "cdr": "0",
                "lifesteal": "0",
                "attack_speed": "10.00",
                "move_speed": 3650
            },
            {
                "level": 2,
                "hp": 3510,
                "attack": 170,
                "defense": 55,
                "sp_attack": 89,
                "sp_defense": 40,
                "crit": "0",
                "cdr": "0",
                "lifesteal": "0",
                "attack_speed": "10.43",
                "move_speed": 3650
            },
            {
                "level": 3,
                "hp": 3574,
                "attack": 173,
                "defense": 59,
                "sp_attack": 99,
                "sp_defense": 43,
                "crit": "0",
                "cdr": "0",
                "lifesteal": "0",
                "attack_speed": "10.94",
                "move_speed": 3650
            },
            {
                "level": 4,
                "hp": 3651,
                "attack": 177,
                "defense": 64,
                "sp_attack": 112,
                "sp_defense": 47,
                "crit": "0",
                "cdr": "0",
                "lifesteal": "0",
                "attack_speed": "11.56",
                "move_speed": 3650
            },
            {
                "level": 5,
                "hp": 3931,
                "attack": 192,
                "defense": 82,
                "sp_attack": 158,
                "sp_defense": 60,
                "crit": "0",
                "cdr": "5",
                "lifesteal": "0",
                "attack_speed": "13.8",
                "move_speed": 3800
            },
            {
                "level": 6,
                "hp": 4043,
                "attack": 198,
                "defense": 89,
                "sp_attack": 176,
                "sp_defense": 65,
                "crit": "0",
                "cdr": "5",
                "lifesteal": "0",
                "attack_speed": "14.69",
                "move_speed": 3800
            },
            {
                "level": 7,
                "hp": 4177,
                "attack": 205,
                "defense": 98,
                "sp_attack": 198,
                "sp_defense": 71,
                "crit": "0",
                "cdr": "5",
                "lifesteal": "0",
                "attack_speed": "15.76",
                "move_speed": 3950
            },
            {
                "level": 8,
                "hp": 4338,
                "attack": 213,
                "defense": 108,
                "sp_attack": 224,
                "sp_defense": 78,
                "crit": "0",
                "cdr": "5",
                "lifesteal": "0",
                "attack_speed": "17.05",
                "move_speed": 3950
            },
            {
                "level": 9,
                "hp": 4905,
                "attack": 243,
                "defense": 144,
                "sp_attack": 316,
                "sp_defense": 104,
                "crit": "0",
                "cdr": "15",
                "lifesteal": "0",
                "attack_speed": "21.59",
                "move_speed": 4100
            },
            {
                "level": 10,
                "hp": 5136,
                "attack": 255,
                "defense": 159,
                "sp_attack": 354,
                "sp_defense": 115,
                "crit": "0",
                "cdr": "15",
                "lifesteal": "0",
                "attack_speed": "23.44",
                "move_speed": 4100
            },
            {
                "level": 11,
                "hp": 5414,
                "attack": 270,
                "defense": 177,
                "sp_attack": 399,
                "sp_defense": 128,
                "crit": "0",
                "cdr": "15",
                "lifesteal": "0",
                "attack_speed": "25.66",
                "move_speed": 4250
            },
            {
                "level": 12,
                "hp": 5747,
                "attack": 288,
                "defense": 198,
                "sp_attack": 453,
                "sp_defense": 143,
                "crit": "0",
                "cdr": "15",
                "lifesteal": "0",
                "attack_speed": "28.33",
                "move_speed": 4250
            },
            {
                "level": 13,
                "hp": 6146,
                "attack": 309,
                "defense": 223,
                "sp_attack": 518,
                "sp_defense": 161,
                "crit": "0",
                "cdr": "25",
                "lifesteal": "0",
                "attack_speed": "31.53",
                "move_speed": 4250
            },
            {
                "level": 14,
                "hp": 6625,
                "attack": 334,
                "defense": 253,
                "sp_attack": 596,
                "sp_defense": 183,
                "crit": "0",
                "cdr": "25",
                "lifesteal": "0",
                "attack_speed": "35.37",
                "move_speed": 4250
            },
            {
                "level": 15,
                "hp": 7200,
                "attack": 364,
                "defense": 290,
                "sp_attack": 690,
                "sp_defense": 210,
                "crit": "0",
                "cdr": "25",
                "lifesteal": "0",
                "attack_speed": "39.98",
                "move_speed": 4250
            }
        ]
    },
    {
        "name": "Glaceon",
        "level": [
            {
                "level": 1,
                "hp": 3200,
                "attack": 20,
                "defense": 35,
                "sp_attack": 100,
                "sp_defense": 25,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3700
            },
            {
                "level": 2,
                "hp": 3270,
                "attack": 22,
                "defense": 39,
                "sp_attack": 117,
                "sp_defense": 28,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 12,
                "move_speed": 3700
            },
            {
                "level": 3,
                "hp": 3350,
                "attack": 24,
                "defense": 44,
                "sp_attack": 137,
                "sp_defense": 32,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 14.29,
                "move_speed": 3700
            },
            {
                "level": 4,
                "hp": 3758,
                "attack": 36,
                "defense": 69,
                "sp_attack": 238,
                "sp_defense": 52,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 25.93,
                "move_speed": 3700
            },
            {
                "level": 5,
                "hp": 3864,
                "attack": 39,
                "defense": 75,
                "sp_attack": 264,
                "sp_defense": 57,
                "crit": 10,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 28.97,
                "move_speed": 3850
            },
            {
                "level": 6,
                "hp": 3986,
                "attack": 43,
                "defense": 82,
                "sp_attack": 294,
                "sp_defense": 63,
                "crit": 10,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 32.46,
                "move_speed": 3850
            },
            {
                "level": 7,
                "hp": 4127,
                "attack": 47,
                "defense": 90,
                "sp_attack": 329,
                "sp_defense": 70,
                "crit": 10,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 36.47,
                "move_speed": 4000
            },
            {
                "level": 8,
                "hp": 4289,
                "attack": 52,
                "defense": 100,
                "sp_attack": 369,
                "sp_defense": 78,
                "crit": 10,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 41.09,
                "move_speed": 4000
            },
            {
                "level": 9,
                "hp": 4475,
                "attack": 58,
                "defense": 111,
                "sp_attack": 415,
                "sp_defense": 87,
                "crit": 20,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 46.41,
                "move_speed": 4150
            },
            {
                "level": 10,
                "hp": 4689,
                "attack": 65,
                "defense": 124,
                "sp_attack": 468,
                "sp_defense": 98,
                "crit": 20,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 52.53,
                "move_speed": 4150
            },
            {
                "level": 11,
                "hp": 4935,
                "attack": 73,
                "defense": 139,
                "sp_attack": 529,
                "sp_defense": 110,
                "crit": 20,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 59.57,
                "move_speed": 4300
            },
            {
                "level": 12,
                "hp": 5218,
                "attack": 82,
                "defense": 156,
                "sp_attack": 599,
                "sp_defense": 124,
                "crit": 20,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 67.67,
                "move_speed": 4300
            },
            {
                "level": 13,
                "hp": 5544,
                "attack": 92,
                "defense": 176,
                "sp_attack": 680,
                "sp_defense": 140,
                "crit": 20,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 76.99,
                "move_speed": 4300
            },
            {
                "level": 14,
                "hp": 5919,
                "attack": 103,
                "defense": 199,
                "sp_attack": 773,
                "sp_defense": 158,
                "crit": 20,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 87.7,
                "move_speed": 4300
            },
            {
                "level": 15,
                "hp": 6350,
                "attack": 116,
                "defense": 225,
                "sp_attack": 880,
                "sp_defense": 180,
                "crit": 20,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 100,
                "move_speed": 4300
            }
        ]
    },
    {
        "name": "Goodra",
        "level": [
            {
                "level": 1,
                "hp": 3225,
                "attack": 150,
                "defense": 100,
                "sp_attack": 50,
                "sp_defense": 100,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3700
            },
            {
                "level": 2,
                "hp": 3319,
                "attack": 152,
                "defense": 107,
                "sp_attack": 56,
                "sp_defense": 106,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.29,
                "move_speed": 3700
            },
            {
                "level": 3,
                "hp": 3432,
                "attack": 155,
                "defense": 116,
                "sp_attack": 63,
                "sp_defense": 113,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.63,
                "move_speed": 3700
            },
            {
                "level": 4,
                "hp": 3568,
                "attack": 158,
                "defense": 126,
                "sp_attack": 71,
                "sp_defense": 121,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 11.04,
                "move_speed": 3700
            },
            {
                "level": 5,
                "hp": 4060,
                "attack": 169,
                "defense": 163,
                "sp_attack": 101,
                "sp_defense": 151,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 12.54,
                "move_speed": 3850
            },
            {
                "level": 6,
                "hp": 4256,
                "attack": 174,
                "defense": 178,
                "sp_attack": 113,
                "sp_defense": 163,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 13.14,
                "move_speed": 3850
            },
            {
                "level": 7,
                "hp": 4491,
                "attack": 179,
                "defense": 196,
                "sp_attack": 127,
                "sp_defense": 177,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 13.86,
                "move_speed": 4000
            },
            {
                "level": 8,
                "hp": 5430,
                "attack": 201,
                "defense": 268,
                "sp_attack": 184,
                "sp_defense": 234,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 16.72,
                "move_speed": 4000
            },
            {
                "level": 9,
                "hp": 5769,
                "attack": 209,
                "defense": 294,
                "sp_attack": 205,
                "sp_defense": 255,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 17.75,
                "move_speed": 4150
            },
            {
                "level": 10,
                "hp": 6175,
                "attack": 218,
                "defense": 325,
                "sp_attack": 230,
                "sp_defense": 280,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 18.98,
                "move_speed": 4150
            },
            {
                "level": 11,
                "hp": 6662,
                "attack": 229,
                "defense": 362,
                "sp_attack": 260,
                "sp_defense": 310,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 20.46,
                "move_speed": 4300
            },
            {
                "level": 12,
                "hp": 7247,
                "attack": 242,
                "defense": 406,
                "sp_attack": 295,
                "sp_defense": 345,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 22.24,
                "move_speed": 4300
            },
            {
                "level": 13,
                "hp": 7948,
                "attack": 258,
                "defense": 459,
                "sp_attack": 338,
                "sp_defense": 388,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 24.37,
                "move_speed": 4300
            },
            {
                "level": 14,
                "hp": 8790,
                "attack": 277,
                "defense": 523,
                "sp_attack": 389,
                "sp_defense": 439,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 26.93,
                "move_speed": 4300
            },
            {
                "level": 15,
                "hp": 9800,
                "attack": 300,
                "defense": 600,
                "sp_attack": 450,
                "sp_defense": 500,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 30,
                "move_speed": 4300
            }
        ]
    },
    {
        "name": "Greedent",
        "level": [
            {
                "level": 1,
                "hp": 3000,
                "attack": 170,
                "defense": 75,
                "sp_attack": 20,
                "sp_defense": 60,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3600
            },
            {
                "level": 2,
                "hp": 3135,
                "attack": 174,
                "defense": 83,
                "sp_attack": 22,
                "sp_defense": 67,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.44,
                "move_speed": 3600
            },
            {
                "level": 3,
                "hp": 3290,
                "attack": 178,
                "defense": 92,
                "sp_attack": 24,
                "sp_defense": 75,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.95,
                "move_speed": 3600
            },
            {
                "level": 4,
                "hp": 3469,
                "attack": 183,
                "defense": 103,
                "sp_attack": 27,
                "sp_defense": 84,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 11.54,
                "move_speed": 3600
            },
            {
                "level": 5,
                "hp": 4285,
                "attack": 206,
                "defense": 151,
                "sp_attack": 40,
                "sp_defense": 124,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 14.22,
                "move_speed": 3750
            },
            {
                "level": 6,
                "hp": 4522,
                "attack": 213,
                "defense": 165,
                "sp_attack": 44,
                "sp_defense": 136,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 15,
                "move_speed": 3750
            },
            {
                "level": 7,
                "hp": 4794,
                "attack": 221,
                "defense": 181,
                "sp_attack": 48,
                "sp_defense": 149,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 15.89,
                "move_speed": 3900
            },
            {
                "level": 8,
                "hp": 5107,
                "attack": 230,
                "defense": 199,
                "sp_attack": 53,
                "sp_defense": 164,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 16.92,
                "move_speed": 3900
            },
            {
                "level": 9,
                "hp": 5467,
                "attack": 240,
                "defense": 220,
                "sp_attack": 59,
                "sp_defense": 182,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 18.1,
                "move_speed": 4050
            },
            {
                "level": 10,
                "hp": 5882,
                "attack": 252,
                "defense": 244,
                "sp_attack": 66,
                "sp_defense": 202,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 19.46,
                "move_speed": 4050
            },
            {
                "level": 11,
                "hp": 6359,
                "attack": 266,
                "defense": 272,
                "sp_attack": 74,
                "sp_defense": 225,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 21.02,
                "move_speed": 4200
            },
            {
                "level": 12,
                "hp": 6908,
                "attack": 282,
                "defense": 304,
                "sp_attack": 83,
                "sp_defense": 252,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 22.82,
                "move_speed": 4200
            },
            {
                "level": 13,
                "hp": 7539,
                "attack": 300,
                "defense": 341,
                "sp_attack": 93,
                "sp_defense": 283,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 24.89,
                "move_speed": 4200
            },
            {
                "level": 14,
                "hp": 8265,
                "attack": 321,
                "defense": 384,
                "sp_attack": 104,
                "sp_defense": 319,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 27.27,
                "move_speed": 4200
            },
            {
                "level": 15,
                "hp": 9099,
                "attack": 345,
                "defense": 433,
                "sp_attack": 117,
                "sp_defense": 360,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 30,
                "move_speed": 4200
            }
        ]
    },
    {
        "name": "Greninja",
        "level": [
            {
                "level": 1,
                "hp": 3000,
                "attack": 146,
                "defense": 50,
                "sp_attack": 20,
                "sp_defense": 30,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3600
            },
            {
                "level": 2,
                "hp": 3031,
                "attack": 151,
                "defense": 53,
                "sp_attack": 21,
                "sp_defense": 32,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 11.57,
                "move_speed": 3600
            },
            {
                "level": 3,
                "hp": 3068,
                "attack": 157,
                "defense": 56,
                "sp_attack": 23,
                "sp_defense": 34,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 13.46,
                "move_speed": 3600
            },
            {
                "level": 4,
                "hp": 3112,
                "attack": 164,
                "defense": 60,
                "sp_attack": 25,
                "sp_defense": 36,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 15.73,
                "move_speed": 3600
            },
            {
                "level": 5,
                "hp": 3273,
                "attack": 191,
                "defense": 75,
                "sp_attack": 32,
                "sp_defense": 45,
                "crit": 15,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 23.96,
                "move_speed": 3750
            },
            {
                "level": 6,
                "hp": 3337,
                "attack": 202,
                "defense": 81,
                "sp_attack": 35,
                "sp_defense": 49,
                "crit": 15,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 27.24,
                "move_speed": 3750
            },
            {
                "level": 7,
                "hp": 3629,
                "attack": 250,
                "defense": 108,
                "sp_attack": 49,
                "sp_defense": 65,
                "crit": 15,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 42.17,
                "move_speed": 3900
            },
            {
                "level": 8,
                "hp": 3721,
                "attack": 265,
                "defense": 117,
                "sp_attack": 53,
                "sp_defense": 70,
                "crit": 15,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 46.89,
                "move_speed": 3900
            },
            {
                "level": 9,
                "hp": 3832,
                "attack": 283,
                "defense": 127,
                "sp_attack": 58,
                "sp_defense": 76,
                "crit": 30,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 52.55,
                "move_speed": 4050
            },
            {
                "level": 10,
                "hp": 3965,
                "attack": 305,
                "defense": 139,
                "sp_attack": 64,
                "sp_defense": 83,
                "crit": 30,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 59.34,
                "move_speed": 4050
            },
            {
                "level": 11,
                "hp": 4125,
                "attack": 331,
                "defense": 154,
                "sp_attack": 71,
                "sp_defense": 92,
                "crit": 30,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 67.5,
                "move_speed": 4200
            },
            {
                "level": 12,
                "hp": 4316,
                "attack": 363,
                "defense": 172,
                "sp_attack": 80,
                "sp_defense": 103,
                "crit": 30,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 77.28,
                "move_speed": 4200
            },
            {
                "level": 13,
                "hp": 4546,
                "attack": 401,
                "defense": 193,
                "sp_attack": 91,
                "sp_defense": 116,
                "crit": 30,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 89.02,
                "move_speed": 4200
            },
            {
                "level": 14,
                "hp": 4821,
                "attack": 446,
                "defense": 219,
                "sp_attack": 104,
                "sp_defense": 131,
                "crit": 30,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 103.1,
                "move_speed": 4200
            },
            {
                "level": 15,
                "hp": 5152,
                "attack": 500,
                "defense": 250,
                "sp_attack": 119,
                "sp_defense": 149,
                "crit": 30,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 120,
                "move_speed": 4200
            }
        ]
    },
    {
        "name": "Gyarados",
        "level": [
            {
                "level": 1,
                "hp": 3100,
                "attack": 140,
                "defense": 80,
                "sp_attack": 20,
                "sp_defense": 60,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3700
            },
            {
                "level": 2,
                "hp": 3239,
                "attack": 149,
                "defense": 91,
                "sp_attack": 23,
                "sp_defense": 69,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3700
            },
            {
                "level": 3,
                "hp": 3392,
                "attack": 159,
                "defense": 104,
                "sp_attack": 27,
                "sp_defense": 78,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3700
            },
            {
                "level": 4,
                "hp": 3560,
                "attack": 170,
                "defense": 118,
                "sp_attack": 31,
                "sp_defense": 88,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3700
            },
            {
                "level": 5,
                "hp": 3744,
                "attack": 182,
                "defense": 133,
                "sp_attack": 35,
                "sp_defense": 99,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 10,
                "move_speed": 3850
            },
            {
                "level": 6,
                "hp": 3947,
                "attack": 196,
                "defense": 150,
                "sp_attack": 40,
                "sp_defense": 112,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 10,
                "move_speed": 3850
            },
            {
                "level": 7,
                "hp": 4170,
                "attack": 211,
                "defense": 168,
                "sp_attack": 45,
                "sp_defense": 126,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 10,
                "move_speed": 4000
            },
            {
                "level": 8,
                "hp": 4416,
                "attack": 228,
                "defense": 188,
                "sp_attack": 51,
                "sp_defense": 141,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 10,
                "move_speed": 4000
            },
            {
                "level": 9,
                "hp": 4687,
                "attack": 246,
                "defense": 210,
                "sp_attack": 58,
                "sp_defense": 158,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 10,
                "move_speed": 4150
            },
            {
                "level": 10,
                "hp": 4986,
                "attack": 266,
                "defense": 234,
                "sp_attack": 65,
                "sp_defense": 176,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 10,
                "move_speed": 4150
            },
            {
                "level": 11,
                "hp": 5316,
                "attack": 288,
                "defense": 261,
                "sp_attack": 73,
                "sp_defense": 196,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 10,
                "move_speed": 4300
            },
            {
                "level": 12,
                "hp": 5678,
                "attack": 312,
                "defense": 291,
                "sp_attack": 82,
                "sp_defense": 218,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 10,
                "move_speed": 4300
            },
            {
                "level": 13,
                "hp": 6077,
                "attack": 339,
                "defense": 324,
                "sp_attack": 92,
                "sp_defense": 243,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 10,
                "move_speed": 4300
            },
            {
                "level": 14,
                "hp": 6516,
                "attack": 368,
                "defense": 360,
                "sp_attack": 103,
                "sp_defense": 270,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 10,
                "move_speed": 4300
            },
            {
                "level": 15,
                "hp": 7000,
                "attack": 400,
                "defense": 400,
                "sp_attack": 115,
                "sp_defense": 300,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 10,
                "move_speed": 4300
            }
        ]
    },
    {
        "name": "Ho-Oh",
        "level": [
            {
                "level": 1,
                "hp": 3400,
                "attack": 170,
                "defense": 90,
                "sp_attack": 20,
                "sp_defense": 70,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3700
            },
            {
                "level": 2,
                "hp": 3631,
                "attack": 177,
                "defense": 106,
                "sp_attack": 23,
                "sp_defense": 82,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.71,
                "move_speed": 3700
            },
            {
                "level": 3,
                "hp": 3886,
                "attack": 185,
                "defense": 124,
                "sp_attack": 27,
                "sp_defense": 96,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 11.49,
                "move_speed": 3700
            },
            {
                "level": 4,
                "hp": 4166,
                "attack": 194,
                "defense": 143,
                "sp_attack": 31,
                "sp_defense": 111,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 12.35,
                "move_speed": 3700
            },
            {
                "level": 5,
                "hp": 4473,
                "attack": 204,
                "defense": 164,
                "sp_attack": 36,
                "sp_defense": 128,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 13.3,
                "move_speed": 3850
            },
            {
                "level": 6,
                "hp": 4812,
                "attack": 215,
                "defense": 187,
                "sp_attack": 41,
                "sp_defense": 146,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 14.34,
                "move_speed": 3850
            },
            {
                "level": 7,
                "hp": 5184,
                "attack": 227,
                "defense": 213,
                "sp_attack": 46,
                "sp_defense": 166,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 15.49,
                "move_speed": 4000
            },
            {
                "level": 8,
                "hp": 5594,
                "attack": 240,
                "defense": 241,
                "sp_attack": 52,
                "sp_defense": 188,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 16.75,
                "move_speed": 4000
            },
            {
                "level": 9,
                "hp": 6046,
                "attack": 255,
                "defense": 272,
                "sp_attack": 59,
                "sp_defense": 212,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 18.14,
                "move_speed": 4150
            },
            {
                "level": 10,
                "hp": 6544,
                "attack": 271,
                "defense": 307,
                "sp_attack": 66,
                "sp_defense": 239,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 19.67,
                "move_speed": 4150
            },
            {
                "level": 11,
                "hp": 7093,
                "attack": 289,
                "defense": 345,
                "sp_attack": 74,
                "sp_defense": 269,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 21.36,
                "move_speed": 4300
            },
            {
                "level": 12,
                "hp": 7697,
                "attack": 309,
                "defense": 387,
                "sp_attack": 83,
                "sp_defense": 302,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 23.22,
                "move_speed": 4300
            },
            {
                "level": 13,
                "hp": 8362,
                "attack": 330,
                "defense": 433,
                "sp_attack": 93,
                "sp_defense": 338,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 25.27,
                "move_speed": 4300
            },
            {
                "level": 14,
                "hp": 9094,
                "attack": 354,
                "defense": 484,
                "sp_attack": 104,
                "sp_defense": 377,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 27.52,
                "move_speed": 4300
            },
            {
                "level": 15,
                "hp": 9900,
                "attack": 380,
                "defense": 540,
                "sp_attack": 116,
                "sp_defense": 420,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 30,
                "move_speed": 4300
            }
        ]
    },
    {
        "name": "Hoopa",
        "level": [
            {
                "level": 1,
                "hp": 3278,
                "attack": 130,
                "defense": 72,
                "sp_attack": 40,
                "sp_defense": 50,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3700
            },
            {
                "level": 2,
                "hp": 3443,
                "attack": 136,
                "defense": 80,
                "sp_attack": 61,
                "sp_defense": 55,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 11.07,
                "move_speed": 3700
            },
            {
                "level": 3,
                "hp": 3624,
                "attack": 143,
                "defense": 89,
                "sp_attack": 84,
                "sp_defense": 61,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 12.24,
                "move_speed": 3700
            },
            {
                "level": 4,
                "hp": 3823,
                "attack": 151,
                "defense": 99,
                "sp_attack": 109,
                "sp_defense": 67,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 13.53,
                "move_speed": 3700
            },
            {
                "level": 5,
                "hp": 4041,
                "attack": 160,
                "defense": 110,
                "sp_attack": 136,
                "sp_defense": 74,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 14.95,
                "move_speed": 3850
            },
            {
                "level": 6,
                "hp": 4282,
                "attack": 169,
                "defense": 122,
                "sp_attack": 166,
                "sp_defense": 82,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 16.51,
                "move_speed": 3850
            },
            {
                "level": 7,
                "hp": 4547,
                "attack": 179,
                "defense": 135,
                "sp_attack": 199,
                "sp_defense": 91,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 18.23,
                "move_speed": 4000
            },
            {
                "level": 8,
                "hp": 4839,
                "attack": 190,
                "defense": 149,
                "sp_attack": 236,
                "sp_defense": 100,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 20.12,
                "move_speed": 4000
            },
            {
                "level": 9,
                "hp": 5161,
                "attack": 203,
                "defense": 165,
                "sp_attack": 276,
                "sp_defense": 110,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 22.21,
                "move_speed": 4150
            },
            {
                "level": 10,
                "hp": 5516,
                "attack": 217,
                "defense": 182,
                "sp_attack": 320,
                "sp_defense": 122,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 24.51,
                "move_speed": 4150
            },
            {
                "level": 11,
                "hp": 5906,
                "attack": 232,
                "defense": 201,
                "sp_attack": 369,
                "sp_defense": 135,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 27.04,
                "move_speed": 4300
            },
            {
                "level": 12,
                "hp": 6335,
                "attack": 249,
                "defense": 222,
                "sp_attack": 423,
                "sp_defense": 149,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 29.83,
                "move_speed": 4300
            },
            {
                "level": 13,
                "hp": 6808,
                "attack": 267,
                "defense": 245,
                "sp_attack": 482,
                "sp_defense": 164,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 32.9,
                "move_speed": 4300
            },
            {
                "level": 14,
                "hp": 7329,
                "attack": 287,
                "defense": 271,
                "sp_attack": 547,
                "sp_defense": 181,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 36.28,
                "move_speed": 4300
            },
            {
                "level": 15,
                "hp": 7902,
                "attack": 309,
                "defense": 299,
                "sp_attack": 619,
                "sp_defense": 200,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 40,
                "move_speed": 4300
            }
        ]
    },
    {
        "name": "Inteleon",
        "level": [
            {
                "level": 1,
                "hp": 3200,
                "attack": 20,
                "defense": 35,
                "sp_attack": 100,
                "sp_defense": 25,
                "crit": 5,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3700
            },
            {
                "level": 2,
                "hp": 3244,
                "attack": 21,
                "defense": 38,
                "sp_attack": 111,
                "sp_defense": 28,
                "crit": 5,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 11,
                "move_speed": 3700
            },
            {
                "level": 3,
                "hp": 3297,
                "attack": 23,
                "defense": 41,
                "sp_attack": 125,
                "sp_defense": 31,
                "crit": 5,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 12.2,
                "move_speed": 3700
            },
            {
                "level": 4,
                "hp": 3361,
                "attack": 25,
                "defense": 45,
                "sp_attack": 142,
                "sp_defense": 35,
                "crit": 5,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 13.64,
                "move_speed": 3700
            },
            {
                "level": 5,
                "hp": 3593,
                "attack": 32,
                "defense": 59,
                "sp_attack": 202,
                "sp_defense": 50,
                "crit": 5,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 18.88,
                "move_speed": 3850
            },
            {
                "level": 6,
                "hp": 3685,
                "attack": 35,
                "defense": 65,
                "sp_attack": 226,
                "sp_defense": 56,
                "crit": 5,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 20.97,
                "move_speed": 3850
            },
            {
                "level": 7,
                "hp": 4106,
                "attack": 48,
                "defense": 91,
                "sp_attack": 335,
                "sp_defense": 83,
                "crit": 5,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 30.47,
                "move_speed": 4000
            },
            {
                "level": 8,
                "hp": 4239,
                "attack": 52,
                "defense": 99,
                "sp_attack": 369,
                "sp_defense": 92,
                "crit": 5,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 33.47,
                "move_speed": 4000
            },
            {
                "level": 9,
                "hp": 4399,
                "attack": 57,
                "defense": 109,
                "sp_attack": 410,
                "sp_defense": 102,
                "crit": 10,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 37.07,
                "move_speed": 4150
            },
            {
                "level": 10,
                "hp": 4590,
                "attack": 63,
                "defense": 121,
                "sp_attack": 459,
                "sp_defense": 114,
                "crit": 10,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 41.39,
                "move_speed": 4150
            },
            {
                "level": 11,
                "hp": 4820,
                "attack": 70,
                "defense": 135,
                "sp_attack": 518,
                "sp_defense": 129,
                "crit": 10,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 46.58,
                "move_speed": 4300
            },
            {
                "level": 12,
                "hp": 5096,
                "attack": 78,
                "defense": 152,
                "sp_attack": 589,
                "sp_defense": 147,
                "crit": 10,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 52.81,
                "move_speed": 4300
            },
            {
                "level": 13,
                "hp": 5427,
                "attack": 88,
                "defense": 172,
                "sp_attack": 674,
                "sp_defense": 168,
                "crit": 10,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 60.28,
                "move_speed": 4300
            },
            {
                "level": 14,
                "hp": 5824,
                "attack": 100,
                "defense": 196,
                "sp_attack": 777,
                "sp_defense": 194,
                "crit": 10,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 69.24,
                "move_speed": 4300
            },
            {
                "level": 15,
                "hp": 6300,
                "attack": 115,
                "defense": 225,
                "sp_attack": 900,
                "sp_defense": 225,
                "crit": 10,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 80,
                "move_speed": 4300
            }
        ]
    },
    {
        "name": "Lapras",
        "level": [
            {
                "level": 1,
                "hp": 3300,
                "attack": 160,
                "defense": 90,
                "sp_attack": 90,
                "sp_defense": 75,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3700
            },
            {
                "level": 2,
                "hp": 3531,
                "attack": 165,
                "defense": 109,
                "sp_attack": 102,
                "sp_defense": 91,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.71,
                "move_speed": 3700
            },
            {
                "level": 3,
                "hp": 3786,
                "attack": 171,
                "defense": 130,
                "sp_attack": 115,
                "sp_defense": 108,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 11.49,
                "move_speed": 3700
            },
            {
                "level": 4,
                "hp": 4066,
                "attack": 177,
                "defense": 153,
                "sp_attack": 130,
                "sp_defense": 127,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 12.35,
                "move_speed": 3700
            },
            {
                "level": 5,
                "hp": 4373,
                "attack": 184,
                "defense": 178,
                "sp_attack": 146,
                "sp_defense": 148,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 13.3,
                "move_speed": 3850
            },
            {
                "level": 6,
                "hp": 4712,
                "attack": 192,
                "defense": 206,
                "sp_attack": 164,
                "sp_defense": 171,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 14.34,
                "move_speed": 3850
            },
            {
                "level": 7,
                "hp": 5084,
                "attack": 201,
                "defense": 237,
                "sp_attack": 183,
                "sp_defense": 196,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 15.49,
                "move_speed": 4000
            },
            {
                "level": 8,
                "hp": 5494,
                "attack": 210,
                "defense": 271,
                "sp_attack": 204,
                "sp_defense": 224,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 16.75,
                "move_speed": 4000
            },
            {
                "level": 9,
                "hp": 5946,
                "attack": 220,
                "defense": 308,
                "sp_attack": 228,
                "sp_defense": 254,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 18.14,
                "move_speed": 4150
            },
            {
                "level": 10,
                "hp": 6444,
                "attack": 232,
                "defense": 349,
                "sp_attack": 254,
                "sp_defense": 288,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 19.67,
                "move_speed": 4150
            },
            {
                "level": 11,
                "hp": 6993,
                "attack": 245,
                "defense": 394,
                "sp_attack": 283,
                "sp_defense": 325,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 21.36,
                "move_speed": 4300
            },
            {
                "level": 12,
                "hp": 7597,
                "attack": 259,
                "defense": 444,
                "sp_attack": 315,
                "sp_defense": 366,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 23.22,
                "move_speed": 4300
            },
            {
                "level": 13,
                "hp": 8262,
                "attack": 274,
                "defense": 499,
                "sp_attack": 350,
                "sp_defense": 411,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 25.27,
                "move_speed": 4300
            },
            {
                "level": 14,
                "hp": 8994,
                "attack": 291,
                "defense": 559,
                "sp_attack": 388,
                "sp_defense": 460,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 27.52,
                "move_speed": 4300
            },
            {
                "level": 15,
                "hp": 9800,
                "attack": 310,
                "defense": 625,
                "sp_attack": 430,
                "sp_defense": 512,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 30,
                "move_speed": 4300
            }
        ]
    },
    {
        "name": "Leafeon",
        "level": [
            {
                "level": 1,
                "hp": 3100,
                "attack": 160,
                "defense": 40,
                "sp_attack": 20,
                "sp_defense": 30,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3650
            },
            {
                "level": 2,
                "hp": 3170,
                "attack": 171,
                "defense": 46,
                "sp_attack": 22,
                "sp_defense": 34,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.44,
                "move_speed": 3650
            },
            {
                "level": 3,
                "hp": 3250,
                "attack": 184,
                "defense": 52,
                "sp_attack": 24,
                "sp_defense": 39,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.95,
                "move_speed": 3650
            },
            {
                "level": 4,
                "hp": 3658,
                "attack": 249,
                "defense": 84,
                "sp_attack": 36,
                "sp_defense": 62,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 13.54,
                "move_speed": 3650
            },
            {
                "level": 5,
                "hp": 3764,
                "attack": 266,
                "defense": 92,
                "sp_attack": 39,
                "sp_defense": 68,
                "crit": 5,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 14.22,
                "move_speed": 3800
            },
            {
                "level": 6,
                "hp": 3886,
                "attack": 285,
                "defense": 102,
                "sp_attack": 43,
                "sp_defense": 75,
                "crit": 5,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 15,
                "move_speed": 3800
            },
            {
                "level": 7,
                "hp": 4027,
                "attack": 307,
                "defense": 113,
                "sp_attack": 47,
                "sp_defense": 83,
                "crit": 5,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 15.89,
                "move_speed": 3950
            },
            {
                "level": 8,
                "hp": 4189,
                "attack": 333,
                "defense": 126,
                "sp_attack": 52,
                "sp_defense": 92,
                "crit": 5,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 16.92,
                "move_speed": 3950
            },
            {
                "level": 9,
                "hp": 4375,
                "attack": 363,
                "defense": 141,
                "sp_attack": 58,
                "sp_defense": 103,
                "crit": 10,
                "cdr": 20,
                "lifesteal": 0,
                "attack_speed": 18.1,
                "move_speed": 4100
            },
            {
                "level": 10,
                "hp": 4589,
                "attack": 397,
                "defense": 158,
                "sp_attack": 65,
                "sp_defense": 115,
                "crit": 10,
                "cdr": 20,
                "lifesteal": 0,
                "attack_speed": 19.46,
                "move_speed": 4100
            },
            {
                "level": 11,
                "hp": 4835,
                "attack": 436,
                "defense": 178,
                "sp_attack": 73,
                "sp_defense": 129,
                "crit": 10,
                "cdr": 20,
                "lifesteal": 0,
                "attack_speed": 21.02,
                "move_speed": 4250
            },
            {
                "level": 12,
                "hp": 5118,
                "attack": 481,
                "defense": 200,
                "sp_attack": 82,
                "sp_defense": 145,
                "crit": 10,
                "cdr": 20,
                "lifesteal": 0,
                "attack_speed": 22.82,
                "move_speed": 4250
            },
            {
                "level": 13,
                "hp": 5444,
                "attack": 533,
                "defense": 226,
                "sp_attack": 92,
                "sp_defense": 164,
                "crit": 10,
                "cdr": 20,
                "lifesteal": 0,
                "attack_speed": 24.89,
                "move_speed": 4250
            },
            {
                "level": 14,
                "hp": 5819,
                "attack": 592,
                "defense": 256,
                "sp_attack": 103,
                "sp_defense": 185,
                "crit": 10,
                "cdr": 20,
                "lifesteal": 0,
                "attack_speed": 27.27,
                "move_speed": 4250
            },
            {
                "level": 15,
                "hp": 6250,
                "attack": 660,
                "defense": 290,
                "sp_attack": 116,
                "sp_defense": 210,
                "crit": 10,
                "cdr": 20,
                "lifesteal": 0,
                "attack_speed": 30,
                "move_speed": 4250
            }
        ]
    },
    {
        "name": "Lucario",
        "level": [
            {
                "level": 1,
                "hp": 3250,
                "attack": 160,
                "defense": 78,
                "sp_attack": 20,
                "sp_defense": 60,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3700
            },
            {
                "level": 2,
                "hp": 3392,
                "attack": 170,
                "defense": 89,
                "sp_attack": 23,
                "sp_defense": 69,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 11.07,
                "move_speed": 3700
            },
            {
                "level": 3,
                "hp": 3549,
                "attack": 180,
                "defense": 101,
                "sp_attack": 27,
                "sp_defense": 78,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 12.24,
                "move_speed": 3700
            },
            {
                "level": 4,
                "hp": 3721,
                "attack": 192,
                "defense": 114,
                "sp_attack": 31,
                "sp_defense": 88,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 13.53,
                "move_speed": 3700
            },
            {
                "level": 5,
                "hp": 3910,
                "attack": 205,
                "defense": 129,
                "sp_attack": 35,
                "sp_defense": 99,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 14.95,
                "move_speed": 3850
            },
            {
                "level": 6,
                "hp": 4118,
                "attack": 219,
                "defense": 145,
                "sp_attack": 40,
                "sp_defense": 112,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 16.51,
                "move_speed": 3850
            },
            {
                "level": 7,
                "hp": 4347,
                "attack": 234,
                "defense": 163,
                "sp_attack": 45,
                "sp_defense": 126,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 18.23,
                "move_speed": 4000
            },
            {
                "level": 8,
                "hp": 4599,
                "attack": 251,
                "defense": 183,
                "sp_attack": 51,
                "sp_defense": 141,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 20.12,
                "move_speed": 4000
            },
            {
                "level": 9,
                "hp": 4877,
                "attack": 270,
                "defense": 205,
                "sp_attack": 58,
                "sp_defense": 158,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 22.21,
                "move_speed": 4150
            },
            {
                "level": 10,
                "hp": 5184,
                "attack": 291,
                "defense": 229,
                "sp_attack": 65,
                "sp_defense": 176,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 24.51,
                "move_speed": 4150
            },
            {
                "level": 11,
                "hp": 5522,
                "attack": 314,
                "defense": 255,
                "sp_attack": 73,
                "sp_defense": 196,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 27.04,
                "move_speed": 4300
            },
            {
                "level": 12,
                "hp": 5894,
                "attack": 339,
                "defense": 284,
                "sp_attack": 82,
                "sp_defense": 218,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 29.83,
                "move_speed": 4300
            },
            {
                "level": 13,
                "hp": 6303,
                "attack": 366,
                "defense": 316,
                "sp_attack": 92,
                "sp_defense": 243,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 32.9,
                "move_speed": 4300
            },
            {
                "level": 14,
                "hp": 6753,
                "attack": 396,
                "defense": 351,
                "sp_attack": 103,
                "sp_defense": 270,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 36.28,
                "move_speed": 4300
            },
            {
                "level": 15,
                "hp": 7249,
                "attack": 429,
                "defense": 390,
                "sp_attack": 115,
                "sp_defense": 300,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 40,
                "move_speed": 4300
            }
        ]
    },
    {
        "name": "Machamp",
        "level": [
            {
                "level": 1,
                "hp": 3250,
                "attack": 165,
                "defense": 100,
                "sp_attack": 20,
                "sp_defense": 70,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3700
            },
            {
                "level": 2,
                "hp": 3313,
                "attack": 170,
                "defense": 106,
                "sp_attack": 21,
                "sp_defense": 74,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.29,
                "move_speed": 3700
            },
            {
                "level": 3,
                "hp": 3389,
                "attack": 175,
                "defense": 113,
                "sp_attack": 23,
                "sp_defense": 79,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.63,
                "move_speed": 3700
            },
            {
                "level": 4,
                "hp": 3480,
                "attack": 181,
                "defense": 121,
                "sp_attack": 25,
                "sp_defense": 85,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 11.04,
                "move_speed": 3700
            },
            {
                "level": 5,
                "hp": 3809,
                "attack": 205,
                "defense": 152,
                "sp_attack": 32,
                "sp_defense": 106,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 12.54,
                "move_speed": 3850
            },
            {
                "level": 6,
                "hp": 3940,
                "attack": 214,
                "defense": 164,
                "sp_attack": 35,
                "sp_defense": 114,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 13.14,
                "move_speed": 3850
            },
            {
                "level": 7,
                "hp": 4097,
                "attack": 225,
                "defense": 179,
                "sp_attack": 38,
                "sp_defense": 124,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 13.86,
                "move_speed": 4000
            },
            {
                "level": 8,
                "hp": 4286,
                "attack": 239,
                "defense": 197,
                "sp_attack": 42,
                "sp_defense": 136,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 14.72,
                "move_speed": 4000
            },
            {
                "level": 9,
                "hp": 4953,
                "attack": 287,
                "defense": 259,
                "sp_attack": 56,
                "sp_defense": 178,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 17.75,
                "move_speed": 4150
            },
            {
                "level": 10,
                "hp": 5225,
                "attack": 306,
                "defense": 284,
                "sp_attack": 62,
                "sp_defense": 195,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 18.98,
                "move_speed": 4150
            },
            {
                "level": 11,
                "hp": 5551,
                "attack": 329,
                "defense": 314,
                "sp_attack": 69,
                "sp_defense": 216,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 20.46,
                "move_speed": 4300
            },
            {
                "level": 12,
                "hp": 5942,
                "attack": 357,
                "defense": 350,
                "sp_attack": 77,
                "sp_defense": 241,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 22.24,
                "move_speed": 4300
            },
            {
                "level": 13,
                "hp": 6411,
                "attack": 391,
                "defense": 394,
                "sp_attack": 87,
                "sp_defense": 271,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 20,
                "attack_speed": 24.37,
                "move_speed": 4300
            },
            {
                "level": 14,
                "hp": 6974,
                "attack": 431,
                "defense": 447,
                "sp_attack": 99,
                "sp_defense": 307,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 20,
                "attack_speed": 26.93,
                "move_speed": 4300
            },
            {
                "level": 15,
                "hp": 7650,
                "attack": 479,
                "defense": 510,
                "sp_attack": 114,
                "sp_defense": 350,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 20,
                "attack_speed": 30,
                "move_speed": 4300
            }
        ]
    },
    {
        "name": "Mamoswine",
        "level": [
            {
                "level": 1,
                "hp": 3280,
                "attack": 170,
                "defense": 85,
                "sp_attack": 20,
                "sp_defense": 65,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3600
            },
            {
                "level": 2,
                "hp": 3371,
                "attack": 172,
                "defense": 91,
                "sp_attack": 21,
                "sp_defense": 70,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.29,
                "move_speed": 3600
            },
            {
                "level": 3,
                "hp": 3480,
                "attack": 175,
                "defense": 98,
                "sp_attack": 23,
                "sp_defense": 75,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.63,
                "move_speed": 3600
            },
            {
                "level": 4,
                "hp": 3611,
                "attack": 178,
                "defense": 107,
                "sp_attack": 25,
                "sp_defense": 81,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 11.04,
                "move_speed": 3600
            },
            {
                "level": 5,
                "hp": 4087,
                "attack": 190,
                "defense": 139,
                "sp_attack": 32,
                "sp_defense": 105,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 12.54,
                "move_speed": 3750
            },
            {
                "level": 6,
                "hp": 4277,
                "attack": 195,
                "defense": 152,
                "sp_attack": 35,
                "sp_defense": 114,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 13.14,
                "move_speed": 3750
            },
            {
                "level": 7,
                "hp": 4505,
                "attack": 201,
                "defense": 167,
                "sp_attack": 38,
                "sp_defense": 125,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 13.86,
                "move_speed": 3900
            },
            {
                "level": 8,
                "hp": 4778,
                "attack": 208,
                "defense": 185,
                "sp_attack": 42,
                "sp_defense": 139,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 14.72,
                "move_speed": 3900
            },
            {
                "level": 9,
                "hp": 5743,
                "attack": 231,
                "defense": 249,
                "sp_attack": 57,
                "sp_defense": 187,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 17.75,
                "move_speed": 4050
            },
            {
                "level": 10,
                "hp": 6136,
                "attack": 240,
                "defense": 275,
                "sp_attack": 63,
                "sp_defense": 206,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 18.98,
                "move_speed": 4050
            },
            {
                "level": 11,
                "hp": 6608,
                "attack": 251,
                "defense": 307,
                "sp_attack": 70,
                "sp_defense": 229,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 20.46,
                "move_speed": 4200
            },
            {
                "level": 12,
                "hp": 7174,
                "attack": 265,
                "defense": 345,
                "sp_attack": 79,
                "sp_defense": 257,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 22.24,
                "move_speed": 4200
            },
            {
                "level": 13,
                "hp": 7854,
                "attack": 281,
                "defense": 390,
                "sp_attack": 89,
                "sp_defense": 291,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 24.37,
                "move_speed": 4200
            },
            {
                "level": 14,
                "hp": 8669,
                "attack": 301,
                "defense": 445,
                "sp_attack": 101,
                "sp_defense": 331,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 26.93,
                "move_speed": 4200
            },
            {
                "level": 15,
                "hp": 9648,
                "attack": 325,
                "defense": 510,
                "sp_attack": 116,
                "sp_defense": 379,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 30,
                "move_speed": 4200
            }
        ]
    },
    {
        "name": "Meowscarada",
        "level": [
            {
                "level": 1,
                "hp": 3100,
                "attack": 160,
                "defense": 50,
                "sp_attack": 20,
                "sp_defense": 40,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3650
            },
            {
                "level": 2,
                "hp": 3146,
                "attack": 167,
                "defense": 53,
                "sp_attack": 21,
                "sp_defense": 42,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.43,
                "move_speed": 3650
            },
            {
                "level": 3,
                "hp": 3201,
                "attack": 175,
                "defense": 57,
                "sp_attack": 23,
                "sp_defense": 45,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.95,
                "move_speed": 3650
            },
            {
                "level": 4,
                "hp": 3427,
                "attack": 208,
                "defense": 74,
                "sp_attack": 30,
                "sp_defense": 56,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 13.07,
                "move_speed": 3650
            },
            {
                "level": 5,
                "hp": 3506,
                "attack": 220,
                "defense": 80,
                "sp_attack": 32,
                "sp_defense": 60,
                "crit": 5,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 13.81,
                "move_speed": 3800
            },
            {
                "level": 6,
                "hp": 3921,
                "attack": 281,
                "defense": 111,
                "sp_attack": 44,
                "sp_defense": 81,
                "crit": 5,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 17.7,
                "move_speed": 3800
            },
            {
                "level": 7,
                "hp": 4035,
                "attack": 298,
                "defense": 120,
                "sp_attack": 47,
                "sp_defense": 87,
                "crit": 5,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 18.77,
                "move_speed": 3950
            },
            {
                "level": 8,
                "hp": 4172,
                "attack": 318,
                "defense": 130,
                "sp_attack": 51,
                "sp_defense": 94,
                "crit": 5,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 20.06,
                "move_speed": 3950
            },
            {
                "level": 9,
                "hp": 4337,
                "attack": 342,
                "defense": 142,
                "sp_attack": 56,
                "sp_defense": 102,
                "crit": 10,
                "cdr": 20,
                "lifesteal": 0,
                "attack_speed": 21.61,
                "move_speed": 4100
            },
            {
                "level": 10,
                "hp": 4535,
                "attack": 371,
                "defense": 157,
                "sp_attack": 62,
                "sp_defense": 112,
                "crit": 10,
                "cdr": 20,
                "lifesteal": 0,
                "attack_speed": 23.46,
                "move_speed": 4100
            },
            {
                "level": 11,
                "hp": 4772,
                "attack": 406,
                "defense": 175,
                "sp_attack": 69,
                "sp_defense": 124,
                "crit": 10,
                "cdr": 20,
                "lifesteal": 0,
                "attack_speed": 25.68,
                "move_speed": 4250
            },
            {
                "level": 12,
                "hp": 5057,
                "attack": 448,
                "defense": 196,
                "sp_attack": 77,
                "sp_defense": 138,
                "crit": 10,
                "cdr": 20,
                "lifesteal": 0,
                "attack_speed": 28.35,
                "move_speed": 4250
            },
            {
                "level": 13,
                "hp": 5398,
                "attack": 498,
                "defense": 222,
                "sp_attack": 87,
                "sp_defense": 155,
                "crit": 10,
                "cdr": 20,
                "lifesteal": 0,
                "attack_speed": 31.55,
                "move_speed": 4250
            },
            {
                "level": 14,
                "hp": 5808,
                "attack": 558,
                "defense": 253,
                "sp_attack": 99,
                "sp_defense": 175,
                "crit": 10,
                "cdr": 20,
                "lifesteal": 0,
                "attack_speed": 35.39,
                "move_speed": 4250
            },
            {
                "level": 15,
                "hp": 6300,
                "attack": 630,
                "defense": 290,
                "sp_attack": 114,
                "sp_defense": 200,
                "crit": 10,
                "cdr": 20,
                "lifesteal": 0,
                "attack_speed": 40,
                "move_speed": 4250
            }
        ]
    },
    {
        "name": "Metagross",
        "level": [
            {
                "level": 1,
                "hp": 3100,
                "attack": 160,
                "defense": 85,
                "sp_attack": 20,
                "sp_defense": 70,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3700
            },
            {
                "level": 2,
                "hp": 3172,
                "attack": 165,
                "defense": 92,
                "sp_attack": 21,
                "sp_defense": 75,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.29,
                "move_speed": 3700
            },
            {
                "level": 3,
                "hp": 3259,
                "attack": 171,
                "defense": 100,
                "sp_attack": 23,
                "sp_defense": 81,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.63,
                "move_speed": 3700
            },
            {
                "level": 4,
                "hp": 3363,
                "attack": 179,
                "defense": 110,
                "sp_attack": 25,
                "sp_defense": 88,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 11.04,
                "move_speed": 3700
            },
            {
                "level": 5,
                "hp": 3741,
                "attack": 207,
                "defense": 145,
                "sp_attack": 32,
                "sp_defense": 113,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 12.54,
                "move_speed": 3850
            },
            {
                "level": 6,
                "hp": 3891,
                "attack": 218,
                "defense": 159,
                "sp_attack": 35,
                "sp_defense": 123,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 13.14,
                "move_speed": 3850
            },
            {
                "level": 7,
                "hp": 4072,
                "attack": 231,
                "defense": 176,
                "sp_attack": 38,
                "sp_defense": 135,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 13.86,
                "move_speed": 4000
            },
            {
                "level": 8,
                "hp": 4289,
                "attack": 247,
                "defense": 196,
                "sp_attack": 42,
                "sp_defense": 150,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 14.72,
                "move_speed": 4000
            },
            {
                "level": 9,
                "hp": 5054,
                "attack": 303,
                "defense": 266,
                "sp_attack": 56,
                "sp_defense": 202,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 17.75,
                "move_speed": 4150
            },
            {
                "level": 10,
                "hp": 5366,
                "attack": 326,
                "defense": 295,
                "sp_attack": 62,
                "sp_defense": 223,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 18.98,
                "move_speed": 4150
            },
            {
                "level": 11,
                "hp": 5740,
                "attack": 353,
                "defense": 329,
                "sp_attack": 69,
                "sp_defense": 248,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 20.46,
                "move_speed": 4300
            },
            {
                "level": 12,
                "hp": 6189,
                "attack": 386,
                "defense": 370,
                "sp_attack": 77,
                "sp_defense": 278,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 22.24,
                "move_speed": 4300
            },
            {
                "level": 13,
                "hp": 6728,
                "attack": 426,
                "defense": 420,
                "sp_attack": 87,
                "sp_defense": 314,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 24.37,
                "move_speed": 4300
            },
            {
                "level": 14,
                "hp": 7374,
                "attack": 473,
                "defense": 479,
                "sp_attack": 99,
                "sp_defense": 358,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 26.93,
                "move_speed": 4300
            },
            {
                "level": 15,
                "hp": 8150,
                "attack": 530,
                "defense": 550,
                "sp_attack": 114,
                "sp_defense": 410,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 30,
                "move_speed": 4300
            }
        ]
    },
    {
        "name": "Mew",
        "level": [
            {
                "level": 1,
                "hp": 3300,
                "attack": 130,
                "defense": 50,
                "sp_attack": 90,
                "sp_defense": 50,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3700
            },
            {
                "level": 2,
                "hp": 3414,
                "attack": 136,
                "defense": 56,
                "sp_attack": 119,
                "sp_defense": 55,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.36,
                "move_speed": 3700
            },
            {
                "level": 3,
                "hp": 3539,
                "attack": 143,
                "defense": 63,
                "sp_attack": 151,
                "sp_defense": 60,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.75,
                "move_speed": 3700
            },
            {
                "level": 4,
                "hp": 3677,
                "attack": 150,
                "defense": 71,
                "sp_attack": 186,
                "sp_defense": 66,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 11.18,
                "move_speed": 3700
            },
            {
                "level": 5,
                "hp": 3828,
                "attack": 158,
                "defense": 80,
                "sp_attack": 224,
                "sp_defense": 72,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 11.65,
                "move_speed": 3850
            },
            {
                "level": 6,
                "hp": 3995,
                "attack": 167,
                "defense": 89,
                "sp_attack": 266,
                "sp_defense": 79,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 12.17,
                "move_speed": 3850
            },
            {
                "level": 7,
                "hp": 4178,
                "attack": 177,
                "defense": 99,
                "sp_attack": 312,
                "sp_defense": 86,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 12.74,
                "move_speed": 4000
            },
            {
                "level": 8,
                "hp": 4380,
                "attack": 188,
                "defense": 110,
                "sp_attack": 363,
                "sp_defense": 94,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 13.37,
                "move_speed": 4000
            },
            {
                "level": 9,
                "hp": 4603,
                "attack": 200,
                "defense": 123,
                "sp_attack": 419,
                "sp_defense": 103,
                "crit": 0,
                "cdr": 15,
                "lifesteal": 0,
                "attack_speed": 14.07,
                "move_speed": 4150
            },
            {
                "level": 10,
                "hp": 4849,
                "attack": 213,
                "defense": 137,
                "sp_attack": 481,
                "sp_defense": 113,
                "crit": 0,
                "cdr": 15,
                "lifesteal": 0,
                "attack_speed": 14.84,
                "move_speed": 4150
            },
            {
                "level": 11,
                "hp": 5119,
                "attack": 227,
                "defense": 152,
                "sp_attack": 550,
                "sp_defense": 124,
                "crit": 0,
                "cdr": 15,
                "lifesteal": 0,
                "attack_speed": 15.68,
                "move_speed": 4300
            },
            {
                "level": 12,
                "hp": 5416,
                "attack": 243,
                "defense": 169,
                "sp_attack": 625,
                "sp_defense": 136,
                "crit": 0,
                "cdr": 15,
                "lifesteal": 0,
                "attack_speed": 16.61,
                "move_speed": 4300
            },
            {
                "level": 13,
                "hp": 5743,
                "attack": 260,
                "defense": 188,
                "sp_attack": 708,
                "sp_defense": 149,
                "crit": 0,
                "cdr": 25,
                "lifesteal": 0,
                "attack_speed": 17.63,
                "move_speed": 4300
            },
            {
                "level": 14,
                "hp": 6103,
                "attack": 279,
                "defense": 208,
                "sp_attack": 799,
                "sp_defense": 164,
                "crit": 0,
                "cdr": 25,
                "lifesteal": 0,
                "attack_speed": 18.76,
                "move_speed": 4300
            },
            {
                "level": 15,
                "hp": 6500,
                "attack": 300,
                "defense": 230,
                "sp_attack": 900,
                "sp_defense": 180,
                "crit": 0,
                "cdr": 25,
                "lifesteal": 0,
                "attack_speed": 20,
                "move_speed": 4300
            }
        ]
    },
    {
        "name": "MewtwoX",
        "level": [
            {
                "level": 1,
                "hp": 3500,
                "attack": 170,
                "defense": 90,
                "sp_attack": 20,
                "sp_defense": 90,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 10,
                "move_speed": 3700
            },
            {
                "level": 2,
                "hp": 3653,
                "attack": 182,
                "defense": 102,
                "sp_attack": 23,
                "sp_defense": 99,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 11.07,
                "move_speed": 3700
            },
            {
                "level": 3,
                "hp": 3821,
                "attack": 195,
                "defense": 115,
                "sp_attack": 27,
                "sp_defense": 109,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 12.24,
                "move_speed": 3700
            },
            {
                "level": 4,
                "hp": 4006,
                "attack": 209,
                "defense": 130,
                "sp_attack": 31,
                "sp_defense": 120,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 13.53,
                "move_speed": 3700
            },
            {
                "level": 5,
                "hp": 4209,
                "attack": 225,
                "defense": 146,
                "sp_attack": 35,
                "sp_defense": 132,
                "crit": 5,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 14.95,
                "move_speed": 3850
            },
            {
                "level": 6,
                "hp": 4433,
                "attack": 242,
                "defense": 164,
                "sp_attack": 40,
                "sp_defense": 145,
                "crit": 5,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 16.51,
                "move_speed": 3850
            },
            {
                "level": 7,
                "hp": 4679,
                "attack": 261,
                "defense": 183,
                "sp_attack": 45,
                "sp_defense": 159,
                "crit": 5,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 18.23,
                "move_speed": 4000
            },
            {
                "level": 8,
                "hp": 4950,
                "attack": 282,
                "defense": 204,
                "sp_attack": 51,
                "sp_defense": 175,
                "crit": 5,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 20.12,
                "move_speed": 4000
            },
            {
                "level": 9,
                "hp": 5249,
                "attack": 305,
                "defense": 228,
                "sp_attack": 58,
                "sp_defense": 192,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 22.21,
                "move_speed": 4150
            },
            {
                "level": 10,
                "hp": 5579,
                "attack": 330,
                "defense": 254,
                "sp_attack": 65,
                "sp_defense": 211,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 24.51,
                "move_speed": 4150
            },
            {
                "level": 11,
                "hp": 5942,
                "attack": 358,
                "defense": 283,
                "sp_attack": 73,
                "sp_defense": 232,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 27.04,
                "move_speed": 4300
            },
            {
                "level": 12,
                "hp": 6342,
                "attack": 388,
                "defense": 315,
                "sp_attack": 82,
                "sp_defense": 255,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 29.83,
                "move_speed": 4300
            },
            {
                "level": 13,
                "hp": 6782,
                "attack": 422,
                "defense": 350,
                "sp_attack": 92,
                "sp_defense": 281,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 32.9,
                "move_speed": 4300
            },
            {
                "level": 14,
                "hp": 7267,
                "attack": 459,
                "defense": 388,
                "sp_attack": 103,
                "sp_defense": 309,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 36.28,
                "move_speed": 4300
            },
            {
                "level": 15,
                "hp": 7800,
                "attack": 500,
                "defense": 430,
                "sp_attack": 115,
                "sp_defense": 340,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 40,
                "move_speed": 4300
            }
        ]
    },
    {
        "name": "MewtwoY",
        "level": [
            {
                "level": 1,
                "hp": 3400,
                "attack": 20,
                "defense": 50,
                "sp_attack": 150,
                "sp_defense": 50,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3650
            },
            {
                "level": 2,
                "hp": 3510,
                "attack": 23,
                "defense": 55,
                "sp_attack": 172,
                "sp_defense": 55,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 11.42,
                "move_speed": 3650
            },
            {
                "level": 3,
                "hp": 3631,
                "attack": 27,
                "defense": 61,
                "sp_attack": 197,
                "sp_defense": 60,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 12.99,
                "move_speed": 3650
            },
            {
                "level": 4,
                "hp": 3764,
                "attack": 31,
                "defense": 67,
                "sp_attack": 224,
                "sp_defense": 66,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 14.71,
                "move_speed": 3650
            },
            {
                "level": 5,
                "hp": 3910,
                "attack": 36,
                "defense": 74,
                "sp_attack": 254,
                "sp_defense": 72,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 16.6,
                "move_speed": 3800
            },
            {
                "level": 6,
                "hp": 4072,
                "attack": 41,
                "defense": 82,
                "sp_attack": 287,
                "sp_defense": 79,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 18.68,
                "move_speed": 3800
            },
            {
                "level": 7,
                "hp": 4250,
                "attack": 46,
                "defense": 91,
                "sp_attack": 323,
                "sp_defense": 86,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 20.97,
                "move_speed": 3950
            },
            {
                "level": 8,
                "hp": 4446,
                "attack": 52,
                "defense": 100,
                "sp_attack": 363,
                "sp_defense": 94,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 23.49,
                "move_speed": 3950
            },
            {
                "level": 9,
                "hp": 4662,
                "attack": 59,
                "defense": 110,
                "sp_attack": 407,
                "sp_defense": 103,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 26.27,
                "move_speed": 4100
            },
            {
                "level": 10,
                "hp": 4900,
                "attack": 66,
                "defense": 122,
                "sp_attack": 455,
                "sp_defense": 113,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 29.34,
                "move_speed": 4100
            },
            {
                "level": 11,
                "hp": 5162,
                "attack": 74,
                "defense": 135,
                "sp_attack": 508,
                "sp_defense": 124,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 32.72,
                "move_speed": 4250
            },
            {
                "level": 12,
                "hp": 5450,
                "attack": 83,
                "defense": 149,
                "sp_attack": 567,
                "sp_defense": 136,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 36.44,
                "move_speed": 4250
            },
            {
                "level": 13,
                "hp": 5767,
                "attack": 93,
                "defense": 164,
                "sp_attack": 631,
                "sp_defense": 149,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 40.53,
                "move_speed": 4250
            },
            {
                "level": 14,
                "hp": 6116,
                "attack": 104,
                "defense": 181,
                "sp_attack": 702,
                "sp_defense": 164,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 45.03,
                "move_speed": 4250
            },
            {
                "level": 15,
                "hp": 6500,
                "attack": 116,
                "defense": 200,
                "sp_attack": 780,
                "sp_defense": 180,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 49.99,
                "move_speed": 4250
            }
        ]
    },
    {
        "name": "Mimikyu",
        "level": [
            {
                "level": 1,
                "hp": 3150,
                "attack": 155,
                "defense": 80,
                "sp_attack": 20,
                "sp_defense": 70,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3700
            },
            {
                "level": 2,
                "hp": 3301,
                "attack": 164,
                "defense": 91,
                "sp_attack": 23,
                "sp_defense": 80,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.71,
                "move_speed": 3700
            },
            {
                "level": 3,
                "hp": 3467,
                "attack": 174,
                "defense": 104,
                "sp_attack": 27,
                "sp_defense": 91,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 11.49,
                "move_speed": 3700
            },
            {
                "level": 4,
                "hp": 3650,
                "attack": 185,
                "defense": 118,
                "sp_attack": 31,
                "sp_defense": 103,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 12.35,
                "move_speed": 3700
            },
            {
                "level": 5,
                "hp": 3851,
                "attack": 198,
                "defense": 133,
                "sp_attack": 35,
                "sp_defense": 117,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 13.3,
                "move_speed": 3850
            },
            {
                "level": 6,
                "hp": 4072,
                "attack": 212,
                "defense": 150,
                "sp_attack": 40,
                "sp_defense": 132,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 14.34,
                "move_speed": 3850
            },
            {
                "level": 7,
                "hp": 4315,
                "attack": 227,
                "defense": 168,
                "sp_attack": 45,
                "sp_defense": 149,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 15.49,
                "move_speed": 4000
            },
            {
                "level": 8,
                "hp": 4583,
                "attack": 244,
                "defense": 188,
                "sp_attack": 51,
                "sp_defense": 167,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 16.75,
                "move_speed": 4000
            },
            {
                "level": 9,
                "hp": 4879,
                "attack": 263,
                "defense": 210,
                "sp_attack": 58,
                "sp_defense": 187,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 18.14,
                "move_speed": 4150
            },
            {
                "level": 10,
                "hp": 5205,
                "attack": 283,
                "defense": 234,
                "sp_attack": 65,
                "sp_defense": 209,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 19.67,
                "move_speed": 4150
            },
            {
                "level": 11,
                "hp": 5564,
                "attack": 305,
                "defense": 261,
                "sp_attack": 73,
                "sp_defense": 234,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 21.36,
                "move_speed": 4300
            },
            {
                "level": 12,
                "hp": 5959,
                "attack": 330,
                "defense": 291,
                "sp_attack": 82,
                "sp_defense": 261,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 23.22,
                "move_speed": 4300
            },
            {
                "level": 13,
                "hp": 6394,
                "attack": 357,
                "defense": 324,
                "sp_attack": 92,
                "sp_defense": 291,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 25.27,
                "move_speed": 4300
            },
            {
                "level": 14,
                "hp": 6873,
                "attack": 387,
                "defense": 360,
                "sp_attack": 103,
                "sp_defense": 324,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 27.52,
                "move_speed": 4300
            },
            {
                "level": 15,
                "hp": 7400,
                "attack": 420,
                "defense": 400,
                "sp_attack": 115,
                "sp_defense": 360,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 30,
                "move_speed": 4300
            }
        ]
    },
    {
        "name": "Miraidon",
        "level": [
            {
                "level": 1,
                "hp": 3300,
                "attack": 140,
                "defense": 70,
                "sp_attack": 100,
                "sp_defense": 80,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3650
            },
            {
                "level": 2,
                "hp": 3432,
                "attack": 147,
                "defense": 77,
                "sp_attack": 132,
                "sp_defense": 86,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.36,
                "move_speed": 3650
            },
            {
                "level": 3,
                "hp": 3577,
                "attack": 154,
                "defense": 85,
                "sp_attack": 167,
                "sp_defense": 92,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.75,
                "move_speed": 3650
            },
            {
                "level": 4,
                "hp": 3736,
                "attack": 162,
                "defense": 94,
                "sp_attack": 206,
                "sp_defense": 99,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 11.18,
                "move_speed": 3650
            },
            {
                "level": 5,
                "hp": 3911,
                "attack": 171,
                "defense": 104,
                "sp_attack": 248,
                "sp_defense": 107,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 11.65,
                "move_speed": 3800
            },
            {
                "level": 6,
                "hp": 4104,
                "attack": 181,
                "defense": 115,
                "sp_attack": 295,
                "sp_defense": 115,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 12.17,
                "move_speed": 3800
            },
            {
                "level": 7,
                "hp": 4316,
                "attack": 192,
                "defense": 127,
                "sp_attack": 347,
                "sp_defense": 124,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 12.74,
                "move_speed": 3950
            },
            {
                "level": 8,
                "hp": 4549,
                "attack": 204,
                "defense": 140,
                "sp_attack": 404,
                "sp_defense": 134,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 13.37,
                "move_speed": 3950
            },
            {
                "level": 9,
                "hp": 4806,
                "attack": 217,
                "defense": 155,
                "sp_attack": 467,
                "sp_defense": 145,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 14.07,
                "move_speed": 4100
            },
            {
                "level": 10,
                "hp": 5090,
                "attack": 232,
                "defense": 171,
                "sp_attack": 536,
                "sp_defense": 157,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 14.84,
                "move_speed": 4100
            },
            {
                "level": 11,
                "hp": 5402,
                "attack": 248,
                "defense": 189,
                "sp_attack": 612,
                "sp_defense": 171,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 15.68,
                "move_speed": 4250
            },
            {
                "level": 12,
                "hp": 5746,
                "attack": 266,
                "defense": 209,
                "sp_attack": 696,
                "sp_defense": 186,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 16.61,
                "move_speed": 4250
            },
            {
                "level": 13,
                "hp": 6124,
                "attack": 285,
                "defense": 230,
                "sp_attack": 788,
                "sp_defense": 202,
                "crit": 0,
                "cdr": 20,
                "lifesteal": 0,
                "attack_speed": 17.63,
                "move_speed": 4250
            },
            {
                "level": 14,
                "hp": 6541,
                "attack": 306,
                "defense": 254,
                "sp_attack": 889,
                "sp_defense": 220,
                "crit": 0,
                "cdr": 20,
                "lifesteal": 0,
                "attack_speed": 18.76,
                "move_speed": 4250
            },
            {
                "level": 15,
                "hp": 7000,
                "attack": 330,
                "defense": 280,
                "sp_attack": 1000,
                "sp_defense": 240,
                "crit": 0,
                "cdr": 20,
                "lifesteal": 0,
                "attack_speed": 20,
                "move_speed": 4250
            }
        ]
    },
    {
        "name": "Mr.Mime",
        "level": [
            {
                "level": 1,
                "hp": 3150,
                "attack": 150,
                "defense": 70,
                "sp_attack": 50,
                "sp_defense": 60,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3800
            },
            {
                "level": 2,
                "hp": 3351,
                "attack": 155,
                "defense": 82,
                "sp_attack": 64,
                "sp_defense": 71,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.71,
                "move_speed": 3800
            },
            {
                "level": 3,
                "hp": 3572,
                "attack": 161,
                "defense": 96,
                "sp_attack": 80,
                "sp_defense": 83,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 11.49,
                "move_speed": 3800
            },
            {
                "level": 4,
                "hp": 3815,
                "attack": 167,
                "defense": 111,
                "sp_attack": 97,
                "sp_defense": 96,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 12.35,
                "move_speed": 3800
            },
            {
                "level": 5,
                "hp": 4082,
                "attack": 174,
                "defense": 128,
                "sp_attack": 116,
                "sp_defense": 110,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 13.29,
                "move_speed": 3950
            },
            {
                "level": 6,
                "hp": 4376,
                "attack": 181,
                "defense": 146,
                "sp_attack": 137,
                "sp_defense": 126,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 14.33,
                "move_speed": 3950
            },
            {
                "level": 7,
                "hp": 4700,
                "attack": 189,
                "defense": 166,
                "sp_attack": 160,
                "sp_defense": 143,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 15.48,
                "move_speed": 4100
            },
            {
                "level": 8,
                "hp": 5057,
                "attack": 198,
                "defense": 188,
                "sp_attack": 185,
                "sp_defense": 162,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 16.74,
                "move_speed": 4100
            },
            {
                "level": 9,
                "hp": 5450,
                "attack": 208,
                "defense": 212,
                "sp_attack": 213,
                "sp_defense": 183,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 18.13,
                "move_speed": 4250
            },
            {
                "level": 10,
                "hp": 5883,
                "attack": 219,
                "defense": 239,
                "sp_attack": 244,
                "sp_defense": 206,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 19.66,
                "move_speed": 4250
            },
            {
                "level": 11,
                "hp": 6360,
                "attack": 231,
                "defense": 269,
                "sp_attack": 278,
                "sp_defense": 231,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 21.35,
                "move_speed": 4400
            },
            {
                "level": 12,
                "hp": 6885,
                "attack": 244,
                "defense": 302,
                "sp_attack": 315,
                "sp_defense": 259,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 23.21,
                "move_speed": 4400
            },
            {
                "level": 13,
                "hp": 7463,
                "attack": 259,
                "defense": 338,
                "sp_attack": 356,
                "sp_defense": 290,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 25.26,
                "move_speed": 4400
            },
            {
                "level": 14,
                "hp": 8099,
                "attack": 275,
                "defense": 377,
                "sp_attack": 401,
                "sp_defense": 324,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 27.51,
                "move_speed": 4400
            },
            {
                "level": 15,
                "hp": 8800,
                "attack": 293,
                "defense": 420,
                "sp_attack": 450,
                "sp_defense": 361,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 29.99,
                "move_speed": 4400
            }
        ]
    },
    {
        "name": "Ninetales",
        "level": [
            {
                "level": 1,
                "hp": 3197,
                "attack": 134,
                "defense": 35,
                "sp_attack": 51,
                "sp_defense": 27,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3700
            },
            {
                "level": 2,
                "hp": 3266,
                "attack": 137,
                "defense": 39,
                "sp_attack": 72,
                "sp_defense": 30,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.44,
                "move_speed": 3700
            },
            {
                "level": 3,
                "hp": 3345,
                "attack": 141,
                "defense": 44,
                "sp_attack": 96,
                "sp_defense": 34,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.95,
                "move_speed": 3700
            },
            {
                "level": 4,
                "hp": 3747,
                "attack": 161,
                "defense": 69,
                "sp_attack": 219,
                "sp_defense": 53,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 13.54,
                "move_speed": 3700
            },
            {
                "level": 5,
                "hp": 3852,
                "attack": 166,
                "defense": 75,
                "sp_attack": 251,
                "sp_defense": 58,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 14.22,
                "move_speed": 3850
            },
            {
                "level": 6,
                "hp": 3972,
                "attack": 172,
                "defense": 82,
                "sp_attack": 288,
                "sp_defense": 64,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 15,
                "move_speed": 3850
            },
            {
                "level": 7,
                "hp": 4110,
                "attack": 179,
                "defense": 90,
                "sp_attack": 330,
                "sp_defense": 71,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 15.89,
                "move_speed": 4000
            },
            {
                "level": 8,
                "hp": 4269,
                "attack": 187,
                "defense": 100,
                "sp_attack": 379,
                "sp_defense": 79,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 16.92,
                "move_speed": 4000
            },
            {
                "level": 9,
                "hp": 4452,
                "attack": 196,
                "defense": 111,
                "sp_attack": 435,
                "sp_defense": 88,
                "crit": 0,
                "cdr": 15,
                "lifesteal": 0,
                "attack_speed": 18.1,
                "move_speed": 4150
            },
            {
                "level": 10,
                "hp": 4663,
                "attack": 207,
                "defense": 124,
                "sp_attack": 500,
                "sp_defense": 98,
                "crit": 0,
                "cdr": 15,
                "lifesteal": 0,
                "attack_speed": 19.46,
                "move_speed": 4150
            },
            {
                "level": 11,
                "hp": 4906,
                "attack": 219,
                "defense": 139,
                "sp_attack": 574,
                "sp_defense": 110,
                "crit": 0,
                "cdr": 15,
                "lifesteal": 0,
                "attack_speed": 21.02,
                "move_speed": 4300
            },
            {
                "level": 12,
                "hp": 5185,
                "attack": 233,
                "defense": 156,
                "sp_attack": 660,
                "sp_defense": 123,
                "crit": 0,
                "cdr": 15,
                "lifesteal": 0,
                "attack_speed": 22.82,
                "move_speed": 4300
            },
            {
                "level": 13,
                "hp": 5506,
                "attack": 249,
                "defense": 176,
                "sp_attack": 759,
                "sp_defense": 138,
                "crit": 0,
                "cdr": 25,
                "lifesteal": 0,
                "attack_speed": 24.89,
                "move_speed": 4300
            },
            {
                "level": 14,
                "hp": 5875,
                "attack": 268,
                "defense": 199,
                "sp_attack": 872,
                "sp_defense": 155,
                "crit": 0,
                "cdr": 25,
                "lifesteal": 0,
                "attack_speed": 27.27,
                "move_speed": 4300
            },
            {
                "level": 15,
                "hp": 6299,
                "attack": 289,
                "defense": 225,
                "sp_attack": 1002,
                "sp_defense": 175,
                "crit": 0,
                "cdr": 25,
                "lifesteal": 0,
                "attack_speed": 30,
                "move_speed": 4300
            }
        ]
    },
    {
        "name": "Pikachu",
        "level": [
            {
                "level": 1,
                "hp": 3292,
                "attack": 134,
                "defense": 35,
                "sp_attack": 50,
                "sp_defense": 27,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3700
            },
            {
                "level": 2,
                "hp": 3399,
                "attack": 140,
                "defense": 40,
                "sp_attack": 82,
                "sp_defense": 31,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3700
            },
            {
                "level": 3,
                "hp": 3517,
                "attack": 146,
                "defense": 45,
                "sp_attack": 117,
                "sp_defense": 35,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3700
            },
            {
                "level": 4,
                "hp": 3646,
                "attack": 153,
                "defense": 51,
                "sp_attack": 156,
                "sp_defense": 40,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3700
            },
            {
                "level": 5,
                "hp": 3788,
                "attack": 160,
                "defense": 58,
                "sp_attack": 199,
                "sp_defense": 45,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3850
            },
            {
                "level": 6,
                "hp": 3945,
                "attack": 168,
                "defense": 65,
                "sp_attack": 246,
                "sp_defense": 51,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3850
            },
            {
                "level": 7,
                "hp": 4117,
                "attack": 177,
                "defense": 73,
                "sp_attack": 298,
                "sp_defense": 57,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 4000
            },
            {
                "level": 8,
                "hp": 4307,
                "attack": 187,
                "defense": 82,
                "sp_attack": 355,
                "sp_defense": 64,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 4000
            },
            {
                "level": 9,
                "hp": 4516,
                "attack": 198,
                "defense": 92,
                "sp_attack": 418,
                "sp_defense": 72,
                "crit": 0,
                "cdr": 15,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 4150
            },
            {
                "level": 10,
                "hp": 4747,
                "attack": 210,
                "defense": 103,
                "sp_attack": 487,
                "sp_defense": 80,
                "crit": 0,
                "cdr": 15,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 4150
            },
            {
                "level": 11,
                "hp": 5001,
                "attack": 223,
                "defense": 115,
                "sp_attack": 563,
                "sp_defense": 89,
                "crit": 0,
                "cdr": 15,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 4300
            },
            {
                "level": 12,
                "hp": 5280,
                "attack": 237,
                "defense": 128,
                "sp_attack": 647,
                "sp_defense": 99,
                "crit": 0,
                "cdr": 15,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 4300
            },
            {
                "level": 13,
                "hp": 5588,
                "attack": 253,
                "defense": 142,
                "sp_attack": 740,
                "sp_defense": 110,
                "crit": 0,
                "cdr": 25,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 4300
            },
            {
                "level": 14,
                "hp": 5927,
                "attack": 271,
                "defense": 158,
                "sp_attack": 842,
                "sp_defense": 122,
                "crit": 0,
                "cdr": 25,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 4300
            },
            {
                "level": 15,
                "hp": 6300,
                "attack": 290,
                "defense": 175,
                "sp_attack": 954,
                "sp_defense": 135,
                "crit": 0,
                "cdr": 25,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 4300
            }
        ]
    },
    {
        "name": "Psyduck",
        "level": [
            {
                "level": 1,
                "hp": 3300,
                "attack": 130,
                "defense": 80,
                "sp_attack": 50,
                "sp_defense": 70,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3700
            },
            {
                "level": 2,
                "hp": 3503,
                "attack": 137,
                "defense": 90,
                "sp_attack": 71,
                "sp_defense": 79,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.36,
                "move_speed": 3700
            },
            {
                "level": 3,
                "hp": 3726,
                "attack": 144,
                "defense": 101,
                "sp_attack": 95,
                "sp_defense": 88,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.75,
                "move_speed": 3700
            },
            {
                "level": 4,
                "hp": 3971,
                "attack": 152,
                "defense": 113,
                "sp_attack": 121,
                "sp_defense": 98,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 11.18,
                "move_speed": 3700
            },
            {
                "level": 5,
                "hp": 4240,
                "attack": 161,
                "defense": 127,
                "sp_attack": 149,
                "sp_defense": 109,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 11.65,
                "move_speed": 3850
            },
            {
                "level": 6,
                "hp": 4537,
                "attack": 171,
                "defense": 142,
                "sp_attack": 180,
                "sp_defense": 122,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 12.17,
                "move_speed": 3850
            },
            {
                "level": 7,
                "hp": 4864,
                "attack": 182,
                "defense": 159,
                "sp_attack": 214,
                "sp_defense": 136,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 12.74,
                "move_speed": 4000
            },
            {
                "level": 8,
                "hp": 5224,
                "attack": 194,
                "defense": 177,
                "sp_attack": 252,
                "sp_defense": 151,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 13.37,
                "move_speed": 4000
            },
            {
                "level": 9,
                "hp": 5621,
                "attack": 207,
                "defense": 197,
                "sp_attack": 294,
                "sp_defense": 168,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 14.07,
                "move_speed": 4150
            },
            {
                "level": 10,
                "hp": 6058,
                "attack": 222,
                "defense": 219,
                "sp_attack": 340,
                "sp_defense": 186,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 14.84,
                "move_speed": 4150
            },
            {
                "level": 11,
                "hp": 6539,
                "attack": 238,
                "defense": 244,
                "sp_attack": 391,
                "sp_defense": 206,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 15.68,
                "move_speed": 4300
            },
            {
                "level": 12,
                "hp": 7068,
                "attack": 256,
                "defense": 271,
                "sp_attack": 447,
                "sp_defense": 228,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 16.61,
                "move_speed": 4300
            },
            {
                "level": 13,
                "hp": 7651,
                "attack": 275,
                "defense": 301,
                "sp_attack": 508,
                "sp_defense": 253,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 17.63,
                "move_speed": 4300
            },
            {
                "level": 14,
                "hp": 8293,
                "attack": 296,
                "defense": 334,
                "sp_attack": 576,
                "sp_defense": 280,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 18.76,
                "move_speed": 4300
            },
            {
                "level": 15,
                "hp": 9000,
                "attack": 320,
                "defense": 370,
                "sp_attack": 650,
                "sp_defense": 310,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 20,
                "move_speed": 4300
            }
        ]
    },
    {
        "name": "Rapidash",
        "level": [
            {
                "level": 1,
                "hp": 3300,
                "attack": 130,
                "defense": 60,
                "sp_attack": 90,
                "sp_defense": 70,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3800
            },
            {
                "level": 2,
                "hp": 3364,
                "attack": 133,
                "defense": 64,
                "sp_attack": 99,
                "sp_defense": 74,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.43,
                "move_speed": 3800
            },
            {
                "level": 3,
                "hp": 3441,
                "attack": 136,
                "defense": 69,
                "sp_attack": 110,
                "sp_defense": 79,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.95,
                "move_speed": 3800
            },
            {
                "level": 4,
                "hp": 3534,
                "attack": 140,
                "defense": 75,
                "sp_attack": 123,
                "sp_defense": 85,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 11.57,
                "move_speed": 3800
            },
            {
                "level": 5,
                "hp": 4321,
                "attack": 173,
                "defense": 122,
                "sp_attack": 233,
                "sp_defense": 136,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 16.82,
                "move_speed": 3950
            },
            {
                "level": 6,
                "hp": 4455,
                "attack": 179,
                "defense": 130,
                "sp_attack": 252,
                "sp_defense": 145,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 17.71,
                "move_speed": 3950
            },
            {
                "level": 7,
                "hp": 4616,
                "attack": 186,
                "defense": 140,
                "sp_attack": 274,
                "sp_defense": 155,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 18.78,
                "move_speed": 4100
            },
            {
                "level": 8,
                "hp": 4809,
                "attack": 194,
                "defense": 151,
                "sp_attack": 301,
                "sp_defense": 167,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 20.07,
                "move_speed": 4100
            },
            {
                "level": 9,
                "hp": 5041,
                "attack": 204,
                "defense": 165,
                "sp_attack": 333,
                "sp_defense": 182,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 21.62,
                "move_speed": 4250
            },
            {
                "level": 10,
                "hp": 5319,
                "attack": 216,
                "defense": 182,
                "sp_attack": 372,
                "sp_defense": 200,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 23.47,
                "move_speed": 4250
            },
            {
                "level": 11,
                "hp": 5653,
                "attack": 230,
                "defense": 202,
                "sp_attack": 419,
                "sp_defense": 222,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 25.69,
                "move_speed": 4400
            },
            {
                "level": 12,
                "hp": 6053,
                "attack": 247,
                "defense": 226,
                "sp_attack": 475,
                "sp_defense": 248,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 28.36,
                "move_speed": 4400
            },
            {
                "level": 13,
                "hp": 6533,
                "attack": 267,
                "defense": 255,
                "sp_attack": 542,
                "sp_defense": 279,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 31.56,
                "move_speed": 4400
            },
            {
                "level": 14,
                "hp": 7109,
                "attack": 291,
                "defense": 289,
                "sp_attack": 623,
                "sp_defense": 316,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 35.4,
                "move_speed": 4400
            },
            {
                "level": 15,
                "hp": 7800,
                "attack": 320,
                "defense": 330,
                "sp_attack": 720,
                "sp_defense": 361,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 40.01,
                "move_speed": 4400
            }
        ]
    },
    {
        "name": "Sableye",
        "level": [
            {
                "level": 1,
                "hp": 3000,
                "attack": 110,
                "defense": 40,
                "sp_attack": 20,
                "sp_defense": 30,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3700
            },
            {
                "level": 2,
                "hp": 3139,
                "attack": 117,
                "defense": 46,
                "sp_attack": 24,
                "sp_defense": 34,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.36,
                "move_speed": 3700
            },
            {
                "level": 3,
                "hp": 3292,
                "attack": 124,
                "defense": 52,
                "sp_attack": 28,
                "sp_defense": 39,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.75,
                "move_speed": 3700
            },
            {
                "level": 4,
                "hp": 3460,
                "attack": 132,
                "defense": 59,
                "sp_attack": 32,
                "sp_defense": 44,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 11.18,
                "move_speed": 3700
            },
            {
                "level": 5,
                "hp": 3644,
                "attack": 141,
                "defense": 67,
                "sp_attack": 37,
                "sp_defense": 50,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 11.65,
                "move_speed": 3850
            },
            {
                "level": 6,
                "hp": 3847,
                "attack": 151,
                "defense": 75,
                "sp_attack": 42,
                "sp_defense": 56,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 12.17,
                "move_speed": 3850
            },
            {
                "level": 7,
                "hp": 4070,
                "attack": 162,
                "defense": 84,
                "sp_attack": 48,
                "sp_defense": 63,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 12.74,
                "move_speed": 4000
            },
            {
                "level": 8,
                "hp": 4316,
                "attack": 174,
                "defense": 94,
                "sp_attack": 54,
                "sp_defense": 71,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 13.37,
                "move_speed": 4000
            },
            {
                "level": 9,
                "hp": 4587,
                "attack": 187,
                "defense": 105,
                "sp_attack": 61,
                "sp_defense": 79,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 14.07,
                "move_speed": 4150
            },
            {
                "level": 10,
                "hp": 4886,
                "attack": 202,
                "defense": 117,
                "sp_attack": 69,
                "sp_defense": 88,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 14.84,
                "move_speed": 4150
            },
            {
                "level": 11,
                "hp": 5216,
                "attack": 218,
                "defense": 131,
                "sp_attack": 78,
                "sp_defense": 98,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 15.68,
                "move_speed": 4300
            },
            {
                "level": 12,
                "hp": 5578,
                "attack": 236,
                "defense": 146,
                "sp_attack": 87,
                "sp_defense": 109,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 16.61,
                "move_speed": 4300
            },
            {
                "level": 13,
                "hp": 5977,
                "attack": 255,
                "defense": 162,
                "sp_attack": 97,
                "sp_defense": 121,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 17.63,
                "move_speed": 4300
            },
            {
                "level": 14,
                "hp": 6416,
                "attack": 276,
                "defense": 180,
                "sp_attack": 108,
                "sp_defense": 135,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 18.76,
                "move_speed": 4300
            },
            {
                "level": 15,
                "hp": 6900,
                "attack": 300,
                "defense": 200,
                "sp_attack": 120,
                "sp_defense": 150,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 20,
                "move_speed": 4300
            }
        ]
    },
    {
        "name": "Scizor",
        "level": [
            {
                "level": 1,
                "hp": 3100,
                "attack": 160,
                "defense": 45,
                "sp_attack": 20,
                "sp_defense": 40,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3650
            },
            {
                "level": 2,
                "hp": 3174,
                "attack": 170,
                "defense": 51,
                "sp_attack": 22,
                "sp_defense": 44,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.44,
                "move_speed": 3650
            },
            {
                "level": 3,
                "hp": 3259,
                "attack": 182,
                "defense": 58,
                "sp_attack": 24,
                "sp_defense": 48,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.95,
                "move_speed": 3650
            },
            {
                "level": 4,
                "hp": 3357,
                "attack": 196,
                "defense": 66,
                "sp_attack": 27,
                "sp_defense": 53,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 11.54,
                "move_speed": 3650
            },
            {
                "level": 5,
                "hp": 4154,
                "attack": 224,
                "defense": 143,
                "sp_attack": 40,
                "sp_defense": 118,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 14.22,
                "move_speed": 3800
            },
            {
                "level": 6,
                "hp": 4348,
                "attack": 236,
                "defense": 161,
                "sp_attack": 44,
                "sp_defense": 132,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 15,
                "move_speed": 3800
            },
            {
                "level": 7,
                "hp": 4571,
                "attack": 249,
                "defense": 182,
                "sp_attack": 48,
                "sp_defense": 149,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 15.89,
                "move_speed": 3950
            },
            {
                "level": 8,
                "hp": 4828,
                "attack": 264,
                "defense": 206,
                "sp_attack": 53,
                "sp_defense": 168,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 16.92,
                "move_speed": 3950
            },
            {
                "level": 9,
                "hp": 5123,
                "attack": 282,
                "defense": 233,
                "sp_attack": 59,
                "sp_defense": 190,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 18.1,
                "move_speed": 4100
            },
            {
                "level": 10,
                "hp": 5463,
                "attack": 302,
                "defense": 265,
                "sp_attack": 65,
                "sp_defense": 215,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 19.46,
                "move_speed": 4100
            },
            {
                "level": 11,
                "hp": 5854,
                "attack": 325,
                "defense": 301,
                "sp_attack": 72,
                "sp_defense": 244,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 21.02,
                "move_speed": 4250
            },
            {
                "level": 12,
                "hp": 6304,
                "attack": 352,
                "defense": 343,
                "sp_attack": 81,
                "sp_defense": 277,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 22.82,
                "move_speed": 4250
            },
            {
                "level": 13,
                "hp": 6821,
                "attack": 383,
                "defense": 391,
                "sp_attack": 91,
                "sp_defense": 315,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 24.89,
                "move_speed": 4250
            },
            {
                "level": 14,
                "hp": 7416,
                "attack": 419,
                "defense": 446,
                "sp_attack": 102,
                "sp_defense": 359,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 27.27,
                "move_speed": 4250
            },
            {
                "level": 15,
                "hp": 8100,
                "attack": 460,
                "defense": 510,
                "sp_attack": 115,
                "sp_defense": 410,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 30,
                "move_speed": 4250
            }
        ]
    },
    {
        "name": "Scyther",
        "level": [
            {
                "level": 1,
                "hp": 3100,
                "attack": 160,
                "defense": 45,
                "sp_attack": 20,
                "sp_defense": 40,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3650
            },
            {
                "level": 2,
                "hp": 3174,
                "attack": 170,
                "defense": 51,
                "sp_attack": 22,
                "sp_defense": 44,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.44,
                "move_speed": 3650
            },
            {
                "level": 3,
                "hp": 3259,
                "attack": 182,
                "defense": 58,
                "sp_attack": 24,
                "sp_defense": 48,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.95,
                "move_speed": 3650
            },
            {
                "level": 4,
                "hp": 3357,
                "attack": 196,
                "defense": 66,
                "sp_attack": 27,
                "sp_defense": 53,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 11.54,
                "move_speed": 3650
            },
            {
                "level": 5,
                "hp": 3805,
                "attack": 259,
                "defense": 100,
                "sp_attack": 40,
                "sp_defense": 74,
                "crit": 5,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 14.22,
                "move_speed": 3800
            },
            {
                "level": 6,
                "hp": 3935,
                "attack": 277,
                "defense": 110,
                "sp_attack": 44,
                "sp_defense": 80,
                "crit": 5,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 15,
                "move_speed": 3800
            },
            {
                "level": 7,
                "hp": 4084,
                "attack": 298,
                "defense": 121,
                "sp_attack": 48,
                "sp_defense": 87,
                "crit": 5,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 15.89,
                "move_speed": 3950
            },
            {
                "level": 8,
                "hp": 4256,
                "attack": 322,
                "defense": 134,
                "sp_attack": 53,
                "sp_defense": 95,
                "crit": 5,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 16.92,
                "move_speed": 3950
            },
            {
                "level": 9,
                "hp": 4454,
                "attack": 350,
                "defense": 149,
                "sp_attack": 59,
                "sp_defense": 104,
                "crit": 10,
                "cdr": 20,
                "lifesteal": 0,
                "attack_speed": 18.1,
                "move_speed": 4100
            },
            {
                "level": 10,
                "hp": 4682,
                "attack": 382,
                "defense": 166,
                "sp_attack": 65,
                "sp_defense": 115,
                "crit": 10,
                "cdr": 20,
                "lifesteal": 0,
                "attack_speed": 19.46,
                "move_speed": 4100
            },
            {
                "level": 11,
                "hp": 4944,
                "attack": 419,
                "defense": 186,
                "sp_attack": 72,
                "sp_defense": 128,
                "crit": 10,
                "cdr": 20,
                "lifesteal": 0,
                "attack_speed": 21.02,
                "move_speed": 4250
            },
            {
                "level": 12,
                "hp": 5246,
                "attack": 461,
                "defense": 209,
                "sp_attack": 81,
                "sp_defense": 142,
                "crit": 10,
                "cdr": 20,
                "lifesteal": 0,
                "attack_speed": 22.82,
                "move_speed": 4250
            },
            {
                "level": 13,
                "hp": 5593,
                "attack": 510,
                "defense": 235,
                "sp_attack": 91,
                "sp_defense": 159,
                "crit": 10,
                "cdr": 20,
                "lifesteal": 0,
                "attack_speed": 24.89,
                "move_speed": 4250
            },
            {
                "level": 14,
                "hp": 5992,
                "attack": 566,
                "defense": 265,
                "sp_attack": 102,
                "sp_defense": 178,
                "crit": 10,
                "cdr": 20,
                "lifesteal": 0,
                "attack_speed": 27.27,
                "move_speed": 4250
            },
            {
                "level": 15,
                "hp": 6450,
                "attack": 630,
                "defense": 300,
                "sp_attack": 115,
                "sp_defense": 200,
                "crit": 10,
                "cdr": 20,
                "lifesteal": 0,
                "attack_speed": 30,
                "move_speed": 4250
            }
        ]
    },
    {
        "name": "Slowbro",
        "level": [
            {
                "level": 1,
                "hp": 3225,
                "attack": 150,
                "defense": 70,
                "sp_attack": 50,
                "sp_defense": 60,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3700
            },
            {
                "level": 2,
                "hp": 3351,
                "attack": 153,
                "defense": 79,
                "sp_attack": 58,
                "sp_defense": 68,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.44,
                "move_speed": 3700
            },
            {
                "level": 3,
                "hp": 3496,
                "attack": 157,
                "defense": 89,
                "sp_attack": 67,
                "sp_defense": 77,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.95,
                "move_speed": 3700
            },
            {
                "level": 4,
                "hp": 4230,
                "attack": 175,
                "defense": 142,
                "sp_attack": 114,
                "sp_defense": 124,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 13.54,
                "move_speed": 3700
            },
            {
                "level": 5,
                "hp": 4422,
                "attack": 180,
                "defense": 156,
                "sp_attack": 126,
                "sp_defense": 136,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 14.22,
                "move_speed": 3850
            },
            {
                "level": 6,
                "hp": 4642,
                "attack": 186,
                "defense": 172,
                "sp_attack": 140,
                "sp_defense": 150,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 15,
                "move_speed": 3850
            },
            {
                "level": 7,
                "hp": 4895,
                "attack": 192,
                "defense": 190,
                "sp_attack": 156,
                "sp_defense": 166,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 15.89,
                "move_speed": 4000
            },
            {
                "level": 8,
                "hp": 5186,
                "attack": 199,
                "defense": 211,
                "sp_attack": 175,
                "sp_defense": 185,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 16.92,
                "move_speed": 4000
            },
            {
                "level": 9,
                "hp": 5521,
                "attack": 207,
                "defense": 235,
                "sp_attack": 196,
                "sp_defense": 206,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 18.1,
                "move_speed": 4150
            },
            {
                "level": 10,
                "hp": 5907,
                "attack": 217,
                "defense": 263,
                "sp_attack": 221,
                "sp_defense": 231,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 19.46,
                "move_speed": 4150
            },
            {
                "level": 11,
                "hp": 6351,
                "attack": 228,
                "defense": 295,
                "sp_attack": 249,
                "sp_defense": 259,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 21.02,
                "move_speed": 4300
            },
            {
                "level": 12,
                "hp": 6862,
                "attack": 241,
                "defense": 332,
                "sp_attack": 282,
                "sp_defense": 291,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 22.82,
                "move_speed": 4300
            },
            {
                "level": 13,
                "hp": 7449,
                "attack": 256,
                "defense": 375,
                "sp_attack": 319,
                "sp_defense": 328,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 24.89,
                "move_speed": 4300
            },
            {
                "level": 14,
                "hp": 8124,
                "attack": 273,
                "defense": 424,
                "sp_attack": 362,
                "sp_defense": 371,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 27.27,
                "move_speed": 4300
            },
            {
                "level": 15,
                "hp": 8900,
                "attack": 292,
                "defense": 480,
                "sp_attack": 411,
                "sp_defense": 420,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 30,
                "move_speed": 4300
            }
        ]
    },
    {
        "name": "Snorlax",
        "level": [
            {
                "level": 1,
                "hp": 3300,
                "attack": 175,
                "defense": 97,
                "sp_attack": 20,
                "sp_defense": 70,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3650
            },
            {
                "level": 2,
                "hp": 3535,
                "attack": 181,
                "defense": 114,
                "sp_attack": 23,
                "sp_defense": 83,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 11.07,
                "move_speed": 3650
            },
            {
                "level": 3,
                "hp": 3793,
                "attack": 188,
                "defense": 133,
                "sp_attack": 27,
                "sp_defense": 98,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 12.24,
                "move_speed": 3650
            },
            {
                "level": 4,
                "hp": 4077,
                "attack": 195,
                "defense": 154,
                "sp_attack": 31,
                "sp_defense": 114,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 13.53,
                "move_speed": 3650
            },
            {
                "level": 5,
                "hp": 4389,
                "attack": 203,
                "defense": 177,
                "sp_attack": 36,
                "sp_defense": 132,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 14.95,
                "move_speed": 3800
            },
            {
                "level": 6,
                "hp": 4733,
                "attack": 212,
                "defense": 202,
                "sp_attack": 41,
                "sp_defense": 151,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 16.51,
                "move_speed": 3800
            },
            {
                "level": 7,
                "hp": 5111,
                "attack": 222,
                "defense": 230,
                "sp_attack": 46,
                "sp_defense": 172,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 18.23,
                "move_speed": 3950
            },
            {
                "level": 8,
                "hp": 5528,
                "attack": 233,
                "defense": 260,
                "sp_attack": 52,
                "sp_defense": 195,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 20.12,
                "move_speed": 3950
            },
            {
                "level": 9,
                "hp": 5987,
                "attack": 245,
                "defense": 294,
                "sp_attack": 59,
                "sp_defense": 221,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 22.21,
                "move_speed": 4100
            },
            {
                "level": 10,
                "hp": 6493,
                "attack": 258,
                "defense": 331,
                "sp_attack": 66,
                "sp_defense": 249,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 24.51,
                "move_speed": 4100
            },
            {
                "level": 11,
                "hp": 7050,
                "attack": 272,
                "defense": 372,
                "sp_attack": 74,
                "sp_defense": 280,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 27.04,
                "move_speed": 4250
            },
            {
                "level": 12,
                "hp": 7663,
                "attack": 288,
                "defense": 417,
                "sp_attack": 83,
                "sp_defense": 314,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 29.83,
                "move_speed": 4250
            },
            {
                "level": 13,
                "hp": 8338,
                "attack": 305,
                "defense": 466,
                "sp_attack": 93,
                "sp_defense": 352,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 32.9,
                "move_speed": 4250
            },
            {
                "level": 14,
                "hp": 9081,
                "attack": 324,
                "defense": 520,
                "sp_attack": 104,
                "sp_defense": 394,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 36.28,
                "move_speed": 4250
            },
            {
                "level": 15,
                "hp": 9899,
                "attack": 345,
                "defense": 580,
                "sp_attack": 116,
                "sp_defense": 440,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 40,
                "move_speed": 4250
            }
        ]
    },
    {
        "name": "Sylveon",
        "level": [
            {
                "level": 1,
                "hp": 3406,
                "attack": 167,
                "defense": 52,
                "sp_attack": 70,
                "sp_defense": 38,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3700
            },
            {
                "level": 2,
                "hp": 3489,
                "attack": 171,
                "defense": 57,
                "sp_attack": 84,
                "sp_defense": 42,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.67,
                "move_speed": 3700
            },
            {
                "level": 3,
                "hp": 3584,
                "attack": 176,
                "defense": 62,
                "sp_attack": 101,
                "sp_defense": 47,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 11.43,
                "move_speed": 3700
            },
            {
                "level": 4,
                "hp": 4068,
                "attack": 201,
                "defense": 89,
                "sp_attack": 185,
                "sp_defense": 73,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 15.31,
                "move_speed": 3700
            },
            {
                "level": 5,
                "hp": 4195,
                "attack": 208,
                "defense": 96,
                "sp_attack": 207,
                "sp_defense": 80,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 16.32,
                "move_speed": 3850
            },
            {
                "level": 6,
                "hp": 4340,
                "attack": 216,
                "defense": 104,
                "sp_attack": 232,
                "sp_defense": 88,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 17.48,
                "move_speed": 3850
            },
            {
                "level": 7,
                "hp": 4507,
                "attack": 225,
                "defense": 113,
                "sp_attack": 261,
                "sp_defense": 97,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 18.82,
                "move_speed": 4000
            },
            {
                "level": 8,
                "hp": 4699,
                "attack": 235,
                "defense": 124,
                "sp_attack": 294,
                "sp_defense": 107,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 20.36,
                "move_speed": 4000
            },
            {
                "level": 9,
                "hp": 4920,
                "attack": 247,
                "defense": 136,
                "sp_attack": 332,
                "sp_defense": 119,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 22.13,
                "move_speed": 4150
            },
            {
                "level": 10,
                "hp": 5174,
                "attack": 260,
                "defense": 150,
                "sp_attack": 376,
                "sp_defense": 133,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 24.17,
                "move_speed": 4150
            },
            {
                "level": 11,
                "hp": 5467,
                "attack": 275,
                "defense": 166,
                "sp_attack": 427,
                "sp_defense": 149,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 26.52,
                "move_speed": 4300
            },
            {
                "level": 12,
                "hp": 5804,
                "attack": 293,
                "defense": 185,
                "sp_attack": 486,
                "sp_defense": 167,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 29.22,
                "move_speed": 4300
            },
            {
                "level": 13,
                "hp": 6191,
                "attack": 313,
                "defense": 207,
                "sp_attack": 553,
                "sp_defense": 188,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 32.32,
                "move_speed": 4300
            },
            {
                "level": 14,
                "hp": 6636,
                "attack": 336,
                "defense": 232,
                "sp_attack": 631,
                "sp_defense": 212,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 35.89,
                "move_speed": 4300
            },
            {
                "level": 15,
                "hp": 7148,
                "attack": 363,
                "defense": 260,
                "sp_attack": 720,
                "sp_defense": 240,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 39.99,
                "move_speed": 4300
            }
        ]
    },
    {
        "name": "Talonflame",
        "level": [
            {
                "level": 1,
                "hp": 3024,
                "attack": 200,
                "defense": 58,
                "sp_attack": 20,
                "sp_defense": 40,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3650
            },
            {
                "level": 2,
                "hp": 3071,
                "attack": 207,
                "defense": 61,
                "sp_attack": 21,
                "sp_defense": 42,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.43,
                "move_speed": 3650
            },
            {
                "level": 3,
                "hp": 3127,
                "attack": 216,
                "defense": 65,
                "sp_attack": 23,
                "sp_defense": 45,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.94,
                "move_speed": 3650
            },
            {
                "level": 4,
                "hp": 3195,
                "attack": 227,
                "defense": 70,
                "sp_attack": 25,
                "sp_defense": 48,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 11.56,
                "move_speed": 3650
            },
            {
                "level": 5,
                "hp": 3440,
                "attack": 265,
                "defense": 87,
                "sp_attack": 32,
                "sp_defense": 60,
                "crit": 5,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 13.8,
                "move_speed": 3800
            },
            {
                "level": 6,
                "hp": 3538,
                "attack": 280,
                "defense": 94,
                "sp_attack": 35,
                "sp_defense": 65,
                "crit": 5,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 14.69,
                "move_speed": 3800
            },
            {
                "level": 7,
                "hp": 3983,
                "attack": 349,
                "defense": 125,
                "sp_attack": 48,
                "sp_defense": 87,
                "crit": 5,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 18.76,
                "move_speed": 3950
            },
            {
                "level": 8,
                "hp": 4124,
                "attack": 371,
                "defense": 135,
                "sp_attack": 52,
                "sp_defense": 94,
                "crit": 5,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 20.05,
                "move_speed": 3950
            },
            {
                "level": 9,
                "hp": 4293,
                "attack": 397,
                "defense": 147,
                "sp_attack": 57,
                "sp_defense": 102,
                "crit": 10,
                "cdr": 20,
                "lifesteal": 0,
                "attack_speed": 21.59,
                "move_speed": 4100
            },
            {
                "level": 10,
                "hp": 4495,
                "attack": 429,
                "defense": 161,
                "sp_attack": 63,
                "sp_defense": 112,
                "crit": 10,
                "cdr": 20,
                "lifesteal": 0,
                "attack_speed": 23.44,
                "move_speed": 4100
            },
            {
                "level": 11,
                "hp": 4738,
                "attack": 467,
                "defense": 178,
                "sp_attack": 70,
                "sp_defense": 124,
                "crit": 10,
                "cdr": 20,
                "lifesteal": 0,
                "attack_speed": 25.66,
                "move_speed": 4250
            },
            {
                "level": 12,
                "hp": 5029,
                "attack": 512,
                "defense": 199,
                "sp_attack": 79,
                "sp_defense": 138,
                "crit": 10,
                "cdr": 20,
                "lifesteal": 0,
                "attack_speed": 28.33,
                "move_speed": 4250
            },
            {
                "level": 13,
                "hp": 5378,
                "attack": 567,
                "defense": 224,
                "sp_attack": 89,
                "sp_defense": 155,
                "crit": 10,
                "cdr": 20,
                "lifesteal": 0,
                "attack_speed": 31.53,
                "move_speed": 4250
            },
            {
                "level": 14,
                "hp": 5797,
                "attack": 632,
                "defense": 254,
                "sp_attack": 102,
                "sp_defense": 175,
                "crit": 10,
                "cdr": 20,
                "lifesteal": 0,
                "attack_speed": 35.37,
                "move_speed": 4250
            },
            {
                "level": 15,
                "hp": 6300,
                "attack": 710,
                "defense": 290,
                "sp_attack": 117,
                "sp_defense": 200,
                "crit": 10,
                "cdr": 20,
                "lifesteal": 0,
                "attack_speed": 39.98,
                "move_speed": 4250
            }
        ]
    },
    {
        "name": "Tinkaton",
        "level": [
            {
                "level": 1,
                "hp": 3250,
                "attack": 100,
                "defense": 60,
                "sp_attack": 20,
                "sp_defense": 80,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3700
            },
            {
                "level": 2,
                "hp": 3324,
                "attack": 105,
                "defense": 64,
                "sp_attack": 21,
                "sp_defense": 85,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.29,
                "move_speed": 3700
            },
            {
                "level": 3,
                "hp": 3412,
                "attack": 111,
                "defense": 69,
                "sp_attack": 23,
                "sp_defense": 91,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.63,
                "move_speed": 3700
            },
            {
                "level": 4,
                "hp": 3518,
                "attack": 118,
                "defense": 75,
                "sp_attack": 25,
                "sp_defense": 98,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 11.04,
                "move_speed": 3700
            },
            {
                "level": 5,
                "hp": 3903,
                "attack": 145,
                "defense": 95,
                "sp_attack": 32,
                "sp_defense": 124,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 12.54,
                "move_speed": 3850
            },
            {
                "level": 6,
                "hp": 4057,
                "attack": 156,
                "defense": 103,
                "sp_attack": 35,
                "sp_defense": 134,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 13.14,
                "move_speed": 3850
            },
            {
                "level": 7,
                "hp": 4756,
                "attack": 205,
                "defense": 139,
                "sp_attack": 48,
                "sp_defense": 182,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 15.86,
                "move_speed": 4000
            },
            {
                "level": 8,
                "hp": 4997,
                "attack": 220,
                "defense": 151,
                "sp_attack": 52,
                "sp_defense": 197,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 16.72,
                "move_speed": 4000
            },
            {
                "level": 9,
                "hp": 5242,
                "attack": 239,
                "defense": 165,
                "sp_attack": 57,
                "sp_defense": 215,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 17.75,
                "move_speed": 4150
            },
            {
                "level": 10,
                "hp": 5560,
                "attack": 261,
                "defense": 182,
                "sp_attack": 63,
                "sp_defense": 237,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 18.98,
                "move_speed": 4150
            },
            {
                "level": 11,
                "hp": 5942,
                "attack": 288,
                "defense": 202,
                "sp_attack": 70,
                "sp_defense": 263,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 20.46,
                "move_speed": 4300
            },
            {
                "level": 12,
                "hp": 6400,
                "attack": 320,
                "defense": 226,
                "sp_attack": 78,
                "sp_defense": 294,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 22.24,
                "move_speed": 4300
            },
            {
                "level": 13,
                "hp": 6950,
                "attack": 359,
                "defense": 255,
                "sp_attack": 88,
                "sp_defense": 331,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 24.37,
                "move_speed": 4300
            },
            {
                "level": 14,
                "hp": 7609,
                "attack": 405,
                "defense": 289,
                "sp_attack": 100,
                "sp_defense": 376,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 26.93,
                "move_speed": 4300
            },
            {
                "level": 15,
                "hp": 8400,
                "attack": 460,
                "defense": 330,
                "sp_attack": 115,
                "sp_defense": 430,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 30,
                "move_speed": 4300
            }
        ]
    },
    {
        "name": "Trevenant",
        "level": [
            {
                "level": 1,
                "hp": 3250,
                "attack": 175,
                "defense": 100,
                "sp_attack": 20,
                "sp_defense": 70,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3800
            },
            {
                "level": 2,
                "hp": 3391,
                "attack": 178,
                "defense": 109,
                "sp_attack": 22,
                "sp_defense": 78,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.44,
                "move_speed": 3800
            },
            {
                "level": 3,
                "hp": 3553,
                "attack": 182,
                "defense": 120,
                "sp_attack": 24,
                "sp_defense": 87,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.95,
                "move_speed": 3800
            },
            {
                "level": 4,
                "hp": 3739,
                "attack": 187,
                "defense": 132,
                "sp_attack": 27,
                "sp_defense": 97,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 11.54,
                "move_speed": 3800
            },
            {
                "level": 5,
                "hp": 4589,
                "attack": 208,
                "defense": 188,
                "sp_attack": 40,
                "sp_defense": 144,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 14.22,
                "move_speed": 3950
            },
            {
                "level": 6,
                "hp": 4835,
                "attack": 214,
                "defense": 204,
                "sp_attack": 44,
                "sp_defense": 158,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 15,
                "move_speed": 3950
            },
            {
                "level": 7,
                "hp": 5118,
                "attack": 221,
                "defense": 223,
                "sp_attack": 48,
                "sp_defense": 174,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 15.89,
                "move_speed": 4100
            },
            {
                "level": 8,
                "hp": 5444,
                "attack": 229,
                "defense": 245,
                "sp_attack": 53,
                "sp_defense": 192,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 16.92,
                "move_speed": 4100
            },
            {
                "level": 9,
                "hp": 5819,
                "attack": 238,
                "defense": 270,
                "sp_attack": 59,
                "sp_defense": 213,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 18.1,
                "move_speed": 4250
            },
            {
                "level": 10,
                "hp": 6251,
                "attack": 249,
                "defense": 299,
                "sp_attack": 66,
                "sp_defense": 237,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 19.46,
                "move_speed": 4250
            },
            {
                "level": 11,
                "hp": 6748,
                "attack": 261,
                "defense": 332,
                "sp_attack": 74,
                "sp_defense": 264,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 21.02,
                "move_speed": 4400
            },
            {
                "level": 12,
                "hp": 7319,
                "attack": 275,
                "defense": 370,
                "sp_attack": 83,
                "sp_defense": 295,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 22.82,
                "move_speed": 4400
            },
            {
                "level": 13,
                "hp": 7976,
                "attack": 291,
                "defense": 413,
                "sp_attack": 93,
                "sp_defense": 331,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 24.89,
                "move_speed": 4400
            },
            {
                "level": 14,
                "hp": 8731,
                "attack": 309,
                "defense": 463,
                "sp_attack": 104,
                "sp_defense": 373,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 27.27,
                "move_speed": 4400
            },
            {
                "level": 15,
                "hp": 9599,
                "attack": 330,
                "defense": 520,
                "sp_attack": 117,
                "sp_defense": 421,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 30,
                "move_speed": 4400
            }
        ]
    },
    {
        "name": "Tsareena",
        "level": [
            {
                "level": 1,
                "hp": 3100,
                "attack": 155,
                "defense": 70,
                "sp_attack": 20,
                "sp_defense": 50,
                "crit": "0",
                "cdr": "0",
                "lifesteal": "0",
                "attack_speed": "10.00",
                "move_speed": 3650
            },
            {
                "level": 2,
                "hp": 3160,
                "attack": 159,
                "defense": 75,
                "sp_attack": 21,
                "sp_defense": 54,
                "crit": "0",
                "cdr": "0",
                "lifesteal": "0",
                "attack_speed": "10.57",
                "move_speed": 3650
            },
            {
                "level": 3,
                "hp": 3232,
                "attack": 164,
                "defense": 81,
                "sp_attack": 23,
                "sp_defense": 59,
                "crit": "0",
                "cdr": "0",
                "lifesteal": "0",
                "attack_speed": "11.26",
                "move_speed": 3650
            },
            {
                "level": 4,
                "hp": 3529,
                "attack": 185,
                "defense": 105,
                "sp_attack": 30,
                "sp_defense": 79,
                "crit": "0",
                "cdr": "0",
                "lifesteal": "0",
                "attack_speed": "14.08",
                "move_speed": 3650
            },
            {
                "level": 5,
                "hp": 3633,
                "attack": 193,
                "defense": 113,
                "sp_attack": 32,
                "sp_defense": 86,
                "crit": "10",
                "cdr": "0",
                "lifesteal": "5",
                "attack_speed": "15.07",
                "move_speed": 3800
            },
            {
                "level": 6,
                "hp": 4178,
                "attack": 233,
                "defense": 157,
                "sp_attack": 44,
                "sp_defense": 124,
                "crit": "10",
                "cdr": "0",
                "lifesteal": "5",
                "attack_speed": "20.26",
                "move_speed": 3800
            },
            {
                "level": 7,
                "hp": 4328,
                "attack": 244,
                "defense": 169,
                "sp_attack": 47,
                "sp_defense": 134,
                "crit": "10",
                "cdr": "0",
                "lifesteal": "10",
                "attack_speed": "21.69",
                "move_speed": 3950
            },
            {
                "level": 8,
                "hp": 4508,
                "attack": 257,
                "defense": 184,
                "sp_attack": 51,
                "sp_defense": 146,
                "crit": "10",
                "cdr": "0",
                "lifesteal": "10",
                "attack_speed": "23.41",
                "move_speed": 3950
            },
            {
                "level": 9,
                "hp": 4724,
                "attack": 273,
                "defense": 202,
                "sp_attack": 56,
                "sp_defense": 161,
                "crit": "20",
                "cdr": "0",
                "lifesteal": "15",
                "attack_speed": "25.47",
                "move_speed": 4100
            },
            {
                "level": 10,
                "hp": 4983,
                "attack": 292,
                "defense": 223,
                "sp_attack": 62,
                "sp_defense": 179,
                "crit": "20",
                "cdr": "0",
                "lifesteal": "15",
                "attack_speed": "27.94",
                "move_speed": 4100
            },
            {
                "level": 11,
                "hp": 5294,
                "attack": 315,
                "defense": 248,
                "sp_attack": 69,
                "sp_defense": 201,
                "crit": "20",
                "cdr": "0",
                "lifesteal": "15",
                "attack_speed": "30.91",
                "move_speed": 4250
            },
            {
                "level": 12,
                "hp": 5667,
                "attack": 342,
                "defense": 278,
                "sp_attack": 78,
                "sp_defense": 227,
                "crit": "20",
                "cdr": "0",
                "lifesteal": "15",
                "attack_speed": "34.47",
                "move_speed": 4250
            },
            {
                "level": 13,
                "hp": 6115,
                "attack": 374,
                "defense": 314,
                "sp_attack": 88,
                "sp_defense": 258,
                "crit": "20",
                "cdr": "0",
                "lifesteal": "20",
                "attack_speed": "38.74",
                "move_speed": 4250
            },
            {
                "level": 14,
                "hp": 6653,
                "attack": 413,
                "defense": 358,
                "sp_attack": 100,
                "sp_defense": 295,
                "crit": "20",
                "cdr": "0",
                "lifesteal": "20",
                "attack_speed": "43.86",
                "move_speed": 4250
            },
            {
                "level": 15,
                "hp": 7298,
                "attack": 460,
                "defense": 410,
                "sp_attack": 115,
                "sp_defense": 340,
                "crit": "20",
                "cdr": "0",
                "lifesteal": "20",
                "attack_speed": "50.01",
                "move_speed": 4250
            }
        ]
    },
    {
        "name": "Tyranitar",
        "level": [
            {
                "level": 1,
                "hp": 3300,
                "attack": 150,
                "defense": 110,
                "sp_attack": 20,
                "sp_defense": 90,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3800
            },
            {
                "level": 2,
                "hp": 3381,
                "attack": 154,
                "defense": 116,
                "sp_attack": 21,
                "sp_defense": 94,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.29,
                "move_speed": 3800
            },
            {
                "level": 3,
                "hp": 3478,
                "attack": 159,
                "defense": 123,
                "sp_attack": 23,
                "sp_defense": 99,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.63,
                "move_speed": 3800
            },
            {
                "level": 4,
                "hp": 3595,
                "attack": 165,
                "defense": 131,
                "sp_attack": 25,
                "sp_defense": 105,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 11.04,
                "move_speed": 3800
            },
            {
                "level": 5,
                "hp": 4018,
                "attack": 187,
                "defense": 162,
                "sp_attack": 32,
                "sp_defense": 128,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 12.54,
                "move_speed": 3950
            },
            {
                "level": 6,
                "hp": 4186,
                "attack": 196,
                "defense": 174,
                "sp_attack": 35,
                "sp_defense": 137,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 13.14,
                "move_speed": 3950
            },
            {
                "level": 7,
                "hp": 4388,
                "attack": 207,
                "defense": 189,
                "sp_attack": 38,
                "sp_defense": 148,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 13.86,
                "move_speed": 4100
            },
            {
                "level": 8,
                "hp": 4630,
                "attack": 220,
                "defense": 207,
                "sp_attack": 42,
                "sp_defense": 161,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 14.72,
                "move_speed": 4100
            },
            {
                "level": 9,
                "hp": 5486,
                "attack": 266,
                "defense": 269,
                "sp_attack": 56,
                "sp_defense": 207,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 17.75,
                "move_speed": 4250
            },
            {
                "level": 10,
                "hp": 5835,
                "attack": 285,
                "defense": 294,
                "sp_attack": 62,
                "sp_defense": 226,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 18.98,
                "move_speed": 4250
            },
            {
                "level": 11,
                "hp": 6254,
                "attack": 307,
                "defense": 324,
                "sp_attack": 69,
                "sp_defense": 249,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 20.46,
                "move_speed": 4400
            },
            {
                "level": 12,
                "hp": 6756,
                "attack": 334,
                "defense": 360,
                "sp_attack": 77,
                "sp_defense": 276,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 22.24,
                "move_speed": 4400
            },
            {
                "level": 13,
                "hp": 7359,
                "attack": 366,
                "defense": 404,
                "sp_attack": 87,
                "sp_defense": 309,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 24.37,
                "move_speed": 4400
            },
            {
                "level": 14,
                "hp": 8082,
                "attack": 404,
                "defense": 457,
                "sp_attack": 99,
                "sp_defense": 348,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 26.93,
                "move_speed": 4400
            },
            {
                "level": 15,
                "hp": 8950,
                "attack": 450,
                "defense": 520,
                "sp_attack": 114,
                "sp_defense": 395,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 30,
                "move_speed": 4400
            }
        ]
    },
    {
        "name": "Umbreon",
        "level": [
            {
                "level": 1,
                "hp": 3300,
                "attack": 170,
                "defense": 85,
                "sp_attack": 20,
                "sp_defense": 60,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3700
            },
            {
                "level": 2,
                "hp": 3439,
                "attack": 174,
                "defense": 94,
                "sp_attack": 22,
                "sp_defense": 68,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.44,
                "move_speed": 3700
            },
            {
                "level": 3,
                "hp": 3598,
                "attack": 179,
                "defense": 105,
                "sp_attack": 24,
                "sp_defense": 77,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.95,
                "move_speed": 3700
            },
            {
                "level": 4,
                "hp": 4407,
                "attack": 202,
                "defense": 159,
                "sp_attack": 36,
                "sp_defense": 121,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 13.54,
                "move_speed": 3700
            },
            {
                "level": 5,
                "hp": 4618,
                "attack": 208,
                "defense": 173,
                "sp_attack": 39,
                "sp_defense": 132,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 14.22,
                "move_speed": 3850
            },
            {
                "level": 6,
                "hp": 4861,
                "attack": 215,
                "defense": 189,
                "sp_attack": 43,
                "sp_defense": 145,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 15,
                "move_speed": 3850
            },
            {
                "level": 7,
                "hp": 5140,
                "attack": 223,
                "defense": 208,
                "sp_attack": 47,
                "sp_defense": 160,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 15.89,
                "move_speed": 4000
            },
            {
                "level": 8,
                "hp": 5461,
                "attack": 232,
                "defense": 229,
                "sp_attack": 52,
                "sp_defense": 177,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 16.92,
                "move_speed": 4000
            },
            {
                "level": 9,
                "hp": 5830,
                "attack": 243,
                "defense": 254,
                "sp_attack": 58,
                "sp_defense": 197,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 18.1,
                "move_speed": 4150
            },
            {
                "level": 10,
                "hp": 6255,
                "attack": 255,
                "defense": 282,
                "sp_attack": 64,
                "sp_defense": 220,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 19.46,
                "move_speed": 4150
            },
            {
                "level": 11,
                "hp": 6744,
                "attack": 269,
                "defense": 314,
                "sp_attack": 71,
                "sp_defense": 247,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 21.02,
                "move_speed": 4300
            },
            {
                "level": 12,
                "hp": 7306,
                "attack": 285,
                "defense": 351,
                "sp_attack": 80,
                "sp_defense": 278,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 22.82,
                "move_speed": 4300
            },
            {
                "level": 13,
                "hp": 7953,
                "attack": 304,
                "defense": 394,
                "sp_attack": 90,
                "sp_defense": 313,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 24.89,
                "move_speed": 4300
            },
            {
                "level": 14,
                "hp": 8696,
                "attack": 325,
                "defense": 443,
                "sp_attack": 101,
                "sp_defense": 353,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 27.27,
                "move_speed": 4300
            },
            {
                "level": 15,
                "hp": 9550,
                "attack": 350,
                "defense": 500,
                "sp_attack": 114,
                "sp_defense": 400,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 30,
                "move_speed": 4300
            }
        ]
    },
    {
        "name": "Urshifu",
        "level": [
            {
                "level": 1,
                "hp": 3200,
                "attack": 150,
                "defense": 80,
                "sp_attack": 20,
                "sp_defense": 60,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3700
            },
            {
                "level": 2,
                "hp": 3304,
                "attack": 157,
                "defense": 88,
                "sp_attack": 22,
                "sp_defense": 66,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.44,
                "move_speed": 3700
            },
            {
                "level": 3,
                "hp": 3424,
                "attack": 165,
                "defense": 97,
                "sp_attack": 24,
                "sp_defense": 73,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.95,
                "move_speed": 3700
            },
            {
                "level": 4,
                "hp": 3562,
                "attack": 175,
                "defense": 107,
                "sp_attack": 27,
                "sp_defense": 81,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 11.54,
                "move_speed": 3700
            },
            {
                "level": 5,
                "hp": 4191,
                "attack": 219,
                "defense": 154,
                "sp_attack": 40,
                "sp_defense": 119,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 14.22,
                "move_speed": 3850
            },
            {
                "level": 6,
                "hp": 4373,
                "attack": 232,
                "defense": 168,
                "sp_attack": 44,
                "sp_defense": 130,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 15,
                "move_speed": 3850
            },
            {
                "level": 7,
                "hp": 4583,
                "attack": 247,
                "defense": 184,
                "sp_attack": 48,
                "sp_defense": 143,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 15.89,
                "move_speed": 4000
            },
            {
                "level": 8,
                "hp": 4824,
                "attack": 264,
                "defense": 202,
                "sp_attack": 53,
                "sp_defense": 157,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 16.92,
                "move_speed": 4000
            },
            {
                "level": 9,
                "hp": 5102,
                "attack": 284,
                "defense": 223,
                "sp_attack": 59,
                "sp_defense": 174,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 18.1,
                "move_speed": 4150
            },
            {
                "level": 10,
                "hp": 5421,
                "attack": 306,
                "defense": 247,
                "sp_attack": 65,
                "sp_defense": 193,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 19.46,
                "move_speed": 4150
            },
            {
                "level": 11,
                "hp": 5789,
                "attack": 332,
                "defense": 274,
                "sp_attack": 72,
                "sp_defense": 215,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 21.02,
                "move_speed": 4300
            },
            {
                "level": 12,
                "hp": 6212,
                "attack": 362,
                "defense": 305,
                "sp_attack": 81,
                "sp_defense": 240,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 22.82,
                "move_speed": 4300
            },
            {
                "level": 13,
                "hp": 6698,
                "attack": 396,
                "defense": 341,
                "sp_attack": 91,
                "sp_defense": 269,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 24.89,
                "move_speed": 4300
            },
            {
                "level": 14,
                "hp": 7257,
                "attack": 435,
                "defense": 382,
                "sp_attack": 102,
                "sp_defense": 302,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 27.27,
                "move_speed": 4300
            },
            {
                "level": 15,
                "hp": 7900,
                "attack": 480,
                "defense": 430,
                "sp_attack": 115,
                "sp_defense": 340,
                "crit": 20,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 30,
                "move_speed": 4300
            }
        ]
    },
    {
        "name": "Venusaur",
        "level": [
            {
                "level": 1,
                "hp": 3300,
                "attack": 134,
                "defense": 45,
                "sp_attack": 50,
                "sp_defense": 35,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3700
            },
            {
                "level": 2,
                "hp": 3346,
                "attack": 136,
                "defense": 48,
                "sp_attack": 63,
                "sp_defense": 37,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.14,
                "move_speed": 3700
            },
            {
                "level": 3,
                "hp": 3401,
                "attack": 139,
                "defense": 51,
                "sp_attack": 79,
                "sp_defense": 39,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.31,
                "move_speed": 3700
            },
            {
                "level": 4,
                "hp": 3467,
                "attack": 142,
                "defense": 55,
                "sp_attack": 98,
                "sp_defense": 42,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.52,
                "move_speed": 3700
            },
            {
                "level": 5,
                "hp": 3706,
                "attack": 154,
                "defense": 69,
                "sp_attack": 166,
                "sp_defense": 52,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 11.27,
                "move_speed": 3850
            },
            {
                "level": 6,
                "hp": 3801,
                "attack": 159,
                "defense": 74,
                "sp_attack": 193,
                "sp_defense": 56,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 11.57,
                "move_speed": 3850
            },
            {
                "level": 7,
                "hp": 4235,
                "attack": 180,
                "defense": 99,
                "sp_attack": 317,
                "sp_defense": 74,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 12.93,
                "move_speed": 4000
            },
            {
                "level": 8,
                "hp": 4372,
                "attack": 187,
                "defense": 107,
                "sp_attack": 356,
                "sp_defense": 80,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 13.36,
                "move_speed": 4000
            },
            {
                "level": 9,
                "hp": 4537,
                "attack": 195,
                "defense": 116,
                "sp_attack": 403,
                "sp_defense": 87,
                "crit": 0,
                "cdr": 15,
                "lifesteal": 0,
                "attack_speed": 13.87,
                "move_speed": 4150
            },
            {
                "level": 10,
                "hp": 4735,
                "attack": 205,
                "defense": 127,
                "sp_attack": 459,
                "sp_defense": 95,
                "crit": 0,
                "cdr": 15,
                "lifesteal": 0,
                "attack_speed": 14.49,
                "move_speed": 4150
            },
            {
                "level": 11,
                "hp": 4972,
                "attack": 217,
                "defense": 140,
                "sp_attack": 527,
                "sp_defense": 105,
                "crit": 0,
                "cdr": 15,
                "lifesteal": 0,
                "attack_speed": 15.23,
                "move_speed": 4300
            },
            {
                "level": 12,
                "hp": 5257,
                "attack": 231,
                "defense": 156,
                "sp_attack": 608,
                "sp_defense": 117,
                "crit": 0,
                "cdr": 15,
                "lifesteal": 0,
                "attack_speed": 16.12,
                "move_speed": 4300
            },
            {
                "level": 13,
                "hp": 5598,
                "attack": 248,
                "defense": 175,
                "sp_attack": 705,
                "sp_defense": 131,
                "crit": 0,
                "cdr": 25,
                "lifesteal": 0,
                "attack_speed": 17.19,
                "move_speed": 4300
            },
            {
                "level": 14,
                "hp": 6008,
                "attack": 268,
                "defense": 198,
                "sp_attack": 822,
                "sp_defense": 148,
                "crit": 0,
                "cdr": 25,
                "lifesteal": 0,
                "attack_speed": 18.47,
                "move_speed": 4300
            },
            {
                "level": 15,
                "hp": 6500,
                "attack": 292,
                "defense": 225,
                "sp_attack": 962,
                "sp_defense": 169,
                "crit": 0,
                "cdr": 25,
                "lifesteal": 0,
                "attack_speed": 20.01,
                "move_speed": 4300
            }
        ]
    },
    {
        "name": "Wigglytuff",
        "level": [
            {
                "level": 1,
                "hp": 3278,
                "attack": 130,
                "defense": 90,
                "sp_attack": 40,
                "sp_defense": 80,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3700
            },
            {
                "level": 2,
                "hp": 3415,
                "attack": 134,
                "defense": 100,
                "sp_attack": 51,
                "sp_defense": 89,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.22,
                "move_speed": 3700
            },
            {
                "level": 3,
                "hp": 3573,
                "attack": 139,
                "defense": 111,
                "sp_attack": 64,
                "sp_defense": 99,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.48,
                "move_speed": 3700
            },
            {
                "level": 4,
                "hp": 4372,
                "attack": 162,
                "defense": 169,
                "sp_attack": 131,
                "sp_defense": 151,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 11.77,
                "move_speed": 3700
            },
            {
                "level": 5,
                "hp": 4581,
                "attack": 168,
                "defense": 184,
                "sp_attack": 148,
                "sp_defense": 165,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 12.11,
                "move_speed": 3850
            },
            {
                "level": 6,
                "hp": 4821,
                "attack": 175,
                "defense": 201,
                "sp_attack": 168,
                "sp_defense": 181,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 12.5,
                "move_speed": 3850
            },
            {
                "level": 7,
                "hp": 5097,
                "attack": 183,
                "defense": 221,
                "sp_attack": 191,
                "sp_defense": 199,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 12.95,
                "move_speed": 4000
            },
            {
                "level": 8,
                "hp": 5414,
                "attack": 192,
                "defense": 244,
                "sp_attack": 217,
                "sp_defense": 220,
                "crit": 0,
                "cdr": 5,
                "lifesteal": 0,
                "attack_speed": 13.46,
                "move_speed": 4000
            },
            {
                "level": 9,
                "hp": 5779,
                "attack": 203,
                "defense": 271,
                "sp_attack": 247,
                "sp_defense": 244,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 14.05,
                "move_speed": 4150
            },
            {
                "level": 10,
                "hp": 6199,
                "attack": 215,
                "defense": 302,
                "sp_attack": 282,
                "sp_defense": 271,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 14.73,
                "move_speed": 4150
            },
            {
                "level": 11,
                "hp": 6681,
                "attack": 229,
                "defense": 337,
                "sp_attack": 322,
                "sp_defense": 302,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 15.51,
                "move_speed": 4300
            },
            {
                "level": 12,
                "hp": 7236,
                "attack": 245,
                "defense": 377,
                "sp_attack": 368,
                "sp_defense": 338,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 16.41,
                "move_speed": 4300
            },
            {
                "level": 13,
                "hp": 7874,
                "attack": 264,
                "defense": 424,
                "sp_attack": 421,
                "sp_defense": 379,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 17.44,
                "move_speed": 4300
            },
            {
                "level": 14,
                "hp": 8608,
                "attack": 285,
                "defense": 477,
                "sp_attack": 482,
                "sp_defense": 427,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 18.63,
                "move_speed": 4300
            },
            {
                "level": 15,
                "hp": 9452,
                "attack": 310,
                "defense": 539,
                "sp_attack": 552,
                "sp_defense": 482,
                "crit": 0,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 20,
                "move_speed": 4300
            }
        ]
    },
    {
        "name": "Zacian",
        "level": [
            {
                "level": 1,
                "hp": 3600,
                "attack": 160,
                "defense": 100,
                "sp_attack": 20,
                "sp_defense": 80,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 25,
                "move_speed": 3800
            },
            {
                "level": 2,
                "hp": 3757,
                "attack": 175,
                "defense": 112,
                "sp_attack": 23,
                "sp_defense": 90,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 25.53,
                "move_speed": 3800
            },
            {
                "level": 3,
                "hp": 3929,
                "attack": 191,
                "defense": 125,
                "sp_attack": 27,
                "sp_defense": 101,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 26.12,
                "move_speed": 3800
            },
            {
                "level": 4,
                "hp": 4118,
                "attack": 209,
                "defense": 140,
                "sp_attack": 31,
                "sp_defense": 113,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 26.77,
                "move_speed": 3800
            },
            {
                "level": 5,
                "hp": 4326,
                "attack": 229,
                "defense": 156,
                "sp_attack": 35,
                "sp_defense": 126,
                "crit": 5,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 27.48,
                "move_speed": 3950
            },
            {
                "level": 6,
                "hp": 4555,
                "attack": 251,
                "defense": 174,
                "sp_attack": 40,
                "sp_defense": 140,
                "crit": 5,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 28.26,
                "move_speed": 3950
            },
            {
                "level": 7,
                "hp": 4807,
                "attack": 275,
                "defense": 193,
                "sp_attack": 45,
                "sp_defense": 155,
                "crit": 5,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 29.12,
                "move_speed": 4100
            },
            {
                "level": 8,
                "hp": 5085,
                "attack": 302,
                "defense": 214,
                "sp_attack": 51,
                "sp_defense": 172,
                "crit": 5,
                "cdr": 0,
                "lifesteal": 5,
                "attack_speed": 30.07,
                "move_speed": 4100
            },
            {
                "level": 9,
                "hp": 5391,
                "attack": 331,
                "defense": 238,
                "sp_attack": 58,
                "sp_defense": 191,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 31.11,
                "move_speed": 4250
            },
            {
                "level": 10,
                "hp": 5728,
                "attack": 363,
                "defense": 264,
                "sp_attack": 65,
                "sp_defense": 212,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 32.26,
                "move_speed": 4250
            },
            {
                "level": 11,
                "hp": 6100,
                "attack": 399,
                "defense": 293,
                "sp_attack": 73,
                "sp_defense": 235,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 33.53,
                "move_speed": 4400
            },
            {
                "level": 12,
                "hp": 6509,
                "attack": 438,
                "defense": 325,
                "sp_attack": 82,
                "sp_defense": 260,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 10,
                "attack_speed": 34.92,
                "move_speed": 4400
            },
            {
                "level": 13,
                "hp": 6959,
                "attack": 481,
                "defense": 360,
                "sp_attack": 92,
                "sp_defense": 287,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 36.45,
                "move_speed": 4400
            },
            {
                "level": 14,
                "hp": 7455,
                "attack": 528,
                "defense": 398,
                "sp_attack": 103,
                "sp_defense": 317,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 38.14,
                "move_speed": 4400
            },
            {
                "level": 15,
                "hp": 8000,
                "attack": 580,
                "defense": 440,
                "sp_attack": 115,
                "sp_defense": 350,
                "crit": 10,
                "cdr": 0,
                "lifesteal": 15,
                "attack_speed": 40,
                "move_speed": 4400
            }
        ]
    },
    {
        "name": "Zeraora",
        "level": [
            {
                "level": 1,
                "hp": 3002,
                "attack": 159,
                "defense": 60,
                "sp_attack": 20,
                "sp_defense": 40,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3650
            },
            {
                "level": 2,
                "hp": 3120,
                "attack": 176,
                "defense": 69,
                "sp_attack": 23,
                "sp_defense": 46,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.71,
                "move_speed": 3650
            },
            {
                "level": 3,
                "hp": 3250,
                "attack": 195,
                "defense": 78,
                "sp_attack": 27,
                "sp_defense": 52,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 11.49,
                "move_speed": 3650
            },
            {
                "level": 4,
                "hp": 3393,
                "attack": 216,
                "defense": 88,
                "sp_attack": 31,
                "sp_defense": 59,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 12.35,
                "move_speed": 3650
            },
            {
                "level": 5,
                "hp": 3550,
                "attack": 239,
                "defense": 99,
                "sp_attack": 36,
                "sp_defense": 67,
                "crit": 5,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 13.29,
                "move_speed": 3800
            },
            {
                "level": 6,
                "hp": 3723,
                "attack": 265,
                "defense": 112,
                "sp_attack": 41,
                "sp_defense": 75,
                "crit": 5,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 14.33,
                "move_speed": 3800
            },
            {
                "level": 7,
                "hp": 3913,
                "attack": 293,
                "defense": 126,
                "sp_attack": 47,
                "sp_defense": 84,
                "crit": 5,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 15.48,
                "move_speed": 3950
            },
            {
                "level": 8,
                "hp": 4122,
                "attack": 324,
                "defense": 141,
                "sp_attack": 53,
                "sp_defense": 94,
                "crit": 5,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 16.74,
                "move_speed": 3950
            },
            {
                "level": 9,
                "hp": 4353,
                "attack": 358,
                "defense": 158,
                "sp_attack": 60,
                "sp_defense": 105,
                "crit": 10,
                "cdr": 20,
                "lifesteal": 0,
                "attack_speed": 18.13,
                "move_speed": 4100
            },
            {
                "level": 10,
                "hp": 4607,
                "attack": 396,
                "defense": 176,
                "sp_attack": 68,
                "sp_defense": 117,
                "crit": 10,
                "cdr": 20,
                "lifesteal": 0,
                "attack_speed": 19.66,
                "move_speed": 4100
            },
            {
                "level": 11,
                "hp": 4887,
                "attack": 437,
                "defense": 196,
                "sp_attack": 76,
                "sp_defense": 131,
                "crit": 10,
                "cdr": 20,
                "lifesteal": 0,
                "attack_speed": 21.35,
                "move_speed": 4250
            },
            {
                "level": 12,
                "hp": 5195,
                "attack": 483,
                "defense": 218,
                "sp_attack": 85,
                "sp_defense": 146,
                "crit": 10,
                "cdr": 20,
                "lifesteal": 0,
                "attack_speed": 23.21,
                "move_speed": 4250
            },
            {
                "level": 13,
                "hp": 5534,
                "attack": 533,
                "defense": 243,
                "sp_attack": 95,
                "sp_defense": 162,
                "crit": 10,
                "cdr": 20,
                "lifesteal": 0,
                "attack_speed": 25.26,
                "move_speed": 4250
            },
            {
                "level": 14,
                "hp": 5908,
                "attack": 588,
                "defense": 270,
                "sp_attack": 106,
                "sp_defense": 180,
                "crit": 10,
                "cdr": 20,
                "lifesteal": 0,
                "attack_speed": 27.51,
                "move_speed": 4250
            },
            {
                "level": 15,
                "hp": 6319,
                "attack": 649,
                "defense": 300,
                "sp_attack": 118,
                "sp_defense": 200,
                "crit": 10,
                "cdr": 20,
                "lifesteal": 0,
                "attack_speed": 29.99,
                "move_speed": 4250
            }
        ]
    },
    {
        "name": "Zoroark",
        "level": [
            {
                "level": 1,
                "hp": 3030,
                "attack": 135,
                "defense": 55,
                "sp_attack": 20,
                "sp_defense": 45,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10,
                "move_speed": 3650
            },
            {
                "level": 2,
                "hp": 3100,
                "attack": 147,
                "defense": 60,
                "sp_attack": 22,
                "sp_defense": 48,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.44,
                "move_speed": 3650
            },
            {
                "level": 3,
                "hp": 3181,
                "attack": 160,
                "defense": 65,
                "sp_attack": 25,
                "sp_defense": 51,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 10.95,
                "move_speed": 3650
            },
            {
                "level": 4,
                "hp": 3274,
                "attack": 175,
                "defense": 71,
                "sp_attack": 28,
                "sp_defense": 55,
                "crit": 0,
                "cdr": 0,
                "lifesteal": 0,
                "attack_speed": 11.54,
                "move_speed": 3650
            },
            {
                "level": 5,
                "hp": 3698,
                "attack": 245,
                "defense": 99,
                "sp_attack": 41,
                "sp_defense": 73,
                "crit": 5,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 14.22,
                "move_speed": 3800
            },
            {
                "level": 6,
                "hp": 3821,
                "attack": 265,
                "defense": 107,
                "sp_attack": 45,
                "sp_defense": 78,
                "crit": 5,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 15,
                "move_speed": 3800
            },
            {
                "level": 7,
                "hp": 3962,
                "attack": 288,
                "defense": 116,
                "sp_attack": 49,
                "sp_defense": 84,
                "crit": 5,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 15.89,
                "move_speed": 3950
            },
            {
                "level": 8,
                "hp": 4125,
                "attack": 315,
                "defense": 127,
                "sp_attack": 54,
                "sp_defense": 91,
                "crit": 5,
                "cdr": 10,
                "lifesteal": 0,
                "attack_speed": 16.92,
                "move_speed": 3950
            },
            {
                "level": 9,
                "hp": 4312,
                "attack": 346,
                "defense": 139,
                "sp_attack": 60,
                "sp_defense": 99,
                "crit": 10,
                "cdr": 20,
                "lifesteal": 0,
                "attack_speed": 18.1,
                "move_speed": 4100
            },
            {
                "level": 10,
                "hp": 4528,
                "attack": 382,
                "defense": 153,
                "sp_attack": 67,
                "sp_defense": 108,
                "crit": 10,
                "cdr": 20,
                "lifesteal": 0,
                "attack_speed": 19.46,
                "move_speed": 4100
            },
            {
                "level": 11,
                "hp": 4776,
                "attack": 423,
                "defense": 169,
                "sp_attack": 75,
                "sp_defense": 119,
                "crit": 10,
                "cdr": 20,
                "lifesteal": 0,
                "attack_speed": 21.02,
                "move_speed": 4250
            },
            {
                "level": 12,
                "hp": 5061,
                "attack": 470,
                "defense": 187,
                "sp_attack": 84,
                "sp_defense": 131,
                "crit": 10,
                "cdr": 20,
                "lifesteal": 0,
                "attack_speed": 22.82,
                "move_speed": 4250
            },
            {
                "level": 13,
                "hp": 5389,
                "attack": 525,
                "defense": 208,
                "sp_attack": 94,
                "sp_defense": 145,
                "crit": 10,
                "cdr": 20,
                "lifesteal": 0,
                "attack_speed": 24.89,
                "move_speed": 4250
            },
            {
                "level": 14,
                "hp": 5766,
                "attack": 588,
                "defense": 232,
                "sp_attack": 106,
                "sp_defense": 161,
                "crit": 10,
                "cdr": 20,
                "lifesteal": 0,
                "attack_speed": 27.27,
                "move_speed": 4250
            },
            {
                "level": 15,
                "hp": 6200,
                "attack": 660,
                "defense": 260,
                "sp_attack": 120,
                "sp_defense": 180,
                "crit": 10,
                "cdr": 20,
                "lifesteal": 0,
                "attack_speed": 30,
                "move_speed": 4250
            }
        ]
    }
]

export default pokemon


// WEBPACK FOOTER //
// ./src/utils/pokemon.js